import React, { useState, useEffect, useRef, use } from "react";
import { message, Modal, Form, Drawer, Row, Col, Collapse, Table, Button, DatePicker, Tag, Card, Input } from "antd";
import { ExclamationCircleOutlined, ArrowLeftOutlined, ClockCircleOutlined, ConsoleSqlOutlined } from "@ant-design/icons";
import { clock, timeStamp, timeValidator, currentDay, dateValidator } from "../../../utility/clock";
import { useHistory } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { v4 as uuidv4 } from "uuid";
import useDebounce from "../../../lib/hooks/useDebounce";
import DefaultProductImage from "../../../assets/images/default-product.webp";
import db from "../../../database";
import Axios from "axios";
import { debounce } from "lodash";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import moment from "moment";
import { SyncData } from "../Restaurant/Tables-Management/SyncData";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";

// OMS Orders Modal Imports //
import NewWhite from "../../../assets/images/pending.svg";
import PreparingWhite from "../../../assets/images/parkedOrder.svg";
import ReadyWhite from "../../../assets/images/completed.svg";
import CompletedWhite from "../../../assets/images/prepared.svg";
import New from "../../../assets/images/new.svg";
import Preparing from "../../../assets/images/preparing.svg";
import Ready from "../../../assets/images/ready.svg";
import Completed from "../../../assets/images/todayOrders.svg";
import _ from "lodash";
import CoreModals from "./coreModals";
import ReturnBill from "./returnBill";
import { CheckoutTotalManualDiscount } from "./PricingRules/CheckoutTotalManualDiscount";
import { CheckoutFlatDiscount } from "./PricingRules/CheckoutFlatDiscount";
import { CheckoutPercentageDiscount } from "./PricingRules/CheckoutPercentageDiscount";
import { createCustomer, getCustomer, updateCustomer } from "./customer";
import { pricingRuleController } from "./PricingRules/pricingRuleController";
import { barcodeScaner } from "./scaner";
import { ofcBarcodeScaner } from "./ofcscaner";
import { TotalBillDiscount } from "./PricingRules/totalBillDiscount";
import { TotalBillFreeProductDiscount } from "./PricingRules/totalBillFreeProductDiscount";
import { paymentProcess } from "./payment/paymentProcess";
import { addProductToCart } from "./cart";
import { useTranslation } from "react-i18next";
import { addAmount, completePayment } from "./payment/paymentController";
import { stock } from "./stock";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import PrintController from "../../../lib/printer/printController";
import upsertPOSLog from "../Retail/posLog";
import PointOfSuperMarketModals from "../Retail/SuperMarket/SuperMarketModal";
import NotFoundImg from "../../../assets/images/NotFoundImg.svg";
import CWPoleDisplay from "../../../lib/printer/CWPoleDisplay";
import { numberToWords } from "../../../utility/numberToWords";
import styles from "../../../constants/styles.json";
import {
  checkGiftCard,
  confirmPOSLayawayOrder1,
  discardCouponService,
  generateGiftVoucher,
  getNewOmsOrder,
  orderHistoryService,
  posConfigService,
  posOrderProcessor1,
  RFIDTag,
  salesHistoryService,
  updateOmsOrder,
  upsertGiftCardTransaction,
  upsertLoyaltyTransaction,
  upsertPOSLogService,
  verifyCouponsService,
  verifyGiftCardService,
  upsertSupplierPayment,
  getCustomerWallet,
  externalCoupon,
} from "../../../services";

import { WarningOutlined } from "@ant-design/icons";
import messages from "../../../errors/messages.en-IN.json";
import { getApplicablePrice } from "../../../utility/getPriceList";

function roundTo(value, decimals = 2) {
  return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);
}
// PointOfsaleCore Component Start
const PointOfsaleCore = (props) => {
  const { t } = useTranslation();
  let paymentModalMsg = null;
  const serverUrl = process.env.REACT_APP_serverUrl;
  const edcUrl = process.env.REACT_APP_edcUrl;
  const RenderComponent = props.component;
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  const precision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;
  const tokens = JSON.parse(localStorage.getItem("tokens"));
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
  const isPrintModeXML = tillData.tillAccess.cwrTill.hardwareController.printReceipt === "Y" ? true : false;
  const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  const tillDataPaymentMethods = tillData.tillAccess.csBunit.paymentMethodList;
  const [saleTypeProducts, setSaleTypeProducts] = useState([]);
  const [showProducts, setShowProducts] = useState(false);
  const [couponVerificationData, setCouponVerificationData] = useState(null);
  const [discountVerificationData, setDiscountVerifictionData] = useState(null);
  const [showCustomerWallet, setShowCustomerWallet] = useState(false);
  const [customersData, setCustomersData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const { RangePicker } = DatePicker;
  const dateRef = useRef(null);
  const authHeaders = getOAuthHeaders();
  const history = useHistory();
  const qs = require("querystring");
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const { dispatchEvent, discountApproval, dispatchItemSelection, dispatchQRCodeEvent, closeQRCodeModal, dispatchWeight } = useEventBus();
  // let setAuthTokens;
  const paymentModalInputRef = useRef();
  const customerSearchInputRef = useRef();
  const quantityInputRef = useRef();
  const metaDataRef = useRef([]);
  const redeemNumberRef = useRef(null);
  const loyaltyInputRef = useRef(null);
  const setDefaultImage = (e) => {
    e.target.src = DefaultProductImage;
  };
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const [tillLink, setTillLink] = useState(false);
  const [currencyType, setCurrencyType] = useState({
    currSymbolLeft: "₹",
    currSymbolRight: "",
    stdPrecision: 2,
  });

  // CLOCK BLOCK START
  const [displayClock, setDisplayClock] = useState(clock());
  useEffect(async () => {
    const timerId = setInterval(() => setDisplayClock(clock()), 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);
  // CLOCK BLOCK END

  // KeyBord changes start
  const [orderHistoryInput, setOrderHistoryInput] = useState("");
  const [keyboardType, setKeyboardType] = useState({
    product: false,
    parkedBill: false,
    salesHistoryDoc: false,
    salesHistoryCus: false,
    searchCus: false,
    productSearch: false,
    giftCardSearch: false,
    addCustomer: false,
  });
  const [layout, setLayout] = useState("default");
  const [loading, setLoading] = useState(false);
  const [inputName, setInputName] = useState("");
  const [inputFocused, setInputFocused] = useState(null);
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [filtersFlag, setFiltersFlag] = useState(false);
  const [filteredDate, setFilterdDate] = useState(null);
  const [searchHistoryInput, setSearchhistoryInput] = useState("");
  const keyboardProduct = useRef(null);
  const keyboardParkbill = useRef(null);
  const keyboardRef = useRef(null);
  const orderHistorySearchInputRef = useRef(null);
  const [notesValue, setNotesValue] = useState("");
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedProductForNotes, setSelectedProductForNotes] = useState(null);
  const [open, setOpen] = useState(false);
  const productSearchInputRef = useRef(null);
  const giftCardRef = useRef(null);
  const salesRepRef = useRef(null);
  const [layoutName, setLayoutName] = useState("default");
  const [searchTerm, setSearchTerm] = useState("");
  const [salesRepValue, setSalesRepValue] = useState("");
  const [productStock, setProductStock] = useState(false);
  const [currenciesData, setCurrenciesData] = useState(tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => b.value - a.value) || []);
  const [selectedDocumentType, setSelectedDocumentType] = useState("Invoice");
  const [showDocumentPopup, setShowDocumentPopup] = useState(false);
  const [currentInput, setCurrentInput] = useState(null);
  const [tableCards, setTableCards] = useState([]);
  const [inputValues, setInputValues] = useState({
    name: "",
    lastName: "",
    email: "",
    mobile: "",
    pincode: "",
    street: "",
    city: "",
    pincode1: "",
    taxID: "",
    cardNumber: "",
  });
  const [keyboardInputFields, setKeyboardInputFields] = useState({});

  const refs = {
    name: useRef(null),
    lastName: useRef(null),
    email: useRef(null),
    mobile: useRef(null),
    pincode: useRef(null),
    street: useRef(null),
    city: useRef(null),
    pincode1: useRef(null),
    taxID: useRef(null),
    cardNumber: useRef(null),
  };

  const keyboard = useRef(null);
  const [keyValue, setKeyValue] = useState("0");
  const [isCardPaymentLoading, setIsCardPaymentLoading] = useState(false);
  const [cardPaymnetError, setCardPaymnetError] = useState(false);
  const [cardPaymnetStatus, setCardPaymnetStatus] = useState(false);
  const [metaData, setMetaData] = useState([]);
  const [saleType, setSaleType] = useState("");
  const [showCustomMix, setShowCustomMix] = useState(false);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const [discountAdditionalInfo, setDiscountAdditionalInfo] = useState([]);
  const [showCouponApproval, setShowCouponApproval] = useState(false);
  const [couponApprovals, setCouponApprovals] = useState([]);
  const [totalBillDiscountData, setTotalBillDiscountData] = useState({});
  const [options, setOptions] = useState([]);
  const searchInputRef = useRef(null);
  const [activeInput, setActiveInput] = useState("search");
  const qtyInputRef = useRef(null);
  const [showCompleteSaleStock, setShowCompleteSaleStock] = useState(false);
  const [completeSaleStockData, setCompleteSaleStockData] = useState([]);
  const tillSession = JSON.parse(localStorage.getItem("tillSession"));
  const [syncLoad, setSyncLoad] = useState(false);
  const [selectedItemsModalOpen, setSelectedItemsModalOpen] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [cardPaymnetStatusPLB, setCardPaymnetStatusPLB] = useState(false);
  const [showCardPaymnteModal, setShowCardPaymnteModal] = useState(false);
  const [callCenterVisible, setCallCenterVisible] = useState(false);
  const [isCallCenterFlow, setIsCallCenterFlow] = useState(false);
  const [showCallCenterPage, setShowCallCenterPage] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [holdQueue, setHoldQueue] = useState(() => {
    const saved = localStorage.getItem("callCenterHoldQueue");
    return saved ? JSON.parse(saved) : [];
  });
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [totalBillCouponData, setTotalBillCouponData] = useState({});
  const couponInputRef = useRef(null);
  const [integratedPaymentStatus, setIntegratedPaymentStatus] = useState({
    status: "",
    message: "",
    txnId: "",
    paymentMode: "",
    amount: "",
  });
  const [isParkedBill, setIsparkedBill] = useState(false);

  // keep localStorage in sync
  useEffect(() => {
    localStorage.setItem("callCenterHoldQueue", JSON.stringify(holdQueue));
  }, [holdQueue]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      const activeElement = document.activeElement;
      const isInputFocused = activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || activeElement.isContentEditable);

      const isDrawerOrModalOpen = !!document.querySelector(".ant-drawer-open") || !!document.querySelector(".ant-modal-mask") || document.body.classList.contains("ant-modal-open");
      if (!isInputFocused && !isDrawerOrModalOpen && !event.ctrlKey && !event.altKey && !event.metaKey) {
        if (event.key.length === 1 || event.key === "Backspace" || event.key === "Delete" || event.key === "ArrowLeft" || event.key === "ArrowRight") {
          setActiveInput("search");
          if (searchInputRef?.current) {
            searchInputRef?.current?.focus();
          }
        }
      }
    };

    if (activeInput === "search") {
      if (searchInputRef?.current) {
        searchInputRef?.current?.focus();
      }
    } else if (activeInput === "weightPopup") {
      const productSearchInput = document.getElementById("sm-weight-popup-input");
      if (productSearchInput) {
        productSearchInput.focus();
      }
    } else if (activeInput === "qty") {
      qtyInputRef.current?.focus();
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [activeInput]);

  const clearReturnCartData = (record) => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Clear The Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: <div>Do you want to clear the bill?</div>,
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        onOk() {
          let setAuthTokens;
          setSelectedDocumentType("Invoice");
          let PaymentMethods = getFilteredPaymentMethods() || [];
          let payments =
            PaymentMethods.length > 5
              ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                  0,
                  tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
                )
              : PaymentMethods;

          setShowPayments(payments);
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const serverUrl = process.env.REACT_APP_serverUrl;
          if (cart?.couponInput?.length > 0) {
            const couponsData = [...cart.couponInput];

            // Function to discard a coupon
            const discardCoupon = async (coupon) => {
              try {
                const response = await discardCouponService(coupon.couponCode, coupon.referenceId);
              } catch (error) {
                console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
              }
            };

            // Iterate over each coupon code in couponsData and make the API call
            couponsData.forEach((coupon) => {
              discardCoupon(coupon);
            });
          }
          let data = [];
          if (giftCardData.length > 0) {
            let details = [];
            giftCardData.map((ele) => {
              details.push(`{
                  cardNo: ${ele.number ? `"${ele.number}"` : null}
                  type: "TO"
                  referenceNo: "${cart.referenceId}"
                  amount: ${ele.amount * -1}
                  cardPin: ${data.pin ? `"${data.pin}"` : null}
                      }`);
            });
            data = {
              query: `
                  mutation {
                    upsertGiftCardTransaction(giftCardTransactions: [${details}]) {
                      status
                      message
                    }
                  }`,
            };
          }
          upsertGiftCardTransaction(data);
          let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
            ? JSON.parse(localStorage.getItem("orderTimeDetails"))
            : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
          orderTimeDetails = {
            ...orderTimeDetails,
            paymentStartTime: "",
            orderStartTime: "", // Update orderStartTime to current time
          };
          localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
          deleteCart(true, true);
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
              setOpen(false);
            }, 500);
          }
        },
        onCancel() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
              setOpen(false);
            }, 300);
          }
          // selectParkedBill(record, "management");
        },
      });
    }
  };

  const tillId = tillData.tillAccess?.cwrTill?.cwrTillID;
  const userData = JSON.parse(localStorage.getItem("userData"));
  const documentTypes = [
    { type: "Invoice", isEnabled: true, isVisible: true },
    {
      type: "Advance",
      isVisible: posConfig?.requireCustomerforLayaway === "Y",
      // isVisible: true,
      isEnabled: JSON.parse(localStorage.getItem("saleTypeData"))?.cwrSaletype?.enableLayaway === "Y",
    },
    { type: "Quotation", isEnabled: posConfig?.enableQuotation === "Y", isVisible: posConfig?.enableQuotation === "Y" },
  ];

  useEffect(() => {
    if (productStock) {
      setProductStock(true);

      // Hide the modal after 1.5 seconds
      const timer = setTimeout(() => {
        setProductStock(false);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [productStock]);

  const handleKeyPress = (button) => {
    if (button === "{shift}" || button === "{caps}") setLayout("shift");
    if (button === "{default}" || button === "{small}") setLayout("default");
    if (button === "{numbers}") setLayout("numbers");
    if (button === "{number}") setLayout("number");
    if (button === "{done}") {
      switch (true) {
        case keyboardType.parkedBill:
          searchParkedBill();
          break;
        case keyboardType.salesHistoryDoc:
          searchOrderHistory();
        case keyboardType.salesHistoryCus:
          searchOrderHistory();
          break;
        case keyboardType.product:
          // getSearchedProducts();
          break;
        // Add more cases as needed
        default:
          // Handle the default case or do nothing
          break;
      }
    }
  };

  const handleKeyboardInput = (inputs) => {
    if (keyboardType.parkedBill === true) {
      setProductSearchInput("");
      localStorage.removeItem("productName");
      setParkedBillSearchInput(inputs.default);
    } else if (keyboardType.product === true) {
      if (inputs.default === "") {
        clearProductSearchResults();
      } else {
        setProductSearchInput(inputs.default);
      }
    } else if (keyboardType.salesHistoryDoc === true) {
      setOrderHistoryInput(inputs.default);
    } else if (keyboardType.salesHistoryCus === true) {
      setOrderHistoryInput(inputs.default);
    }
  };

  // KeyBord changes End

  // ORDER TYPE BLOCK START
  const [orderType, setOrderType] = useState();
  const [posSaleTypes, setPosSaleTypes] = useState([]);
  const [displaySetOrderType, setDisplayOrderType] = useState(false);
  const changeOrderType = (type) => {
    setDisplayOrderType(false);
    setOrderType(type);
  };

  useEffect(() => {
    const totalRecords = 12;
    let filledCurrencies = currenciesData;
    while (filledCurrencies.length < totalRecords) {
      filledCurrencies.push({ id: `placeholder-${filledCurrencies.length}`, value: 999999 });
    }
    setCurrenciesData(filledCurrencies?.sort((a, b) => b.value - a.value));
    db.posSaletypes.toArray().then((saleType) => {
      setPosSaleTypes([...saleType]);
      const saleIndex = saleType.findIndex((st) => st.cwrSaletype.isdefault === "Y");
      setOrderType(saleType[saleIndex]);
    });
  }, []);
  // ORDER TYPE BLOCK END

  // Cash Management Start
  const [cashAddInFlag, setCashAddInFlag] = useState(false);
  const [cashManagementForm] = Form.useForm();
  // const [cashIn, setCashOut] = useState(true);
  const [cashIn, setCashIn] = useState(true);
  const [cashOut, setCashOut] = useState(false);
  const [pettyCashIn, setPettyCashIn] = useState(false);
  const [pettyCashOut, setPettyCashOut] = useState(false);

  const [addCashFlag, setAddCashFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [giftCardFlag, setGiftCardFlag] = useState(false);
  const [isGiftCardFlag, setIsGiftCardFlag] = useState(false);
  const [isWalletFlag, setIswalletFlag] = useState(false);
  const [isCardPaymentFlag, setIsCardPaymentFlag] = useState(false);
  const [CardPaymentForm] = Form.useForm();
  const [showSaleType, setShowSaleType] = useState(() => (posConfig?.enableSaleType === "Y" ? true : false));
  const [isSaleTypeFlag, setIsSaleTypeFlag] = useState(false);
  const [selectedSaleType, setSelectedSaleType] = useState(() => {
    if (localStorage.getItem("saleTypeData") !== null) {
      const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData"));
      return saleTypeData?.cwrSaletype?.name;
    } else {
      return "";
    }
  });
  const [selectedSaleTypeData, setSelectedSaleTypeData] = useState(() => {
    if (localStorage.getItem("saleTypeData") !== null) {
      const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData"));
      return saleTypeData;
    } else {
      return "";
    }
  });
  const [splitCarts, setSplitCarts] = useState([]);
  const [customMixItems, setCustomMixItems] = useState([]);
  const [existingGroupItems, setExistingGroupItems] = useState(true);
  const [selectedCustomMix, setSelectedCustomMix] = useState([]);
  const [groupQty, setGroupQty] = useState(1);
  const [selectedUser, setSelectedUser] = useState();
  const [additionalInfoForm] = Form.useForm();
  const [discountAdditionalInfoForm] = Form.useForm();

  const handleCahInOut = async (data) => {
    let formData = cashManagementForm.getFieldsValue(true);
    formData.key = uuidv4().replace(/-/g, "").toUpperCase();
    formData.id = uuidv4().replace(/-/g, "").toUpperCase();
    formData.date = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    if (cashAddInFlag === true) {
      if (formData.type === "cashOut" || !formData.type) {
        formData.type = "cashOut";
      } else {
        formData.type = "pettyCashOut";
      }
    } else {
      if (formData.type === "cashIn" || !formData.type) {
        formData.type = "cashIn";
      } else {
        formData.type = "pettyCashIn";
      }
    }
    // formData.notes = data.note
    if (formData.type === "cashIn") {
      upsertPOSLog(formData, "CAI");
    } else if (formData.type === "cashOut") {
      upsertPOSLog(formData, "CAO");
    }
    setPettyCashIn(false);
    setCashOut(true);
    const pettyCashOut = [formData].filter((item) => item.type === "pettyCashOut");

    if (pettyCashOut.length > 0) {
      const buildRequestString = (data) => {
        const paymentLineString = data
          .map(
            (line) => `      {
            expCategoryId: "${line.expenseCategory}"
            description: "${(line.note || "").replace(/"/g, '\\"')}"
            amount: "${line.amount}"
          }`
          )
          .join(",\n");

        return `{
        bunitId: "${tillData.tillAccess.csBunit.csBunitId}"
        date: "${moment(new Date()).format("YYYY-MM-DD")}"
        description: null
        supplierId: null
        paymentLine: [
    ${paymentLineString}
        ]
      }`;
      };

      const newStringRequest = buildRequestString(pettyCashOut);

      upsertSupplierPayment(newStringRequest);
    }
    db.cashInCashOut.add(formData);
    cashManagementForm.resetFields();
    setAddCashFlag(false);

    let obj = { cashIn: 0, cashOut: 0, pettyCashIn: 0, pettyCashOut: 0 };
    let cashDetails = await db.cashInCashOut.toArray();

    cashDetails.map((item) => {
      if (item.type === "cashIn") {
        obj.cashIn += parseFloat(item.amount);
      } else if (item.type === "cashOut") {
        obj.cashOut += parseFloat(item.amount);
      }
      if (item.type === "pettyCashIn") {
        obj.pettyCashIn += parseFloat(item.amount);
      }
      if (item.type === "pettyCashOut") {
        obj.pettyCashOut += parseFloat(item.amount);
      }
    });
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    db.tillEvents
      .where("tillSessionId")
      .equals(tillSession.tillSessionId)
      .modify((tillEvent) => {
        tillEvent.cashInOutData = obj;
      });
    setCashIn(false);
    setCashOut(false);
    setPettyCashIn(false);
    setPettyCashOut(false); // reset the "Expenses" checkbox
    setAddCashFlag(false);
  };

  const onChangeCheckbox = (e) => {
    const eventId = e.target.id;
    const checkedValue = e.target.checked;
    let formData = cashManagementForm.getFieldsValue(true);
    if (cashAddInFlag) {
      if (eventId === "cashOut") {
        if (checkedValue === true) {
          setCashOut(checkedValue);
          setPettyCashOut(false);
          formData.type = "cashOut";
          cashManagementForm.setFieldsValue({ pettyCashOut: false });
        }
      }
      if (eventId === "pettyCashOut") {
        if (checkedValue === true) {
          formData.type = "pettyCashOut";
          setPettyCashOut(checkedValue);
          setCashOut(false);
          cashManagementForm.setFieldsValue({ cashOut: false });
        }
      }
    } else {
      if (eventId === "cashIn") {
        if (checkedValue === true) {
          formData.type = "cashIn";
          setCashIn(checkedValue);
          setPettyCashIn(false);
          cashManagementForm.setFieldsValue({ pettyCashIn: false });
        }
      }
      if (eventId === "pettyCashIn") {
        if (checkedValue === true) {
          formData.type = "pettyCashIn";
          setCashIn(false);
          setPettyCashIn(checkedValue);
          cashManagementForm.setFieldsValue({ cashIn: false });
        }
      }
    }
    cashManagementForm.setFieldsValue(formData);
  };

  // Cash Management End
  const [giftCardForm] = Form.useForm();
  const [giftCardItems, setGiftCardItems] = useState([]);
  const [giftCardType, setGiftCardType] = useState("giftCard");
  const [selectGiftCardItem, setSelectGiftCardItem] = useState({});
  const [validateGiftCard, setValidateGiftCard] = useState(false);
  const [giftCardData, setGiftCardData] = useState([]);
  const [giftCardBalance, setGiftCardBalance] = useState(0);
  const [validateGiftCardForm] = Form.useForm();
  const [realPrice, setRealPrice] = useState(0);
  const [firstInputValue, setFirstInputValue] = useState(false);

  const handleGiftCardDetails = async (data) => {
    try {
      const setAuthTokens = authHeaders?.access_token || "";
      const returnFlag = cart.isReturn === true || cart.isReturn === "Y" ? data.amount <= Math.abs(cart.total) : true;

      if (!returnFlag || data.amount <= 0) {
        message.error(`The ${giftCardType} ${messages.errors.gift_card.amount_exceeds_return}`);
        return;
      }

      const matchedGiftCardData = await findMatchedGiftCardData();
      if (!matchedGiftCardData) return;

      const refId = generateRefId();
      const giftCardResponse = await verifyGiftCard(data, matchedGiftCardData, refId, setAuthTokens);

      if (giftCardResponse?.status === "200") {
        processVerifiedGiftCard(data, matchedGiftCardData, refId, giftCardResponse);
      } else {
        handleGiftCardError(data, refId, matchedGiftCardData, giftCardResponse);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // Helper Functions

  const findMatchedGiftCardData = async () => {
    const giftCardData = await db.giftCardData.toArray();
    return giftCardData.find((giftcard) => giftcard.mProductId === selectGiftCardItem.mProductId);
  };

  const generateRefId = () => uuidv4().replace(/-/g, "").toUpperCase();

  const verifyGiftCard = async (data, matchedGiftCardData, refId, setAuthTokens) => {
    const query = {
      query: `
      mutation {
        verifyGiftCard(giftCards: [{
          cwrGiftcardTypeId: "${matchedGiftCardData?.cwrGiftcardTypeId}"
          cardNo: ${data.number ? `"${data.number}"` : null}
          referenceNo: "${refId}"
          b2cCustomerId: "${cart.customer?.cwrCustomerId || null}"
          cardPin: ${data.cardPin ? `"${data.cardPin}"` : null}
          currentBalance: ${parseFloat(data.amount)}
        }]) {
          status
          message
          cardNo
          expiryDate
        }
      }`,
    };

    const response = await verifyGiftCardService(query);
    if (response.data.data.verifyGiftCard.status !== "200") {
      message.error(response.data.data.verifyGiftCard.message);
    }
    return response.data.data.verifyGiftCard;
  };

  const processVerifiedGiftCard = (data, matchedGiftCardData, refId, giftCardResponse) => {
    setValidateGiftCard(false);
    setGiftCardBalance("0.00");

    const futureDate = moment().add(matchedGiftCardData.validity, "days");
    const updatedItem = {
      ...selectGiftCardItem,
      isGiftCard: true,
      realPrice: parseFloat(data.amount),
      total: parseFloat(data.amount),
      nettotal: parseFloat(data.amount),
      salePrice: parseFloat(data.amount),
      discAmount: 0,
      taxRate: 0,
      taxAmount: 0,
      unitPrice: parseFloat(data.amount),
      giftCardType: matchedGiftCardData.type,
      cardNo: matchedGiftCardData.type === "PHY" ? data.number : giftCardResponse.cardNo,
      expiryGiftCard: futureDate.format("DD-MM-YYYY"),
      grosslist: parseFloat(data.amount),
      grossstd: selectGiftCardItem.sunitprice,
      grossunit: parseFloat(data.amount),
      linegross: selectGiftCardItem.nettotal,
      linenet: parseFloat(data.amount),
      linetax: 0,
      listPrice: parseFloat(data.amount),
      netList: parseFloat(data.amount),
      netunit: parseFloat(data.amount),
    };

    const cardDetails = [
      ...giftCardData,
      {
        number: updatedItem.cardNo,
        amount: parseFloat(data.amount),
        refId,
      },
    ];
    setCart({ ...cart, giftCardData: cardDetails });
    localStorage.setItem("cartObj", JSON.stringify({ ...cart, giftCardData: cardDetails }));
    setGiftCardData(cardDetails);
    upsertPOSLog(cart, "GCI");
    addProduct(updatedItem, 1, false, 0, false);
  };

  const handleGiftCardError = (data, refId, matchedGiftCardData, response) => {
    Sentry.captureException(new Error("Verify gift card failed"), {
      extra: JSON.stringify({
        cwrGiftcardTypeId: matchedGiftCardData?.cwrGiftcardTypeId || null,
        cardNo: data.number ? `"${data.number}"` : null,
        referenceNo: refId,
        b2cCustomerId: cart.customer?.cwrCustomerId || null,
        cardPin: data.cardPin ? `"${data.cardPin}"` : null,
        currentBalance: data.amount || null,
        response,
      }),
    });
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const redeemGiftCard = async (data) => {
    setIsSubmitting(true);
    const uniqId = uuidv4().replace(/-/g, "").toUpperCase();
    let giftCardAmount = 0;
    let giftCardGroup = "";
    const setAuthTokens = authHeaders?.access_token ?? "";

    try {
      const query = {
        query: `
          query {
            checkGiftCardBalance(cardNo: "${data.number}", cardPin: ${data.pin ? `"${data.pin}"` : null}) {
              currentBalance
              cardGroup
              status
              message
            }
          }`,
      };

      const giftCardResponse = await checkGiftCard(query);

      const balanceData = giftCardResponse?.data?.data?.checkGiftCardBalance?.[0];
      if (balanceData?.status === "200") {
        giftCardAmount = balanceData.currentBalance ?? 0;
        giftCardGroup = giftCardResponse.data.data.checkGiftCardBalance[0].cardGroup;
      }
    } catch (err) {
      message.error(err);
      setIsSubmitting(false);
      return;
    }
    if (selectedPaymentMethod.name.toLowerCase() !== giftCardGroup.toLowerCase()) {
      message.error(`${giftCardGroup} redemption is not allowed through ${selectedPaymentMethod.name}`);
      setIsSubmitting(false);
      return;
    }
    if (cart?.total - cart?.paid >= data?.amount && data?.amount > 0) {
      try {
        const data1 = {
          query: `
            mutation {
              upsertGiftCardTransaction(giftCardTransactions: [{
                cardNo: "${data.number}"
                type: "RD"
                referenceNo: "${uniqId}"
                amount: ${parseFloat(data.amount)?.toFixed(precision)}
                cardPin: ${data.pin ? `"${data.pin}"` : null}
              }]) {
                status
                message
              }
            }`,
        };
        const upsertGiftCard = await upsertGiftCardTransaction(data1);

        const transactionData = upsertGiftCard?.data?.data?.upsertGiftCardTransaction;
        if (transactionData?.status === "200") {
          setGiftCardFlag(false);
          giftCardForm.resetFields();
          setGiftCardBalance(0);

          const cardDetails = [...(giftCardData ?? [])];
          const giftCardIndex = cardDetails.findIndex((item) => item.number === data.number);

          if (giftCardIndex >= 0) {
            cardDetails[giftCardIndex] = {
              ...cardDetails[giftCardIndex],
              number: data.number,
              amount: Math.min(data.amount, giftCardAmount + (cardDetails[giftCardIndex]?.amount ?? 0)),
              redemptionId: uniqId,
              pin: data.pin ?? null,
            };
          } else {
            cardDetails.push({
              number: data.number,
              amount: Math.min(data.amount, giftCardAmount),
              redemptionId: uniqId,
              pin: data.pin ?? null,
            });
          }
          // const filteredGiftCardNumbers = cardDetails.filter((card) => card.amount > 0).map((card) => card.number);
          const activeGiftCards = cardDetails.filter((card) => card.amount > 0);
          const latestRedemptionCards = cardDetails.filter((card) => card.redemptionId === uniqId && card.amount > 0);
          const combinedNumbers = [...new Set([...activeGiftCards.map((card) => card.number), ...latestRedemptionCards.map((card) => card.number)])];
          const updatedCart = { ...cart, giftCardData: cardDetails, giftCardNumbers: combinedNumbers };
          setCart(updatedCart);
          localStorage.setItem("cartObj", JSON.stringify(updatedCart));
          setGiftCardData(cardDetails);
          requestPayment(selectedPaymentMethod, Math.min(data.amount, giftCardAmount), null, null, null, updatedCart);
          upsertPOSLog(cart, "GCR");
          setIsSubmitting(false);
        } else {
          setIsSubmitting(false);
          message.error(transactionData?.message ?? `${messages.errors.gift_card.transaction_failed}`);
          Sentry.captureException(new Error("Gift card transaction failed"), {
            extra: {
              cardNo: data.number,
              type: "RD",
              referenceNo: uniqId,
              amount: data.amount,
              cardPin: data.pin ?? null,
              response: transactionData,
            },
          });
        }
      } catch (err) {
        setIsSubmitting(false);
        Sentry.captureException(err);
        message.error(err);
      }
    } else if (cart?.total - cart?.paid > data?.amount) {
      message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
      setIsSubmitting(false);
    } else {
      message.error(`${messages.errors.gift_card.amount_exceeds_balance}`);
      setIsSubmitting(false);
    }
  };

  const handleGiftCard = async (data) => {
    try {
      const formData = giftCardForm.getFieldsValue(true);
      const setAuthTokens = authHeaders?.access_token || "";

      if (!formData.number) {
        message.error(`${messages.errors.gift_card.number_required}`);
        return;
      }

      const giftCardResponse = await checkGiftCardBalance(formData, setAuthTokens);

      if (giftCardResponse?.status === "200") {
        setGiftCardBalance(giftCardResponse.currentBalance);
      } else {
        message.error(giftCardResponse?.message || `${messages.errors.gift_card.balance_fetch_failed}`);
      }
    } catch (error) {
      message.error(error.message || `${messages.errors.gift_card.processing_error}`);
    }
  };

  // Helper Function
  const checkGiftCardBalance = async (formData, setAuthTokens) => {
    const query = {
      query: `
      query {
        checkGiftCardBalance(
          cardNo: "${formData.number}",
          cardPin: ${formData.pin ? `"${formData.pin}"` : null}
        ) {
          currentBalance
          cardGroup
          status
          message
        }
      }`,
    };

    const response = await checkGiftCard(query);

    return response.data.data.checkGiftCardBalance[0];
  };

  const walletFunc = async () => {
    setIswalletFlag(true);
    await fetchWalletData(true);
  };

  // CUSTOMER  SEARCH AND SELECTION BLOCK START
  const [displayCustomerSearch, setDisplayCustomerSearch] = useState(false);
  const [displayUAECustomerSearch, setDisplayUAECustomerSearch] = useState(false);
  const [displayUAECustomer, setDisplayUAECustomer] = useState(false);
  const [customerSearchType, setCustomerSearchType] = useState(() => (posConfig?.defaultCustomerSearch === "Search Key" ? "searchKey" : "mobile"));
  const [customerSearchInput, setCustomerSearchInput] = useState("");
  const [customerSearchResults, setCustomerSearchResults] = useState();
  const [closeCustomerFlag, setCloseCustomerFlag] = useState(false);
  const [properties, setProperties] = useState("");
  const [kioskUI, setKioskUI] = useState(parseFloat(localStorage.getItem("kioskUI")) ? parseFloat(localStorage.getItem("kioskUI")) : 0);
  const [kioskLogin] = Form.useForm();
  const [layoutType, setLayoutType] = useState(parseFloat(localStorage.getItem("layoutType")) ? parseFloat(localStorage.getItem("layoutType")) : 0);
  const [addToBagProducts, setAddToBagProducts] = useState([]);
  const [addToBagFlag, setAddToBagFlag] = useState(false);

  useEffect(() => {
    const handleCustomEvent = (event) => {
      const dynamoDBValue = event.detail.newValue;
      if (event.detail.key === "kioskUI") {
        setKioskUI(dynamoDBValue ? dynamoDBValue : parseFloat(localStorage.getItem("kioskUI")) || 0);
      } else if (event.detail.key === "layoutType") {
        setLayoutType(dynamoDBValue ? dynamoDBValue : parseFloat(localStorage.getItem("layoutType")) || 0);
      }
    };

    db.products
      .filter((product) => product.isactive === true)
      .toArray()
      .then((productsFetched) => {
        let items = [];
        let bagItems = [];
        productsFetched.map(async (item) => {
          if (item.productSegment === "GC") {
            const giftCardData = await db.giftCardData.toArray();
            const matchingGiftCard = giftCardData.filter((giftcard) => giftcard.mProductId === item.mProductId);
            item.matchingGiftCard = matchingGiftCard;
            items.push(item);
          } else if (item.productSegment === "BG") {
            bagItems.push(item);
          }
        });
        setAddToBagProducts(bagItems);
        setGiftCardItems(items);
      });
    window.addEventListener("customStorageChange", handleCustomEvent);

    return () => {
      window.removeEventListener("customStorageChange", handleCustomEvent);
    };
  }, []);

  const debouncedCustomerSearch = useDebounce(customerSearchInput, 350);
  useEffect(() => {
    if (debouncedCustomerSearch !== "") {
      handleCustomerSearch(debouncedCustomerSearch);
    } else {
      setCustomerSearchResults([]);
    }
  }, [debouncedCustomerSearch]);

  const closeCustomerSearch = (obj) => {
    setDisplayCustomerSearch(false);
    setDisplayUAECustomerSearch(false);
    setCustomerSearchInput("");
    setCustomerSearchResults();
    setIsInputFocused(false);
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
    // const productSearchInput = document.getElementById("sm-product-search");
    // if (productSearchInput) {
    //   productSearchInput.focus();
    // }
  };
  const handleCustomerSearch = async () => {
    getCustomer(form, tillLayout, customerSearchInput, setKioskUI, setCustomerSearchResults, kioskLogin, tillData);
  };

  const [orderTimeDetails, setOrderTimeDetails] = useState({ orderStartTime: "", orderEndTime: "", paymentStartTime: "" });

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          let setAuthTokens;
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number ? ele.number : null,
            type: "RD",
            referenceNo: cart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin ? ele.pin : null,
          }));

          const upsertDetailsStrings = upsertDetails.map(
            (detail) => `{
            cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
            type: "${detail.type}",
            referenceNo: "${detail.referenceNo}",
            amount: ${detail.amount},
            cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
          }`
          );

          const data = {
            query: `
                mutation {
                  upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
                    status
                    message
                  }
                }`,
          };

          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({
                number: detail.cardNo,
                amount: detail.amount,
                redemptionId: uniqId,
                pin: detail.cardPin ? detail.cardPin : null,
              });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.name.toLowerCase() === "loyalty" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, cart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        // Filter out undefined results (where payment name matched)
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        localStorage.setItem("cartObj", JSON.stringify(cart));
        setCart(cart);
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      });
  };

  const fetchWalletData = async (flag) => {
    try {
      const wallets = await getCustomerWallet(cart?.customer?.cwrCustomerId);

      // Fallback customer data if no wallets are present
      const defaultCustomerData = {
        id: cart.customer.code || "",
        name: cart.customer.name || "",
        phone: cart.customer.mobileNo || "",
        email: cart.customer.email || null,
        currentBalance: 0,
        totalSpent: 0,
        transactions: [],
      };

      // Map wallet data if wallets exist, otherwise use default customer data
      const mappedData =
        wallets?.wallets?.length > 0
          ? wallets.wallets.map((wallet) => ({
              id: cart.customer.code || "",
              name: cart.customer.name || "",
              phone: cart.customer.mobileNo || "",
              email: cart.customer.email || null,
              currentBalance: wallet.balance_amt || 0,
              totalSpent: wallet.deposit_amt || 0,
              joinDate: wallet.created || new Date().toISOString().split("T")[0],
              lastTransaction: wallet.laxt_trxdate || new Date().toISOString().split("T")[0],
              transactions: (wallet.transactions || []).map((trx) => ({
                id: trx.cwr_wallet_trx_id,
                date: trx.created.split(" ")[0],
                time: new Date(trx.created).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }),
                type: trx.trx_type === "DP" ? "Credit" : "Debit",
                amount: Math.abs(trx.trx_value),
                description: trx.trx_type === "DP" ? "Wallet Top-up" : "Purchase Payment",
                reference: trx.cwr_wallet_trx_id,
                balance: wallet.balance_amt || 0,
              })),
            }))
          : [defaultCustomerData];

      setSelectedCustomer(mappedData);
      setCustomersData(mappedData);
      if (!flag) {
        setShowCustomerWallet(true); // Enable wallet display
      }
      setTillLink(false);
    } catch (error) {
      message.error(`${messages.errors.customer.wallet_load_failed}`);
    }
  };

  const selectCustomer = async (index) => {
    setCustomerFlag(false);
    let latestData = removeAllDiscounts(false, true);
    const truncateDecimal = (num, decimalPlaces) => {
      // Convert the number to a string
      let numStr = num.toString();

      // Find the position of the decimal point
      let decimalIndex = numStr.indexOf(".");

      // If there is no decimal point or if there are less decimal places than desired, return the number as is
      if (decimalIndex === -1 || numStr.length - decimalIndex - 1 <= decimalPlaces) {
        return num;
      }

      // Truncate the string to the desired number of decimal places
      numStr = numStr.slice(0, decimalIndex + decimalPlaces + 1);

      // Parse the truncated string back to a number
      return parseFloat(numStr);
    };

    let num = customerSearchResults[index]?.retlLoyaltyBalance || 0;
    let truncatedNum = truncateDecimal(num, 2);

    customerSearchResults[index].retlLoyaltyBalance = truncatedNum;
    const saleTypeData1 = JSON.parse(localStorage.getItem("saleTypeData") || "{}");
    const selectedPriceListId1 = customerSearchResults[index]?.sPriceListId ?? saleTypeData1?.customer?.sPriceListId;
    const cartObj = {
      ...latestData,
      customer: {
        ...customerSearchResults[index],
        sPriceListId: selectedPriceListId1,
      },
    };
    let updatedCart = cartObj;

    if (cartObj.items.length > 0) {
      await Promise.all(
        cartObj.items.map(async (ele) => {
          let addToCart = ele;
          let matchedPriceIndex = [];
          if (defaultCustomer?.cwrCustomerId !== updatedCart?.customer?.cwrCustomerId && addToCart?.priceList?.length > 0) {
            const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
            let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
            // matchedPriceIndex = addToCart?.priceList.filter((i) => i.sPricelistId === updatedCart.customer.sPriceListId);
            // if (matchedPriceIndex.length > 0) {
            //   addToCart.price = matchedPriceIndex[0].pricestd;
            //   addToCart.salePrice = matchedPriceIndex[0].pricestd;
            //   addToCart.realPrice = matchedPriceIndex[0].pricestd;
            //   addToCart.sunitprice = matchedPriceIndex[0].pricestd;
            // } else if (!updatedCart.customer.sPriceListId) {
            //   addToCart.price = addToCart?.originalPrice;
            //   addToCart.salePrice = addToCart?.originalPrice;
            //   addToCart.realPrice = addToCart?.originalPrice;
            //   addToCart.sunitprice = addToCart?.originalPrice;
            // }
            const selectedPrice = getApplicablePrice({
              priceList: addToCart.priceList,
              selectedUomId: addToCart.uomData[0]?.csUomId,
              sPriceListId: updatedCart.customer.sPriceListId,
            });

            if (selectedPrice) {
              addToCart.price = selectedPrice.pricestd;
              addToCart.salePrice = selectedPrice.pricestd;
              addToCart.realPrice = selectedPrice.pricestd;
              addToCart.sunitprice = selectedPrice.pricestd;
            } else if (!updatedCart.customer.sPriceListId) {
              addToCart.price = addToCart.originalPrice;
              addToCart.salePrice = addToCart.originalPrice;
              addToCart.realPrice = addToCart.originalPrice;
              addToCart.sunitprice = addToCart.originalPrice;
            }
            const addOnsPriceSum = _.sumBy(addToCart?.selectedAddons, "price");
            const mrp = (parseFloat(addToCart.salePrice) + addOnsPriceSum * addToCart.weight) * parseFloat(addToCart.weight);
            const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addToCart.taxRate / 100) : mrp * (addToCart.taxRate / 100);
            addToCart.taxAmount = tax;
            // addToCart.nettotal =
            //   taxIncludeFlag === "Y"
            //     ? mrp - parseFloat(parseFloat(addToCart.discount ? addToCart.discount : 0)?.toFixed(precision))
            //     : mrp - parseFloat(parseFloat(addToCart.discount ? addToCart.discount : 0) + tax)?.toFixed(precision);
            addToCart.nettotal = parseFloat(
              parseFloat(
                (taxIncludeFlag === "Y"
                  ? mrp - parseFloat((addToCart.discount || 0).toFixed(precision))
                  : mrp - parseFloat((addToCart.discount || 0).toFixed(precision)) + tax
                ).toFixed(precision)
              )
            );
          }

          updatedCart = await pricingRuleController(addToCart, cartObj, cartObj, setCart, cartObj, orderType);
          return updatedCart;
        })
      );
    } else {
      let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
        ? JSON.parse(localStorage.getItem("orderTimeDetails"))
        : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
      orderTimeDetails = {
        ...orderTimeDetails,
        orderStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
      };
      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
    }

    if (updatedCart?.couponInput?.length > 0) {
      let addToCart = cartObj.items[0];
      await Promise.all(
        updatedCart.couponInput.map(async (coupon) => {
          const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(coupon.mPricingruleId).toArray();
          if (matchingPricingRules[0].type !== "TD" && matchingPricingRules[0].type !== "TDF") {
            updatedCart = await pricingRuleController(
              addToCart,
              updatedCart,
              cart,
              setCart,
              cartRef,
              orderType,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          } else {
            updatedCart = await processBillDiscounts(
              matchingPricingRules[0],
              updatedCart,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          }
        })
      );
    }
    if (cartObj.totalDiscountFlag) {
      await openPaymentModalByCustomer(updatedCart);
    }
    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    if (updatedCart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.lineLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        let productSelected = updatedCart.items.filter((cartItem) => cartItem.productId === item.productId);
        if (pricingRule?.type === "FD") {
          try {
            const newCart = await CheckoutFlatDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying flat discount:", err);
          }
        } else if (pricingRule?.type === "PD") {
          try {
            const newCart = await CheckoutPercentageDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying percentage discount:", err);
          }
        }
      });
    }

    if (updatedCart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.totalLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        if (pricingRule?.type === "TD") {
          try {
            const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying Total discount:", err);
          }
        }
      });
    }

    const itemSummery = {
      decimalItems: { totalQty: 0, totalAmount: 0 },
      nonDecimalItems: { totalQty: 0, totalAmount: 0 },
      itemsQty: 0,
      items: 0,
    };

    // Group items by tax rate
    const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

    const groupedItems = allItems.reduce((acc, item) => {
      const key = item.tax?.rate ?? item.taxRate ?? "0";
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    // Calculate tax totals with SGST and CGST
    const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
      const totalTaxAmount = items.reduce((sum, item) => {
        const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
        return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
      }, 0);

      const totalNetTotal = items.reduce((sum, item) => {
        const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
        return sum + parseFloat(netValue);
      }, 0);

      // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
      const totalSgstAmount = items.reduce((sum, item) => {
        const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
      }, 0);

      const totalCgstAmount = items.reduce((sum, item) => {
        const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
      }, 0);

      return {
        taxRate,
        totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
        totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
        totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
        totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
        totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
      };
    });

    updatedCart.items = updatedCart.items.map((item, i) => {
      const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
      const nettotalFixed = parseFloat(parseFloat(item?.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item?.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item?.discount)?.toFixed(precision)) : 0;

      // Update totals
      updatedTotalPrice += nettotalFixed;
      updatedTotalItemsQty += item.weight;
      updatedTotalTax += taxAmountFixed;
      updatedTotalDiscounts += discountFixed;

      item.discount = discountFixed;
      item.key = i;

      if (!item.isGiftCard) {
        const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;

        const lineTax = item.listPrice * (1 + (item.taxRate || 0) / 100);
        const stdTax = item.sunitprice * (1 + (item.taxRate || 0) / 100);
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : stdTax;
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

        Object.assign(item, {
          linetax: nettotalFixed ? taxAmountFixed : 0,
          linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
          linegross: nettotalFixed || 0,
          linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
          netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          listprice: nettotalFixed ? item.listPrice : 0,
          grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
          grossstd: nettotalFixed ? parseFloat(parseFloat(grossStd)?.toFixed(precision)) : 0,
          grosslist: nettotalFixed ? roundTo(gross_list, precision) : 0,
          netList: nettotalFixed ? netList : 0,
          unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          taxAmount: nettotalFixed ? taxAmountFixed : 0,
        });
      }

      // Update summary
      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => {
          const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemSummery.itemsQty += child.weight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += child.weight;
          itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
        });
      } else {
        const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemSummery.itemsQty += item.weight;
        itemSummery.items += 1;
        itemSummery[summaryKey].totalQty += item.weight;
        itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
    // const updatedTotalStd = updatedCart.items.reduce((sum, item) => sum + item.linestd, 0);
    const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
    const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData") || "{}");
    const selectedPriceListId = customerSearchResults[index]?.sPriceListId ?? saleTypeData?.customer?.sPriceListId;
    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      total: parseFloat(updatedTotalPrice.toFixed(precision)),
      tax: updatedTotalTax,
      customer: {
        ...customerSearchResults[index],
        sPriceListId: selectedPriceListId,
      },
      totalStd: updatedTotalStd,
      itemsSummery: itemSummery,
      groupedItemsByTaxRate: groupedItemsByTaxRate,
    };
    localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
    setCart({ ...finalCartObj });
    if (isCallCenterFlow && tillLayout === 2) {
      history.push("/call-center");
      setCallCenterVisible(true);
      setShowCallCenterPage(false);
      setDisplayAddNewCustomer(false);
      setDisplayCustomerSearch(false);
      setCustomerSearchInput("");
      return;
    }
    closeCustomerSearch(finalCartObj, true);
    setShowPaymentMethods(false);
    setIsInputFocused(false);
    upsertPOSLog(finalCartObj, "ACT");
    setActiveInput("search");
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
    // setOpen(false);
  };
  // CUSTOMER  SEARCH AND SELECTION BLOCK END

  // ADD NEW CUSTOMER BLOCK START
  const [form] = Form.useForm();
  const [UAECustomerForm] = Form.useForm();
  const [displayAddNewCustomer, setDisplayAddNewCustomer] = useState(false);

  const showAddNewCustomerFields = async () => {
    setDisplayCustomerSearch(false);

    const searchResult = customerSearchInput || keyboardInputFields?.search;
    let customerSearchType = "name";

    if (/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/.test(searchResult)) {
      customerSearchType = "email";
    } else if (/^\d+$/.test(searchResult)) {
      customerSearchType = "mobile";
    }

    const defaultAddress = {
      country: tillData.tillAccess.csBunit.customerAddress?.csCountry?.name,
      state: tillData.tillAccess.csBunit.customerAddress?.csRegion?.name,
    };

    const fieldValues = {
      mobile: customerSearchType === "mobile" ? searchResult : "",
      name: customerSearchType === "name" ? searchResult : "",
      email: customerSearchType === "email" ? searchResult : "",
      type: "addCustomerForm",
      ...defaultAddress,
    };

    setKeyboardInputFields(fieldValues);
    form.setFieldsValue(fieldValues);

    const loyaltyData = await db.loyalityData.toArray();
    const defaultLoyalty = loyaltyData.find((item) => item.isDefault === "Y");

    if (defaultLoyalty) {
      form.setFieldsValue({ program: defaultLoyalty.loyaltylevelId });
    }

    setDisplayAddNewCustomer(true);
  };

  const showAddNewUAECustomerFields = async () => {
    setDisplayUAECustomerSearch(false);

    const customerSearchType = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/.test(customerSearchInput)
      ? "email"
      : /^\d+$/.test(customerSearchInput)
        ? "mobile"
        : "name";

    const defaultAddress = {
      country: tillData.tillAccess.csBunit.customerAddress?.csCountry?.name,
      state: tillData.tillAccess.csBunit.customerAddress?.csRegion?.name,
    };

    const fieldValues = {
      mobile: customerSearchType === "mobile" ? customerSearchInput : "",
      name: customerSearchType === "name" ? customerSearchInput : "",
      email: customerSearchType === "email" ? customerSearchInput : "",
      type: "UAECustomerForm",
      ...defaultAddress,
    };
    setKeyboardInputFields(fieldValues);
    UAECustomerForm.setFieldsValue(fieldValues);

    const loyaltyData = await db.loyalityData.toArray();
    const defaultLoyalty = loyaltyData.find((item) => item.isDefault === "Y");

    if (defaultLoyalty) {
      form.setFieldsValue({ program: defaultLoyalty.loyaltylevelId });
    }

    setDisplayUAECustomer(true);
  };

  const addNewCustomer = async (data) => {
    if (navigator.onLine) {
      createCustomer(
        data,
        cart,
        setCart,
        form,
        tillLayout,
        closeCustomerSearch,
        tillData,
        posLogActivity,
        setKioskUI,
        setDisplayAddNewCustomer,
        UAECustomerForm,
        setTillLink,
        setCustomerLoading,
        setDisplayUAECustomer,
        isCallCenterFlow,
        setCallCenterVisible,
        setIsCallCenterFlow,
        history
      );
    } else {
      errorMessage("Sync Failed", "Please check your network connection and try again");
    }
  };
  // ADD NEW CUSTOMER BLOCK END

  // EDIT CUSTOMER BLOCK END
  const [displayEditOldCustomer, setDisplayEditOldCustomer] = useState(false);
  const [selectedEditOldCustomer, setSelectedEditOldCustomer] = useState();

  const showEditOldCustomerFields = async (customer) => {
    setDisplayCustomerSearch(false);
    setSelectedEditOldCustomer(customer);
    if (!customer) {
      console.error("Customer data not available");
      return;
    }

    const fieldValues = {
      editName: customer.name || "",
      editMobile: customer.mobileNo || "",
      editEmail: customer.email || "",
      editPincode: customer.pincode || "",
      name: customer.name || "",
      mobile: customer.mobileNo || "",
      birthday: customer.birthday ? moment(customer.birthday) : null,
      anniversaryDate: customer.anniversaryDate ? moment(customer.anniversaryDate) : null,
      city: customer.customerAddress?.line2 || "",
      street: customer.customerAddress?.line1 || "",
      gender: customer.gender || "",
      lastName: customer.lastName || "",
      taxID: customer.taxId || "",
      pincode: customer.pincode || "",
      country: customer.customerAddress?.country || tillData.tillAccess.csBunit.customerAddress?.csCountry?.name || "",
      state: customer.customerAddress?.region || tillData.tillAccess.csBunit.customerAddress?.csRegion?.name || "",
      type: "editCustomerForm",
    };

    form.setFieldsValue(fieldValues);
    setKeyboardInputFields(fieldValues);

    try {
      let loyaltyData = await db.loyalityData.toArray();
      loyaltyData.forEach((item) => {
        if (item.isDefault === "Y") {
          form.setFieldsValue({
            program: item.loyaltylevelId || "", // Handle missing loyalty level
          });
        }
      });
    } catch (error) {
      console.error("Error fetching loyalty data:", error);
    }

    setDisplayEditOldCustomer(true);
  };

  const editOldCustomer = async (data) => {
    updateCustomer(
      data,
      cart,
      setCart,
      form,
      closeCustomerSearch,
      selectedEditOldCustomer,
      setSelectedEditOldCustomer,
      setDisplayEditOldCustomer,
      tillData,
      cart?.customer,
      UAECustomerForm,
      isCallCenterFlow,
      setCallCenterVisible,
      setIsCallCenterFlow,
      history,
      tillLayout
    );
  };
  // EDIT CUSTOMER BLOCK END

  //// CENTER BUTTON BLOCK START /////

  const [isQtyUpdate, setIsQtyUpdate] = useState(false);
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [selectedProductInCart, setSelectedProductInCart] = useState({});
  const [selectedProductQty, setSelectProductQty] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isInputFocused, setIsInputFocused] = useState(false);

  const selectProductInCart = (record, e) => {
    if (record.productId === selectedProductInCart.productId && e !== "1") {
      // setSelectedRowKeys([]);
      // setSelectedProductInCart({});
    } else {
      record.weight = parseFloat(parseFloat(record.weight)?.toFixed(record?.isQtyDesimal));
      setSelectedRowKeys([record.key]);
      setSelectedProductInCart(record);
    }
  };

  const enterTotalQty = async (type) => {
    // stopCallingGetWeight();
    if (cart.payments.length > 0) {
      if (paymentModalMsg) {
        paymentModalMsg();
        paymentModalMsg = null;
      }

      paymentModalMsg = Modal.confirm({
        title: "Payment is in progress. You cannot modify cart items once payment has started. Please complete or cancel this payment to proceed",
        icon: null,
        okText: "Ok",
        cancelButtonProps: { style: { display: "none" } }, // hides the Cancel button
        autoFocusButton: null,
        onOk() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
        },
      });
    } else {
      setDisplayManualQtyWeightInput(false);
      if (CWHardwareController) {
        CWPoleDisplay(selectedProductInCart, "Quantity update");
      } else {
        PoleDisplay(selectedProductInCart, "Quantity update");
      }
      if (cart.items.length > 0 && selectedProductInCart.weight > 0 && !selectedProductInCart.isReturn) {
        let totalQtyFlag = true;
        setSelectedProductInCart({});
        let product = {};
        const addedToCart = cart.items;

        // Use Promise.all to wait for all async operations to complete
        // await Promise.all(
        //   addedToCart.map(async (item) => {
        //     if (item.value === selectedProductInCart.value && item.lineId === selectedProductInCart.lineId) {
        //       product = item;
        //     }
        //   })
        // );

        if (selectedProductInCart.groupedItems) {
          const parentItem = addedToCart.find((item) => item.children?.some((child) => child.childrenId === selectedProductInCart.childrenId));
          if (parentItem) {
            await Promise.all(
              parentItem.children.map(async (childItem) => {
                if (childItem.childrenId === selectedProductInCart.childrenId && childItem.lineId === selectedProductInCart.lineId) {
                  product = childItem;
                }
              })
            );
          }
        } else {
          // Case: Handle normal items
          await Promise.all(
            addedToCart.map(async (item) => {
              if (item.value === selectedProductInCart.value && item.lineId === selectedProductInCart.lineId) {
                product = item;
              }
            })
          );
        }

        delete product.expiryId;
        setIsInputFocused(false);
        if (type === "weight") {
          addProduct(selectedProductInCart, selectedProductInCart.weight, totalQtyFlag, 0, false);
        } else {
          addProduct(product, selectedProductInCart.weight, totalQtyFlag, 0, false);
        }

        const amountInput = document.getElementById("sm-amount-input");
        if (amountInput) {
          amountInput?.focus();
          amountInput?.blur();
        }
        setTimeout(() => {
          if (searchInputRef?.current) {
            searchInputRef?.current?.focus();
          }
        }, 100);
      }
    }
  };

  const enterRealPrice = async (type) => {
    // stopCallingGetWeight();
    setDisplayManualQtyWeightInput(false);
    if (CWHardwareController) {
      CWPoleDisplay(selectedProductInCart, "Quantity update");
    } else {
      PoleDisplay(selectedProductInCart, "Quantity update");
    }
    if (cart.items.length > 0 && selectedProductInCart.weight > 0 && !selectedProductInCart.isReturn) {
      let totalQtyFlag = true;
      setSelectedProductInCart({});
      let product = {};
      const addedToCart = cart.items;

      // Use Promise.all to wait for all async operations to complete
      await Promise.all(
        addedToCart.map(async (item, index) => {
          if (item.value === selectedProductInCart.value && item.lineId === selectedProductInCart.lineId) {
            // product = item;
            product = { ...item, realPrice: Number(realPrice) };
            addedToCart[index] = { ...item, realPrice: Number(realPrice), salePrice: Number(realPrice), originalPrice: Number(realPrice), sunitprice: Number(realPrice) };
            setSelectedProductInCart(addedToCart[index]);
            // setSelectedProductInCart(product);
          }
        })
      );
      const updatedCart = {
        ...cart,
        items: addedToCart,
      };

      setCart(updatedCart);
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));

      delete product.expiryId;
      setIsInputFocused(false);
      if (type === "weight") {
        addProduct(selectedProductInCart, selectedProductInCart.weight, totalQtyFlag, 0, false);
      } else {
        addProduct(product, selectedProductInCart.weight, totalQtyFlag, 0, false);
      }

      const amountInput = document.getElementById("sm-amount-input");
      if (amountInput) {
        amountInput?.focus();
        amountInput?.blur();
      }
    }
  };
  const onChangeTotalQuantity = async (e) => {
    if (!selectedProductInCart.isReturn && Object.keys(selectedProductInCart).length > 0) {
      delete selectedProductInCart.expiryId;
      setSelectedProductInCart({ ...selectedProductInCart, weight: selectedProductInCart.isDecimalQty === true ? e : e.replaceAll(".", "") });
    }
  };

  const handleTotalQty = async (value) => {
    // if (isInputFocused === false) {
    //   if (productSearchInput === "" && value === "x") {
    //     setProductSearchInput("");
    //   } else if (value === "x") {
    //     setProductSearchInput(`${productSearchI nput.toString().substring(0, productSearchInput.toString().length - 1)}`);
    //   } else {
    //     setProductSearchInput(`${productSearchInput ? productSearchInput : ""}${value}`);
    //   }
    // } else {
    if (Object.keys(selectedProductInCart).length > 0 && !selectedProductInCart.isReturn) {
      if (selectedProductQty === "" && value === "x") {
        setSelectedProductInCart({ ...selectedProductInCart, weight: 0 });
      } else if (value === "x") {
        setSelectedProductInCart({
          ...selectedProductInCart,
          weight: `${selectedProductInCart.weight.toString().substring(0, selectedProductInCart.weight.toString().length - 1)}`,
        });
      } else if (value === "clear") {
        setSelectedProductInCart({ ...selectedProductInCart, weight: 0 });
      } else {
        if (qtyNumberFlag === 0) {
          setQtyNumberFlag(1);
          setSelectedProductInCart({ ...selectedProductInCart, weight: value });
        } else {
          setSelectedProductInCart({
            ...selectedProductInCart,
            weight: selectedProductInCart.isDecimalQty === true ? `${selectedProductInCart.weight}${value}` : `${selectedProductInCart.weight}${value}`.replaceAll(".", ""),
          });
        }
      }
    }
    const amountInput = document.getElementById("sm-amount-input");
    if (amountInput) {
      amountInput?.focus();
    }
    // }
  };

  const handleRealPrice = (value) => {
    let updatedPrice = realPrice;

    if (value === "x") {
      updatedPrice = realPrice.slice(0, -1);
    } else if (value === "clear") {
      updatedPrice = "";
    } else if (value === ".") {
      if (!realPrice.includes(".")) {
        updatedPrice += ".";
      }
    } else {
      if (firstInputValue) {
        updatedPrice = value;
        setFirstInputValue(false);
      } else {
        updatedPrice += value;
      }
    }

    setRealPrice(updatedPrice);
  };

  const selectProduct = (record) => {
    setSelectedKeys([record.key]);
    // setSelectedProduct(record);
  };

  const selectSalseProduct = (record) => {
    setSelectedKeys([record.sOrderID]);
    // setSelectedProduct(record);
  };

  const deleteProduct = async (addToCart) => {
    try {
      clearSelectedProductInCart();

      if (cart.isRetrived === "Y" && cart.items.length === 1) {
        message.warning(`${messages.errors.cart.cannot_delete_parked_item}`);
        return;
      } else if (cart.isRetrived === "Y" && cart.items.length > 1 && addToCart?.type !== "S" && addToCart?.productSegment !== "" && addToCart?.productSegment !== "AD") {
        message.warning(`${messages.errors.cart.cannot_delete_parked_item}`);
        return;
      } else if (cart.payments.length > 0) {
        message.warning(`${messages.errors.cart.delete_payment_first}`);
        return;
      } else if (addToCart.isReturn) return;
      const deleteProductInCart = true;
      await addProduct(addToCart, -addToCart.weight, false, 0, deleteProductInCart);
      if (giftCardData?.length > 0) {
        let authToken = authHeaders?.access_token || "";
        const { referenceId } = cart;
        const giftCardDetails = giftCardData.map(
          (ele) => `{
          cardNo: ${ele.number ? `"${ele.number}"` : null},
          type: "RD",
          referenceNo: "${referenceId}",
          amount: ${ele.amount * -1},
          cardPin: ${ele.pin ? `"${ele.pin}"` : null}
        }`
        );
        const query = `
          mutation {
            upsertGiftCardTransaction(giftCardTransactions: [${giftCardDetails.join(",")}]) {
              status
              message
            }
          }`;

        await upsertGiftCardTransaction(query);

        // const paidAmount = giftCardData.reduce((sum, ele) => sum + ele.amount, 0);
        // const updatedPayments = cart.payments.filter((payment) => payment.name.toLowerCase() !== "gift card");

        // cart.payments = updatedPayments;
        // cart.giftCardData = [];
        // cart.total -= paidAmount;

        setCart((prevCart) => {
          const paidAmount = giftCardData.reduce((sum, ele) => sum + ele.amount, 0);
          const updatedPayments = prevCart.payments.filter((payment) => payment.name.toLowerCase() !== "gift card");

          return {
            ...prevCart,
            payments: updatedPayments,
            giftCardData: [],
            total: prevCart.total - paidAmount,
          };
        });
        setGiftCardData([]);
        // setCart(cart);
      }

      const posConfig = JSON.parse(localStorage.getItem("posConfig")) || {};
      if (posConfig?.DLN === "Y") {
        posLogActivity(addToCart, "DLN");
      }
    } catch (error) {
      message.error(error.message || `${messages.errors.cart.error_deleting_product}`);
    }
  };

  const decreaseProductQty = (addToCart) => {
    if (cart.payments.length > 0) {
      if (paymentModalMsg) {
        paymentModalMsg();
        paymentModalMsg = null;
      }

      paymentModalMsg = Modal.confirm({
        title: "Payment is in progress. You cannot modify cart items once payment has started. Please complete or cancel this payment to proceed",
        icon: null,
        okText: "Ok",
        cancelButtonProps: { style: { display: "none" } }, // hides the Cancel button
        autoFocusButton: null,
        onOk() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
        },
      });
    } else {
      if (!addToCart.isReturn) {
        if (!addToCart.isManualQty) {
          if (addToCart.weight - 1 !== 0) {
            delete addToCart.expiryId;
          }
          const deleteQty = addToCart.weight - 1;
          if (cart.isRetrived === "Y" && cart.items.length === 1 && deleteQty <= 0) {
            message.warning(`${messages.errors.cart.cannot_delete_parked_item}`);
            return;
          }
          addProduct(addToCart, -1, false, 0, false, true);
          if (JSON.parse(localStorage.getItem("posConfig"))?.RQT === "Y") {
            posLogActivity(addToCart, "RQT");
          }
          const amountInput = document.getElementById("sm-amount-input");
          if (amountInput) {
            amountInput?.focus();
            amountInput?.blur();
          }
        }
      }
    }
  };

  // const increaseProductQty = (addToCart) => {
  //   if (!addToCart.isReturn) {
  //     if (!addToCart.isManualQty) {
  //       delete addToCart.expiryId;
  //       addProduct(addToCart, 1);
  //       const amountInput = document.getElementById("sm-amount-input");
  //       if (amountInput) {
  //         amountInput?.focus();
  //         amountInput?.blur();
  //       }
  //     }
  //   }
  // };

  const increaseProductQty = async (addToCart) => {
    if (cart.payments.length > 0) {
      if (paymentModalMsg) {
        paymentModalMsg();
        paymentModalMsg = null;
      }

      paymentModalMsg = Modal.confirm({
        title: "Payment is in progress. You cannot modify cart items once payment has started. Please complete or cancel this payment to proceed",
        icon: null,
        okText: "Ok",
        cancelButtonProps: { style: { display: "none" } }, // hides the Cancel button
        autoFocusButton: null,
        onOk() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
        },
      });
    } else {
      if (!addToCart.isReturn) {
        if (!addToCart.isManualQty) {
          delete addToCart.expiryId;
          addProduct(addToCart, 1, false, 0, false, true);
          const amountInput = document.getElementById("sm-amount-input");
          if (amountInput) {
            amountInput?.focus();
            amountInput?.blur();
          }
        }
      }
    }
  };

  const deleteReceipt = (param) => {
    let cartObj = {
      items: [],
      couponInput: [],
      advancePayment: 0,
      total: 0,
      tax: 0,
      discount: 0,
      paid: 0,
      change: 0,
      totalQty: 0,
      roundOff: 0,
      payments: [],
      redemptionPoints: 0,
      accumulationPoints: 0,
      creditAmount: 0,
      docType: "Invoice",
      sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
      referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
      giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      customer: selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : defaultCustomer,
      salesRepId: null,
      cardPaymentData: {},
      documentno:
        cart?.parked === "Y"
          ? `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`
          : param === "layAwayParked" || param
            ? `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`
            : `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 2}`,
      userName: userData.user,
      tillName: tillValue?.name,
      subTotal: 0,
      itemsSummery: {},
      amountInWords: "",
      groupedItemsByTaxRate: {},
      serviceCharge: 0,
      tip: 0,
      deiveryCharge: 0,
      packingCharge: 0,
      others: 0,
    };
    setCart(cartObj);
    localStorage.setItem("cartObj", JSON.stringify(cartObj));
    setSelectedRowKeys([]);
    setSelectedProductInCart({});
    setAmount("");
    setSelectedPaymentMethod("");
  };

  const deleteCart = (status = false, type) => {
    if (status === true) {
      if (JSON.parse(localStorage.getItem("posConfig"))?.DOR === "Y") {
        upsertPOSLog(cart, "DOR");
      }
    }
    deleteReceipt(type);
    /* if (parkedList.length > 0) {
        selectParkedBill(parkedList[0]);
      } */
  };

  // ORDER HISTORY BLOCK START
  const [displayOrderHistory, setDisplayOrderHistory] = useState(false);
  const [orderHistoryDetails, setOrderHistoryDetails] = useState([]);
  const [ordersCopy, setOrdersCopy] = useState([]);
  const [selectDate, setSelectDate] = useState("");
  const [salesHistoryType, setSalesHistoryType] = useState([]);
  const [startRowData, setStartRowData] = useState({ startRow: "0", endRow: "10" });

  const [orderHistorySearchType, setOrderHistorySearchType] = useState("orderDocumentNo");
  const changeOrderHistorySearchType = (value, e) => {
    setOrderHistorySearchType(value);
    setSelectDate(e);
  };

  const showOrderHistory = () => {
    db.orders
      .orderBy("orderTime")
      .limit(20)
      .reverse()
      .toArray()
      .then((data) => {
        setDisplayOrderHistory(true);
      });
  };

  const [selectedOrderHistoryLine, setSelectedOrderHistoryLine] = useState("");
  const showOrderHistoryLine = (orderID) => {
    if (selectedOrderHistoryLine === orderID) {
      setSelectedOrderHistoryLine("");
    } else {
      setSelectedOrderHistoryLine(orderID);
    }
  };

  // useEffect(() => {
  //   localStorage.setItem("dataLength", orderHistoryDetails.length);
  // }, [orderHistoryDetails]);

  const getSalesHistoryData = async (order_id) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    setLoading(true);
    try {
      const data = {
        query: `query {salesHistoryDetails(
                    orderId: "${order_id}"
                  ) {
                    sOrderID
                    created
                    createdby
                    updated
                    updatedby
                    deliveryDate
                    documentno
                    dateordered
                    cwrProductQty
                    orderTime
                    taxamt
                    grosstotal
                    discAmount
                    layAway
                    isReturn
                    paid
                    csUser {
                      user
                    }
                    csBUnit {
                      csBunitId
                      name
                    }
                    csbUnitLocation {
                      fulladdress
                    }
                    cwrB2cCustomer {
                      cwrCustomerId
                      sPriceListId
                      code
                      name
                      mobileNo
                      pincode
                      email
                      retlLoyaltyBalance
                      iscredit
                      loyaltyLevelId
                      creditBalance
                      loyaltyLevel {
                       cwrLoyaltyLevelId
                       name
                      }
                      cwrWallet {
                        wallet_Id
                        balance_Amt
                      }
                      sCustomer {
                        sCustomerID
                        customerCategory {
                          sCustomerCateforyId
                          value
                          name
                          description
                        }
                      }
                    }
                    saleType {
                      cwrSaletypeId
                      name
                      value
                    }
                    cwrTill {
                      cwrTillID
                      till
                    }
                    tablename
                    fboRder {
                      guests
                    }
                    saLesRep {
                      waitername
                    }
                    finReceiptPlan {
                      finReceiptPlanDetails {
                        amount
                        transactionId
                        cardType
                        cardNo
                        transactionTime
                        authorizationCode
                        cwrPaymentmethod {
                          cWRPaymentMethodID
                          finFinancialAccountId
                          finPaymentmethodId
                          integratedPayment
                          isloyalty
                          paymentProvider
                        }
                      }
                    }
                    line {
                      sOrderlineID
                      sOrderId
                      line
                      description
                      qty
                      deliveryDate
                      netlist
                      netunit
                      created
                      linetax
                      unittax
                      unitprice
                      linenet
                      linegross
                      grosslist
                      grossstd
                      returnline
                      returnQty
                      discount
                      mBatchId
                      product {
                        mProductId
                        name
                        value
                        upc
                        hsncode
                        imageurl
                        isManualQty
                        shortDescription
                        returnable
                        returnDays
                        productSegment
                      }
                      uom {
                        csUomId
                        name
                      }
                      tax {
                        csTaxID
                        name
                        rate
                      }
                      pricingRule {
                        mPricingrulesId
                        name
                      }
                      addons {
                        qty
                        price
                        name
                        addonProductId
                        value
                      }
                    }
                    metaData { key value }
                  }
                }`,
      };
      const response = await salesHistoryService(data);
      // Processing the fetched data
      let totalQty = 0;
      const salesData = response?.data?.data?.salesHistoryDetails;
      if (salesData[0]?.metaData?.length > 0) {
        setMetaData(salesData[0].metaData);
        metaDataRef.current = salesData[0].metaData;
      }

      const arrayData = await Promise.all(
        response?.data?.data?.salesHistoryDetails?.map(async (item) => {
          const paymentMethods = [];
          let change = 0;

          const itemSummery = {
            decimalItems: { totalQty: 0, totalAmount: 0 },
            nonDecimalItems: { totalQty: 0, totalAmount: 0 },
            itemsQty: 0,
            items: 0,
          };

          // Group items by tax rate
          const groupedItems = (item.line || []).reduce((acc, item) => {
            const key = item.tax?.rate ?? item.taxRate ?? "0";
            acc[key] = acc[key] || [];
            acc[key].push(item);
            return acc;
          }, {});

          // Calculate tax totals with SGST and CGST
          const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
            const totalTaxAmount = items.reduce((sum, item) => {
              const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.linetax : item.taxAmount) || 0;
              return sum + parseFloat(taxValue);
            }, 0);

            const totalNetTotal = items.reduce((sum, item) => {
              const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.linegross : item.nettotal) || 0;
              return sum + parseFloat(netValue);
            }, 0);

            // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
            const totalSgstAmount = items.reduce((sum, item) => {
              const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.linetax || item.taxAmount || 0) / 2;
              return sum + parseFloat(sgstValue || 0);
            }, 0);

            const totalCgstAmount = items.reduce((sum, item) => {
              const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.linetax || item.taxAmount || 0) / 2;
              return sum + parseFloat(cgstValue || 0);
            }, 0);

            return {
              taxRate,
              totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
              totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
              totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
              totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
              totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
            };
          });

          let totalLineStd = 0;
          const lineItems = await Promise.all(
            item.line.map(async (pro) => {
              const productObj = await db.products.where("mProductId").equals(pro.product.mProductId).first();
              const matchedGiftCardData = await db.giftCardData.toArray().then((giftCardData) => giftCardData.find((giftcard) => giftcard.mProductId === item.mProductId));

              // Update summary
              // const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro?.isDecimal;
              // const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
              // itemSummery.itemsQty += pro.qty;
              // itemSummery.items += 1;
              // itemSummery[summaryKey].totalQty += pro.qty;
              // itemSummery[summaryKey].totalAmount += pro.linegross;

              if (Array.isArray(pro.children) && pro.children.length > 0) {
                pro.children.forEach((child) => {
                  const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro?.isDecimal;
                  const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

                  itemSummery.itemsQty += child.qty;
                  itemSummery.items += 1;
                  itemSummery[summaryKey].totalQty += child.qty;
                  itemSummery[summaryKey].totalAmount += child.linegross;
                });
              } else {
                const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro.isDecimal;
                const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

                itemSummery.itemsQty += pro.qty;
                itemSummery.items += 1;
                itemSummery[summaryKey].totalQty += pro.qty;
                itemSummery[summaryKey].totalAmount += pro.linegross;
              }

              const productDefined = {
                batchno: productObj?.batchno || null,
                description: productObj?.description || "",
                discount: pro?.discount ?? 0,
                discountName: pro?.pricingRule?.name || "",
                imageurl: productObj?.imageurl || "",
                isDecimal: productObj?.isDecimal || false,
                isManualQty: productObj?.isManualQty || false,
                isPromoApplicable: productObj?.isPromoApplicable || false,
                deliveryDate: pro?.deliveryDate ? moment(pro?.deliveryDate).format("DD-MM-YYYY HH:mm:ss") : null,
                isReturn: false,
                mBatchId: pro?.mBatchId || null,
                giftCardType: matchedGiftCardData ? matchedGiftCardData?.type : null,
                mPricingruleId: null,
                name: productObj?.name || "",
                name2: productObj?.name2 || "",
                nettotal: pro.linegross || 0,
                primaryOrderLine: null,
                productId: productObj?.mProductId || null,
                realPrice: pro.unitprice || 0,
                listPrice: productObj?.slistprice || 0,
                sunitprice: pro?.unitprice || 0,
                returnQty: null,
                originalPrice: pro?.unitprice || 0,
                productSegment: pro?.product?.productSegment || "",
                salePrice: pro?.unitprice || 0,
                stock: productObj?.onhandQty || 0,
                tax: productObj?.cTaxId || null,
                taxCategory: productObj?.taxCategory || "",
                taxName: productObj?.taxName || "",
                taxFlag: productObj?.taxFlag || "N",
                taxAmount: pro.linetax || 0,
                taxRate: productObj?.taxRate || 0,
                uom: productObj?.csUomId || null,
                uom_name: productObj?.uomName || "",
                addNewLine: productObj?.addNewLine || "N",
                customAttributes: productObj?.customAttributes || [],
                preparationTime: productObj?.preparationTime || "",
                showAddons: productObj?.showAddons || false,
                foodType: productObj?.foodType || "",
                itemType: productObj?.itemType || "",
                type: productObj?.type || "",
                newCustomAttributes: [],
                priceList: productObj?.priceList || [],
                addons: pro.addons || [],
                selectedAddons: [],
                isDecimalQty: productObj?.uomData?.[0]?.decimal === "Y",
                isQtyDesimal: productObj?.uomData?.[0]?.stdprecision ?? 2,
                upc: pro.product?.upc || null,
                value: productObj?.value || null,
                weight: pro.qty || 0,
                order: "N",
                productionCenter: productObj?.productionCenter || "",
                productionCenterId: productObj?.productionCenterId || "",
                shortDescription: productObj?.shortDescription || "",
                hsncode: productObj?.hsncode || null,
                csBunitId: productObj?.csBunitId || null,
                mProductCategoryId: productObj?.mProductCategoryId || null,
                productManufacturerId: productObj?.productManufacturerId || null,
                productBrandId: productObj?.productBrandId || null,
                productBrandName: productObj?.productBrandName || null,
                productCategoryName: productObj?.productCategoryName || "",
                productAddons: productObj?.productAddons || [],
                batchedProduct: productObj?.batchedProduct || false,
                batchedForSale: productObj?.batchedForSale || false,
                batchedForStock: productObj?.batchedForStock || false,
                multiPrice: productObj?.multiPrice || [],
                shelfLife: productObj?.shelfLife || 0,
                stdTax: productObj?.sunitprice * (1 + productObj?.taxRate / 100),
                lineId: uuidv4().replace(/-/g, "").toUpperCase(),
                layAway: item.layAway || "N",
                // linestd: pro.grossstd * pro.qty,
                linestd: pro.linegross,
              };
              // const linestd = (pro.grossstd || 0) * (pro.qty || 0);
              const linestd = pro.linegross;
              totalLineStd += linestd;

              return { ...pro, ...productDefined };
            })
          );

          let paidAmount = 0;
          item?.finReceiptPlan?.[0]?.finReceiptPlanDetails?.forEach((ele) => {
            const paymentMethod = tillDataPaymentMethods.find((pi) => pi.finPaymentmethodId === ele.cwrPaymentmethod.finPaymentmethodId);
            if (paymentMethod && ele.amount > 0) {
              // paymentMethods.push({ ...paymentMethod, amount: parseFloat(ele.amount?.toFixed(2)), advancePayment: parseFloat(ele.amount?.toFixed(2)) });
              paymentMethods.push({
                ...paymentMethod,
                amount: parseFloat(parseFloat(ele.amount)?.toFixed(precision)),
                advancePayment: parseFloat(parseFloat(ele.amount)?.toFixed(precision)),
                transactionId: ele.transactionId || "",
                cardType: ele.cardType || "",
                cardNo: ele.cardNo || "",
                transactionTime: ele.transactionTime ? moment(ele.transactionTime).format("DD-MM-YYYY HH:mm:ss") : "",
                authorizationCode: ele.authorizationCode || "",
              });
              paidAmount += ele.amount;
            } else if (ele.amount < 0) {
              change = ele.amount;
            }
          });
          salesData?.forEach((item) => {
            const paymentDetailsMeta = item.metaData?.find((meta) => meta.key === "Payment Details");
            const paymentDetails = paymentDetailsMeta ? JSON.parse(paymentDetailsMeta.value) : [];
            const changeObj = paymentDetails.find((detail) => detail.change !== undefined && detail.change !== null);
            change = changeObj ? changeObj.change : 0;
          });
          const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData") || "{}");
          const selectedPriceListId = item?.cwrB2cCustomer?.sPriceListId ?? saleTypeData?.customer?.sPriceListId;
          return {
            change,
            items: lineItems || [],
            cardPaymentData: {},
            originalPrice: item.grosstotal || 0,
            customer: { ...item.cwrB2cCustomer, sPriceListId: selectedPriceListId } || "",
            documentno: item.documentno,
            total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
            discount: item.discAmount || 0,
            tax: item.taxamt || 0,
            deliveryDate: item?.deliveryDate ? moment(item?.deliveryDate).format("DD-MM-YYYY HH:mm:ss") : null,
            orderTime: item.orderTime ? moment(item.orderTime).format("DD-MM-YYYY HH:mm:ss") : null,
            orderDate: item.dateordered,
            totalQty: item.cwrProductQty,
            payments: [],
            paymentData: paymentMethods || [],
            roundOff: 0,
            sOrderID: item.sOrderID,
            key: item.documentno,
            salesHistory: "Y",
            status: "Success",
            isSynced: 0,
            creditAmount: 0,
            createdBy: "",
            layAway: item?.layAway || "N",
            isReturn: item?.isReturn || "N",
            paid: paidAmount || 0,
            advancePayment: paidAmount || 0,
            redemptionPoints: 0,
            accumulationPoints: 0,
            saleType: item.saleType || {},
            referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
            userName: userData.user,
            tillName: tillValue?.name,
            subTotal: parseFloat(parseFloat(item?.grosstotal - item.discAmount - item?.taxamt || 0)?.toFixed(precision)),
            itemsSummery: itemSummery,
            amountInWords: numberToWords(item?.grosstotal || 0),
            groupedItemsByTaxRate: groupedItemsByTaxRate,
            totalStd: totalLineStd,
          };
        })
      );
      if (arrayData.length > 0) {
        // Create a new array by updating or adding records
        const updatedOrderDetails = orderHistoryDetails.map((order) => {
          // Check if the current order matches any entry in arrayData
          const matchingData = arrayData.find((newData) => newData.sOrderID === order.sOrderID);
          return matchingData ? { ...order, ...matchingData } : order; // Update if match found
        });

        // Update state with the new array
        setOrderHistoryDetails(updatedOrderDetails);
        setOrdersCopy(updatedOrderDetails);
      }

      setLoading(false);
      return arrayData;
    } catch (error) {
      console.error("Error fetching order history:", error);
      // Handle error appropriately, for example, set a state to show an error message
    } finally {
      setLoading(false);
    }
    setOrderHistoryInput("");
  };

  const searchOrderHistory = async (date, dateValue, row, flag, dateFlag) => {
    let setAuthTokens;
    let startDate;
    let endDate;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const sortOptions = {
      documentno: "desc",
      dateordered: "desc",
      customer: null,
      totalAmount: null,
    };
    const filteredSortOptions = Object.fromEntries(Object.entries(sortOptions).filter(([key, value]) => value !== null));
    if (dateValue?.length > 0) {
      localStorage.setItem("orderType", JSON.stringify([date, dateValue]));
      startDate = moment(dateValue[0]).format("YYYY-MM-DD");
      endDate = moment(dateValue[1]).format("YYYY-MM-DD");
    }

    const productSearchInput = document.getElementById("sm-salesHistory-customer");
    if (productSearchInput) {
      productSearchInput.focus();
    }
    const isPreOrderPage = window.location.pathname.includes("/preorder");
    let dateFiltered;
    if (isPreOrderPage) {
      dateFiltered = `"{\\"DateRange\\":[\\"${startDate}\\",\\"${endDate}\\"],\\"DeliveryDateRange\\":[\\"${startDate}\\",\\"${endDate}\\"]}"`;
    } else {
      dateFiltered = `"{\\"DateRange\\":[\\"${startDate}\\",\\"${endDate}\\"]}"`;
    }
    // const dateFiltered = `"{\\"DateRange\\":[\\"${startDate}\\",\\"${endDate}\\"]}"`;
    const sortData = JSON.stringify(filteredSortOptions).replace(/"/g, '\\"');
    const isCallCenterPage = window.location.pathname.includes("/call-center");
    if (date === "orderDateSearchKey") {
      setLoading(true);
      try {
        const startRow = row;
        const endRow = parseInt(startRow, 10) + 50;
        const specificStores = posConfig?.showStoreSpecificRecords === "Y" ? true : false;
        const data = {
          query: `query {salesHistory(
                    q: ${
                      posConfig?.enableCallCentre === "Y" && isCallCenterPage ? `"${cart.customer.code}"` : searchHistoryInput?.trim() ? `"${searchHistoryInput.trim()}"` : null
                    },
                    filter_by: ${dateFiltered},
                    startRow: "${startRow}",
                    endRow: "${endRow}",
                    sort_by: "${sortData}",
                    tillId: ${specificStores ? `"${tillValue?.cwr_till_id}"` : null}
                  ) {
                  sOrderID
                  documentno
                  dateordered
                  totalQty
                  orderTime
                  grosstotal
                  layAway
                  isReturn
                  docstatus
                  saleType {
                    cwrSaletypeId
                    name
                    value
                  }
                  deliveryDate
                  cwrB2cCustomer {
                    cwrCustomerId
                    code
                    name
                    mobileNo
                    pincode
                    email
                    retlLoyaltyBalance
                    loyaltyLevelId
                    creditBalance
                    creditApproachPercentage
                    loyaltyLevel {
                      name
                    }
                    cwrWallet {
                      wallet_Id
                      balance_Amt
                    }
                    sCustomer {
                      sCustomerID
                      customerCategory {
                        sCustomerCategoryId
                        value
                        name
                        description
                      }
                    }
                  }
                  cwrTill {
                    till
                  }
                }        
                }
                `,
        };
        const orderHistoryData = await orderHistoryService(data);
        if (orderHistoryData?.data?.data?.salesHistory.length === 0) {
          message.error(`${messages.errors.cart.no_more_records}`);
          setFiltersFlag(true);
          setLoading(false);
        } else {
          localStorage.setItem("dataLength", endRow.toString());
          setFilterdDate(dateFiltered);
          const isPreOrderPage = window.location.pathname.includes("/preorder");
          const arrayData = await Promise.all(
            orderHistoryData?.data?.data?.salesHistory
              ?.filter((item) => {
                if (!isPreOrderPage && posConfig?.enablePreOrder === "Y" && item.layAway === "Y") {
                  return false;
                }
                return true;
              })
              ?.map(async (item) => {
                const obj = {
                  change: 0,
                  items: [],
                  cardPaymentData: {},
                  originalPrice: item.grosstotal || 0,
                  customer: item.cwrB2cCustomer || "",
                  documentno: item.documentno,
                  total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
                  discount: item.discAmount || 0,
                  tax: item.taxamt || 0,
                  orderTime: item.orderTime,
                  orderDate: item.dateordered,
                  totalQty: item.totalQty || 0,
                  payments: [],
                  paymentData: [],
                  roundOff: 0,
                  sOrderID: item.sOrderID,
                  key: item.documentno,
                  salesHistory: "Y",
                  status: "Success",
                  isSynced: 0,
                  creditAmount: 0,
                  createdBy: "",
                  layAway: item.layAway || "N",
                  isReturn: item.isReturn || "N",
                  docstatus: item.docstatus,
                  deliveryDate: item.deliveryDate,
                  saleType: item.saleType || {},
                  paid: 0,
                  advancePayment: 0,
                  redemptionPoints: 0,
                  accumulationPoints: 0,
                  // saleType: item.saleType || {},)
                  referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                  userName: userData.user,
                  tillName: tillValue?.name,
                  subTotal: 0,
                  itemsSummery: {},
                  amountInWords: "",
                  groupedItemsByTaxRate: {},
                };

                return obj;
              })
          );
          setOrderHistoryDetails((prevData) => {
            const existingOrderIds = new Set(prevData.map((order) => order.sOrderID));
            const uniqueNewOrders = arrayData.filter((order) => !existingOrderIds.has(order.sOrderID));
            return [...prevData, ...uniqueNewOrders];
          });
          setOrdersCopy((prevData) => {
            const existingOrderIds = new Set(prevData.map((order) => order.sOrderID));
            const uniqueNewOrders = arrayData.filter((order) => !existingOrderIds.has(order.sOrderID));
            return [...prevData, ...uniqueNewOrders];
          });
          setFiltersFlag(dateFlag ? false : true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching order history data:", error);
        setLoading(false);
      }
    } else {
      setLoading(true);
      setOrderHistoryDetails([]);
      prevHistoryRef.current = orderHistoryDetails;
      localStorage.setItem("dataLength", "100");
      const specificStores = posConfig?.showStoreSpecificRecords === "Y" ? true : false;
      try {
        const data = {
          query: `query { salesHistory(
              q: "${dateValue.trim()}",
              filter_by: ${flag ? filteredDate : null},
              startRow: "0",
              endRow: "100",
              sort_by: "${sortData}",
              tillId: ${specificStores ? `"${tillValue?.cwr_till_id}"` : null}
            ) {
                  sOrderID
                  documentno
                  dateordered
                  totalQty
                  orderTime
                  grosstotal
                  layAway
                  isReturn
                  docstatus
                  saleType {
                    cwrSaletypeId
                    name
                    value
                  }
                  deliveryDate
                  cwrB2cCustomer {
                    cwrCustomerId
                    code
                    name
                    mobileNo
                    pincode
                    email
                    retlLoyaltyBalance
                    loyaltyLevelId
                    creditBalance
                    creditApproachPercentage
                    loyaltyLevel {
                      name
                    }
                    cwrWallet {
                      wallet_Id
                      balance_Amt
                    }
                    sCustomer {
                      sCustomerID
                      customerCategory {
                        sCustomerCategoryId
                        value
                        name
                        description
                      }
                    }
                  }
                  cwrTill {
                    till
                  }
                }
                }`,
        };
        const response = await orderHistoryService(data);

        // Processing the fetched data
        const arrayData = await Promise.all(
          response?.data?.data?.salesHistory?.map(async (item) => {
            return {
              change: 0,
              items: [],
              cardPaymentData: {},
              originalPrice: item.grosstotal || 0,
              customer: item.cwrB2cCustomer || "",
              documentno: item.documentno,
              total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
              discount: item.discAmount || 0,
              tax: item.taxamt || 0,
              orderTime: item.orderTime,
              orderDate: item.dateordered,
              totalQty: item.cwrProductQty || item.totalQty,
              payments: [],
              paymentData: [],
              roundOff: 0,
              sOrderID: item.sOrderID,
              key: item.documentno,
              salesHistory: "Y",
              status: "Success",
              isSynced: 0,
              creditAmount: 0,
              createdBy: "",
              layAway: item?.layAway || "N",
              isReturn: item?.isReturn || "N",
              docstatus: item.docstatus,
              deliveryDate: item.deliveryDate,
              saleType: item.saleType || {},
              paid: 0,
              advancePayment: 0,
              redemptionPoints: 0,
              accumulationPoints: 0,
              referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
              userName: userData.user,
              tillName: tillValue?.name,
              subTotal: 0,
              itemsSummery: {},
              amountInWords: "",
              groupedItemsByTaxRate: {},
            };
          })
        );

        setOrdersCopy(arrayData);
        setOrderHistoryDetails(arrayData);
        setFiltersFlag(!dateFlag);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching order history:", error);
        // Handle error appropriately, for example, set a state to show an error message
      } finally {
        setLoading(false);
      }
    }

    setOrderHistoryInput("");
  };

  const getDisplayDate = () => {
    if (dateRange && dateRange.length === 2) {
      const [start, end] = dateRange;
      return `${start.format("DD-MM-YYYY")} to ${end.format("DD-MM-YYYY")}`;
    }
    return "Choose date range";
  };

  const content = (
    <RangePicker
      open={isPopoverVisible}
      allowEmpty
      id="sm-salesHistory-date"
      onPressEnter={searchOrderHistory}
      allowClear={true}
      format={"YYYY-MM-DD"}
      suffixIcon={null}
      separator={null}
      value={dateRange}
      onChange={(e) => {
        if (e?.length > 0) {
          setFilterdDate(null);
          setPopoverVisible(false);
          setDateRange(e);
          localStorage.setItem("dataLength", 0);
          searchOrderHistory("orderDateSearchKey", e, 0, searchHistoryInput !== "" ? true : false, false);
        } else if (e === null && searchHistoryInput === "") {
          setFilterdDate(null);
          setDateRange(e);
          setOrderHistoryDetails([]);
          db.orders
            .orderBy("orderTime")
            .limit(20)
            .reverse()
            .toArray()
            .then((data) => {
              // Your logic to handle data here
            });
        } else if (e === null && searchHistoryInput !== "") {
          setDateRange(e);
          setFilterdDate(null);
          setOrderHistoryDetails([]);
          searchOrderHistory("customer", searchHistoryInput, 0, false);
        }
      }}
      className="salesHistory-datePicker-sm"
    />
  );
  // parked block

  const storedParkedList = JSON.parse(localStorage.getItem("parkedList"));
  const initialParkedList = storedParkedList ? storedParkedList : [];
  const [displayParkedBillModal, setDisplayParkedBillModal] = useState(false);
  const [parkedList, setParkedList] = useState(initialParkedList);
  const [filterdParkedList, setFilterdParkedList] = useState(initialParkedList);

  const discardParkedBill = async (record) => {
    upsertPOSLog(record.parkedCart, "DPO");

    // Remove from localStorage / main list
    const localParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
    const updatedList = localParkedList.filter((item) => item.key !== record.key);
    localStorage.setItem("parkedList", JSON.stringify(updatedList));
    setParkedList([...updatedList]);

    // Update filtered list based on current search input
    if (!parkedBillSearchInput) {
      setFilterdParkedList(mapParkedList(updatedList));
    } else {
      const lowercaseKey = parkedBillSearchInput.toLowerCase();
      const filteredBills = updatedList.filter((item) => {
        const lowercaseCustomer = item?.parkedCart?.customer?.name?.toLowerCase() || "";
        const lowercaseParkedDocNo = item.parkedDocNo?.toLowerCase() || "";
        return lowercaseCustomer.includes(lowercaseKey) || lowercaseParkedDocNo.includes(lowercaseKey);
      });
      setFilterdParkedList(mapParkedList(filteredBills));
    }

    // Save discarded cart to DB (your existing logic)
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    const tillSessionId = tillSession?.tillSessionId;
    let cartToDb = record.parkedCart;
    cartToDb.orderTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    cartToDb.createdBy = tillData.tillAccess?.csUserId || "";
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId || "";
    cartToDb.orderDate = moment(new Date()).format("DD-MM-YYYY");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart?.customer?.code || "";
    cartToDb.total = 0;
    cartToDb.totalQty = 0;
    cartToDb.tax = 0;
    cartToDb.isReturn = false;
    cartToDb.items.forEach((item) => {
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.netList = 0;
      item.discount = 0;
      item.isReturn = false;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
      item.realPrice = 0;
    });
    if (record.parkedCart.type === "Layaway") {
      setDocumnetSequence(documentSequence);
    } else {
      await db.orders.put(cartToDb);
    }
  };

  const openDisplayParkedBillModal = (param, record) => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        onOk() {
          setSelectedDocumentType("Invoice");
          let PaymentMethods = getFilteredPaymentMethods() || [];
          let payments =
            PaymentMethods.length > 5
              ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                  0,
                  tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
                )
              : PaymentMethods;

          setShowPayments(payments);
          parkBill(param, record);
          const productSearchInput = document.getElementById("sm-product-search");
          setTimeout(() => {
            // productSearchInput.focus();
            setOpen(false);
          }, 600);
          if (searchInputRef?.current) {
            searchInputRef?.current?.focus();
          }
          setProductSearchInput("");
        },
        onCancel() {
          const productSearchInput = document.getElementById("sm-product-search");
          productSearchInput?.focus();
          if (searchInputRef?.current) {
            searchInputRef.current.focus();
          }
          setOpen(false);
          setProductSearchInput("");
          setDisplayParkedBillModal(true);
        },
      });
    } else {
      setProductSearchInput("");
      setDisplayParkedBillModal(true);
    }
  };

  const parkedListRef = useRef(initialParkedList);
  useEffect(() => {
    parkedListRef.current = parkedList;
  }, [parkedList]);

  const parkBill = (value, record) => {
    if (cart.parked !== "Y" && cart.layAway !== "Y") {
      const newDocumentSequence = documentSequence + 1;
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      deleteReceipt();
      if (value === "retrieve") {
        selectParkedBill(record, "management");
      }
    } else if (cart.layAway === "Y") {
      const newDocumentSequence = documentSequence;
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      deleteReceipt("layAwayParked");
    } else {
      if (value === "retrieve") {
        selectParkedBill(record, "management");
      } else {
        if (cart.isRetrived !== "Y") {
          const newDocumentSequence = documentSequence + 1;
          localStorage.setItem("documentSequence", newDocumentSequence);
          setDocumnetSequence(newDocumentSequence);
        }
        deleteReceipt();
      }
    }
    const presentParkedList = value === "parkKey" ? parkedListRef.current : JSON.parse(localStorage.getItem("parkedList")) || [];
    cart.parked = "Y";
    const presentCart = cart;
    const presentTimeStamp = timeStamp();
    const parkedBill = {
      parkedCart: presentCart,
      parkedTime: presentTimeStamp,
      parkedDocNo: cart.documentno,
      parkedOrderID: cart.items[0].sOrderReturnId,
      parkedBillId: uuidv4().replace(/-/g, "").toUpperCase(),
      qty: presentCart.totalQty,
    };
    presentParkedList.push(parkedBill);
    localStorage.setItem("parkedList", JSON.stringify(presentParkedList));
    setParkedList([...presentParkedList]);
    hasShownCustomerModalRef.current = false;

    {
      message.success(`${t("bill_parking_successful")}`);
    }
  };

  const selectParkedBill = async (item, fieldName) => {
    const listItemIndex = parkedList.findIndex((bill) => bill.parkedBillId === item.parkedBillId);
    const selectedParkedBill = { ...parkedList[listItemIndex]?.parkedCart, isRetrived: "Y" };

    let stockCheckResult = true;
    let isFinalValidation = false;
    let isCompleteSale = false;
    if (navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: selectedParkedBill,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        setShowPaymentMethods(true);
        setOrderHistoryDetails([]);
        setIsparkedBill(false);
      }
    } else {
      setShowPaymentMethods(true);
      setOrderHistoryDetails([]);
      setIsparkedBill(false);
    }
    // Remove the selected bill from the parked list
    const updatedParkedList = [...parkedList];
    updatedParkedList.splice(listItemIndex, 1);
    setParkedList(updatedParkedList);
    localStorage.setItem("parkedList", JSON.stringify(updatedParkedList));

    // Handle layaway logic
    if (selectedParkedBill?.layAway === "Y") {
      setSelectedDocumentType("Advance");

      const PaymentMethods = getFilteredPaymentMethods() || [];
      const maxPayments =
        PaymentMethods.length > 5
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
            )
          : PaymentMethods;

      setShowPayments(maxPayments);
    }
    setCart(selectedParkedBill);
    localStorage.setItem("cartObj", JSON.stringify(selectedParkedBill));

    setDisplayParkedBillModal(false);
    if (fieldName === "management") {
      setManagementScreenShow(false);
    }
  };

  const selectLayAwayOrder = async (item, fieldName) => {
    const itemWithNumberTotal = {
      ...item,
      total: parseFloat(item.total),
    };
    const customMixEntry = metaDataRef.current.find((entry) => entry.key === "Custom Mix");
    let updatedCart;
    if (!customMixEntry) {
      updatedCart = {
        ...itemWithNumberTotal,
      };
    } else {
      let customMixData = [];
      try {
        customMixData = JSON.parse(customMixEntry.value);
      } catch (error) {
        console.error("Invalid JSON in Custom Mix value", error);
        return [];
      }
      const matchedIds = new Set();
      const enrichedMixes = customMixData.map((mix) => {
        const matchedChildren = mix.children
          .map((child) => {
            const matchedItem = item.items.find((line) => line.sOrderlineID === child.sOrderlineID);
            if (matchedItem) {
              matchedIds.add(child.sOrderlineID);
            }
            return {
              ...matchedItem,
              taxAmount: matchedItem?.unittax ?? 0,
              groupedItems: true,
              actualWeight: matchedItem?.weight / mix.weight,
              baseQty: matchedItem?.weight / mix.weight,
            };
          })
          .filter(Boolean);

        return {
          ...mix,
          children: matchedChildren,
          nettotal: mix.nettotal,
          sunitprice: mix.nettotal,
          originalPrice: mix.nettotal,
          salePrice: mix.nettotal - mix.taxAmount,
          realPrice: mix.nettotal - mix.taxAmount,
          addNewLine: "N",
          batchedForSale: "N",
          batchedForStock: "N",
          batchedProduct: "N",
          batchno: null,
          bunitName: "",
          csBunitId: null,
          customAttributes: [],
          preparationTime: "",
          cwrMenuTimeslot: [],
          description: "",
          discount: mix.discount,
          discountName: "",
          foodType: "",
          itemType: "",
          grosslist: 0,
          grossstd: 0,
          grossunit: 0,
          hsncode: "",
          imageUrl: "",
          imageurl: "",
          isDecimal: false,
          isDecimalQty: false,
          isManualQty: false,
          isPromoApplicable: false,
          isQtyDesimal: 2,
          isReturn: false,
          key: 0,
          lineId: uuidv4().replace(/-/g, "").toUpperCase(),
          linegross: 0,
          linenet: 0,
          linetax: 0,
          listPrice: 0,
          listprice: 0,
          mBatchId: null,
          mPricingruleId: null,
          multiPrice: "N",
          name2: "",
          netList: 0,
          netStd: 0,
          netunit: 0,
          newCustomAttributes: [],
          order: "N",
          originalPrice: 0,
          priceList: [],
          primaryOrderLine: null,
          productAddons: [],
          productCategoryName: "",
          productId: uuidv4().replace(/-/g, "").toUpperCase(),
          productManufacturerId: null,
          productionCenter: "",
          productionCenterId: "",
          returnQty: null,
          salesRepId: null,
          salesRepName: "",
          selectedAddons: [],
          shelfLife: "",
          shortDescription: "",
          showAddons: "N",
          taxCategory: "",
          taxFlag: "N",
          taxName: "",
          // taxRate: 18,
          type: "I",
          unitPrice: 0,
          unitTax: 0,
          upc: "",
          upcPricingRule: null,
          value: "",
        };
      });
      const unmatchedItems = item.items.filter((line) => !matchedIds.has(line.sOrderlineID));
      const allItems = [...enrichedMixes, ...unmatchedItems];
      updatedCart = {
        ...itemWithNumberTotal,
        items: allItems,
      };
    }
    setShowPaymentMethods(true);
    const filteredItemsForStockCheck = updatedCart.items.filter((item) => item.productSegment !== "CB" && item.type === "I");
    const stockCart = {
      ...updatedCart,
      items: filteredItemsForStockCheck,
    };
    let stockCheckResult = true;
    let isFinalValidation = false;
    if (navigator.onLine && updatedCart?.preOrder === "Y" && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: stockCart,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
        setCart(updatedCart);
      }
    }
    localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    setCart(updatedCart);
  };

  const [parkedBillSearchInput, setParkedBillSearchInput] = useState("");
  const [salesHistoryCustomerSearchInput, setSalesHistoryCustomerSearchInput] = useState("");
  const [salesHistoryDocumentNoSearchInput, setSalesHistoryDocumentNoSearchInput] = useState("");

  const handleParkedBillSearchInput = (e) => {
    setParkedBillSearchInput(e.target.value);
    searchParkedBill(e.target.value);
  };

  const mapParkedList = (list) => {
    return list.map((item) => ({
      ...item,
      customer: item?.parkedCart?.customer?.name || "",
      status: "Parked",
      key: item.key,
      qty: item?.parkedCart?.totalQty || 0,
    }));
  };

  const searchParkedBill = (key) => {
    if (!key) {
      const allParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];
      setFilterdParkedList(mapParkedList(allParkedList));
      return;
    }

    const lowercaseKey = key.toLowerCase();
    const allParkedList = JSON.parse(localStorage.getItem("parkedList")) || [];

    const filteredBills = allParkedList.filter((list) => {
      const lowercaseCustomer = list?.parkedCart?.customer?.name?.toLowerCase() || "";
      const lowercaseParkedDocNo = list.parkedDocNo?.toLowerCase() || "";
      return lowercaseCustomer.includes(lowercaseKey) || lowercaseParkedDocNo.includes(lowercaseKey);
    });
    setFilterdParkedList(mapParkedList(filteredBills));
  };

  const closeParkedBillModal = () => {
    setDisplayParkedBillModal(false);
    setParkedBillSearchInput("");
    setFilterdParkedList([...parkedList]);
  };

  // PARKED BILL BLOCK END

  // prodcut add ons start

  const [displayAddOnSelection, setDisplayAddOnSelection] = useState(false);
  const [addOnsList, setAddOnsList] = useState({
    requiredList: [],
    optionsList: [],
  });
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [isUpdatingAddon, setIsUpdatingAddon] = useState(false);

  const addDefinedProductWithAddons = (productObjs, upc, batchno, mBatchId, price) => {
    const productObj = { ...productObjs };
    if (productObj.overRideTax === "Y" && price <= productObj.overRideCondition) {
      const originalPrice = price - (price - price * (100 / (100 + productObj.taxRate)));
      const taxedPrice = originalPrice + (originalPrice * productObj.contraRate) / 100;
      price = taxedPrice;
      productObj.cTaxId = productObj.contraTaxId;
      productObj.taxRate = productObj.contraRate;
    }
    productObj.salePrice = productObj?.sunitprice || 0;
    productObj.realPrice = price;
    productObj.order = "N";
    ((productObj.isQtyDesimal = productObj?.uomData[0]?.length > 0 ? productObj.uomData[0].stdprecision : 2), (productObj.productId = productObj?.mProductId || null));
    productObj.mBatchId = mBatchId || null;
    productObj.productId = productObjs.productId;
    addProductToCart(
      productObj,
      productObj.weight || productObj?.qty,
      false,
      cart,
      setCart,
      setSelectedProductInCart,
      deleteCart,
      processTotalManualDiscount,
      setLoader,
      salesRepresentDefaultLine,
      tillData,
      cartRef,
      productsCopy,
      salesRepresent,
      orderType,
      processBillDiscounts,
      undefined,
      setSelectedRowKeys,
      setOrderTimeDetails,
      setDisplayAddOnSelection,
      displayAddOnSelection,
      handleAddOnModal,
      manualDiscountTypes,
      CheckoutFlatDiscount,
      CheckoutPercentageDiscount,
      CheckoutTotalManualDiscount,
      setProductStock,
      selectedProductInCart,
      setTableCards,
      dispatchItemSelection,
      searchInputRef,
      false,
      setShowCompleteSaleStock,
      setCompleteSaleStockData,
      TotalBillDiscount,
      tillLayout,
      false
    );
    setSelectedAddons([]);
  };

  const handleAddOnModal = (record, qty) => {
    setDisplayAddOnSelection(true);
    record.qty = qty;
    setSelectedProduct(record);
    setAddOnsList({
      requiredList: record.productAddons,
      optionsList: record.productAddons,
    });
  };

  const handleAddOnValue = (e, fieldName) => {
    let newSelectedAddons = [...selectedAddons];
    const indexValue =
      fieldName === "addOnRadio"
        ? _.findIndex(newSelectedAddons, (item) => item.mAddonGroup.mAddonGroupId === e.target.value.mAddonGroup.mAddonGroupId)
        : _.findIndex(newSelectedAddons, (item) => item === e.target.value);
    if (indexValue !== -1) {
      if (e.target.checked) {
        newSelectedAddons[indexValue] = e.target.value;
      } else {
        newSelectedAddons.splice(indexValue, 1);
      }
    } else {
      newSelectedAddons = [...selectedAddons, e.target.value];
    }
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = {
      ...selectedProduct,
      weight: selectedProduct?.weight || 1,
    };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }
    setSelectedProduct({
      ...newSelectedProduct,
    });
  };

  const handleSelectedSaleTypeForProducts = (obj) => async () => {
    try {
      setSelectedSaleTypeData(obj);
      const paymentDetails = getFilteredPaymentMethods(obj?.cwrSaletype?.cwrSaletypeId || null);
      setShowPayments(paymentDetails);
      localStorage.setItem("saleTypeData", JSON.stringify(obj));
      setSelectedSaleType(obj?.cwrSaletype?.name);
      setIsSaleTypeFlag(false);
      changeCustomerId(obj);

      let updatedCart = JSON.parse(localStorage.getItem("cartObj"));
      updatedCart.customer = obj?.customer?.b2cCustomerId ? obj?.customer : tillData.tillAccess.csBunit.b2cCustomer;
      let processedProducts;
      let updatedProducts = await db.products.filter((product) => product.isactive === true).toArray();
      const filteredProducts = updatedProducts.filter((product) => product.priceList?.some((priceList) => priceList?.sPricelistId === updatedCart.customer?.sPriceListId));
      processedProducts = filteredProducts.map((product) => {
        // const matchedPrice = product.priceList.find((priceList) => priceList.sPricelistId === updatedCart.customer?.sPriceListId);
        // return {
        //   ...product,
        //   price: matchedPrice.pricestd,
        //   salePrice: matchedPrice.pricestd,
        //   realPrice: matchedPrice.pricestd,
        //   sunitprice: matchedPrice.pricestd,
        // };
        const selectedPrice = getApplicablePrice({
          priceList: product.priceList,
          selectedUomId: product.uomData[0]?.csUomId,
          sPriceListId: updatedCart.customer.sPriceListId,
        });

        if (!selectedPrice) return product;

        return {
          ...product,
          price: selectedPrice.pricestd,
          salePrice: selectedPrice.pricestd,
          realPrice: selectedPrice.pricestd,
          sunitprice: selectedPrice.pricestd,
        };
      });
      if (!updatedCart?.customer?.sPriceListId) {
        processedProducts = updatedProducts;
      }

      setSaleTypeProducts(processedProducts);

      const finalCartObj = { ...updatedCart };
      localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
      setCart(finalCartObj);

      if (obj?.cwrSaletype?.value === "DI" || obj?.cwrSaletype?.value === "TA") {
        return;
      } else {
        setShowProducts(true);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const handleAdd = async () => {
    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        selectedAddons: selectedAddons || [],
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice
    );
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
    setFilterDrawer(false);
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  // product add ons end

  //// CENTER BUTTON BLOCK END ////

  //// CART OPERATIONS START ////

  // DEFAULT CART START
  const [cart, setCart] = useState({
    items: [],
    couponInput: [],
    advancePayment: 0,
    total: 0,
    tax: 0,
    discount: 0,
    paid: 0,
    change: 0,
    totalQty: 0,
    roundOff: 0,
    payments: [],
    redemptionPoints: 0,
    accumulationPoints: 0,
    creditAmount: 0,
    docType: "Invoice",
    sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
    referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
    giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    customer: defaultCustomer,
    salesRepId: null,
    cardPaymentData: {},
    documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
    userName: userData.user,
    tillName: tillValue?.name,
    subTotal: 0,
    itemsSummery: {},
    amountInWords: "",
    groupedItemsByTaxRate: {},
    serviceCharge: 0,
    tip: 0,
    deiveryCharge: 0,
    packingCharge: 0,
    others: 0,
    refundAmount: 0,
  });

  useEffect(() => {
    if (cart?.items?.length > 0) {
      const preciseTotal = parseFloat(cart?.total?.toFixed(precision));

      let updatedCart = {
        ...cart,
        total: preciseTotal,
        amountInWords: numberToWords(preciseTotal),
      };

      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }
  }, [cart]);

  useEffect(() => {
    let saleType = JSON.parse(localStorage.getItem("saleTypeData"));
    let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
    if (saleType && cartObj.items.length > 0) {
      let updatedCart = {
        ...cartObj,
        saleType: saleType?.cwrSaletype,
      };
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }
  }, [selectedSaleType, cart]);

  useEffect(() => {
    if (cart?.items?.length > 0) {
      if (window.location.pathname.includes("/pos")) {
        if (cart?.isPreOrderPage === true && cart?.preOrder !== "Y") {
          Modal.confirm({
            title: "Clear The Cart Items ?",
            icon: <ExclamationCircleOutlined />,
            content: <div>Pre-Order cart will be cleared if you continue. Do you want to proceed?</div>,
            okText: "Yes",
            cancelText: "No",
            autoFocusButton: null,
            onOk() {
              let updatedCart = {
                ...cart,
                isPreOrderPage: false,
                items: [],
                total: 0,
                subTotal: 0,
                tax: 0,
                discount: 0,
                paid: 0,
                change: 0,
                roundOff: 0,
                advancePayment: 0,
                couponInput: [],
                payments: [],
                giftCardRefId: null,
                couponRefId: null,
                itemsSummery: {},
                groupedItemsByTaxRate: {},
              };
              localStorage.setItem("cartObj", JSON.stringify(updatedCart));
              setCart(updatedCart);
            },
            onCancel() {
              history.push("/preorder");
            },
          });
        }
      } else if (window.location.pathname.includes("/preorder")) {
        let updatedCart = {
          ...cart,
          isPreOrderPage: true,
        };
        localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      }
    }
  }, [cart]);

  // DEFAULT CART END

  // BARCODE READER BLOCK START
  const [displayBatchSelection, setDisplayBatchSelection] = useState(false);
  const [batchSetAvailable, setBatchSetAvailable] = useState([]);

  const onBarcodeInput = async (data, flag) => {
    keyboard?.current?.setInput("");
    let chackBarcodeFlag = false;
    if (data?.trim() !== "" && data !== null) {
      if (posConfig?.noFocus === "Y") {
        await ofcBarcodeScaner(
          data,
          tillData,
          tillLayout,
          addDefinedProduct,
          setBatchSetAvailable,
          setDisplayBatchSelection,
          setLayoutType,
          setIsProductsVisible,
          setProductsData,
          chackBarcodeFlag,
          setSelectedProductInCart,
          setProductSearchInput,
          productSearchInputRef,
          cart,
          authHeaders,
          setOptions
        );
      } else {
        await barcodeScaner(
          data,
          tillData,
          tillLayout,
          addDefinedProduct,
          setBatchSetAvailable,
          setDisplayBatchSelection,
          setLayoutType,
          setIsProductsVisible,
          setProductsData,
          chackBarcodeFlag,
          setSelectedProductInCart,
          setProductSearchInput,
          productSearchInputRef,
          cart,
          authHeaders,
          setOptions
        );
      }
    }
  };

  const [isStockModal, setIsStockModal] = useState(false);
  const [tempCart, setTempCart] = useState({});

  const verifyStock = async (docType) => {
    const defaultCustomer = cart?.customer?.cwrCustomerId === tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId;
    const isAnonymousCustomer = defaultCustomer && posConfig?.showCustomerSearchValue === "Before Payment";

    const performStockCheck = async () => {
      if (posConfig?.enableStockCheck === "N" || !posConfig?.enableStockCheck) {
        handleCartTotalClick(docType);
        return;
      }

      const isFinalValidation = true;
      const stockCheckResult = await stock({
        cart,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
      });

      setSelectedProductInCart({});

      if (stockCheckResult) {
        handleCartTotalClick();
      } else {
        setIsStockModal(true);
      }
    };

    if (isAnonymousCustomer && !hasShownCustomerModalRef.current && cart.total > 0) {
      hasShownCustomerModalRef.current = true;
      setDisplayCustomerSearch(true);
    } else {
      await performStockCheck();
    }
  };

  const handleCartTotalClick = async (documentType) => {
    try {
      let index = cart.items.findIndex((item) => item.productSegment === "AD");
      if ((posConfig ? posConfig["requireDeliveryDate-Advance"] === "Y" : false) && (documentType === "Advance" || selectedDocumentType === "Advance")) {
        if (!cart.deliveryDate && cart.deliveryDate !== "") {
          message.warn(`${messages.errors.cart.deliverydate_required}`);
          return;
        }
      }
      if (index !== -1 && selectedDocumentType !== "Advance") {
        setShowPaymentMethods(false);
        message.warn(`${messages.errors.cart.advance_option_required}`);
        return;
      }
      // setAmount(parseFloat(parseFloat(amount || cart.total - (cart.paid ?? 0))?.toFixed(precision)));

      let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
      setAmount(parseFloat(parseFloat(cartObj.total - (cartObj.paid ?? 0) || amount)?.toFixed(precision)));

      const workflowRules = (await db.POSWorkFlowRules.toArray()) || [];
      const approvers = (await db.approvers.toArray()) || [];

      let localCart = JSON.parse(localStorage.getItem("cartObj")) || cart;

      if (!localCart.items) {
        localCart.items = [];
      }

      let PaymentMethods = getFilteredPaymentMethods() || [];
      const advanceItem = cart.items.find((item) => item.type === "S" && item.weight > 0 && item.productSegment === "AD");
      if (
        cart.layAway === "Y" &&
        cart?.docType === "Advance" &&
        !advanceItem &&
        posConfig?.allowLayawaywithoutPayment !== "Y" &&
        !cart.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
      ) {
        PaymentMethods = [
          ...PaymentMethods,
          ...(posConfig?.enablePreOrder !== "Y"
            ? [
                {
                  cWRPaymentMethodID: "",
                  sequenceNo: 9999,
                  finPaymentmethodId: "",
                  finFinancialAccountId: "",
                  finDayCloseAccountId: null,
                  name: "Complete Order",
                  integratedPayment: false,
                  isloyalty: false,
                  paymentProvider: null,
                  iscredit: false,
                  isGiftCard: false,
                  isDefault: "N",
                  csCurrencyId: "",
                  isoCode: "AED",
                  isactive: true,
                  salesType: [],
                },
              ]
            : []),
        ];
      }
      const isPreOrderPage = window.location.pathname.includes("/preorder");
      if (isPreOrderPage) {
        const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
        const maxPaymentsToShow = isRefundScenario ? 3 : 3;
        let payments =
          PaymentMethods.length > maxPaymentsToShow
            ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                0,
                tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
                  ? maxPaymentsToShow
                  : cart.layAway === "Y"
                    ? maxPaymentsToShow
                    : maxPaymentsToShow
              )
            : PaymentMethods;
        setShowPayments(payments);
        setStartIndex(cart.layAway === "Y" && payments.length >= maxPaymentsToShow ? maxPaymentsToShow : payments.length);
      } else {
        let payments =
          PaymentMethods.length > 5
            ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                0,
                tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
              )
            : PaymentMethods;

        setShowPayments(payments);
        setStartIndex(cart.layAway === "Y" && payments.length >= 5 ? 5 : payments.length);
      }

      if (workflowRules.length > 0 && localCart.isReturn === true && localCart.items.length > 0 && !showPaymentMethods) {
        workflowRules.forEach((res) => {
          if (res.eventName === "Sales Return Process") {
            dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, (eventData) => {
              if (eventData?.approvalGranted) {
                setSelectedProductInCart({});
                openPaymentModalByCustomer(cart);
                setShowPaymentMethods(true);
                if (CWHardwareController) {
                  CWPoleDisplay(cart, "Total to pay");
                } else {
                  PoleDisplay(cart, "Total to pay");
                }
              }
            });
          }
        });
      } else if (localCart.items.length > 0) {
        setSelectedProductInCart({});
        openPaymentModalByCustomer(cart);
        setShowPaymentMethods(true);
        if (CWHardwareController) {
          CWPoleDisplay(cart, "Total to pay");
        } else {
          PoleDisplay(cart, "Total to pay");
        }
      }
      let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
      };

      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
    } catch (error) {
      console.error("Error handling cart total:", error);
    }
  };

  // const filterPaymentsBySaleType = (paymentMethods, id) => {
  //   const saleTypeId = id || selectedSaleTypeData?.cwrSaletype?.cwrSaletypeId;
  //   if (!saleTypeId) return paymentMethods; // If saleTypeId is null or falsy, return all payment methods

  //   return paymentMethods.filter(({ salesType }) => Array.isArray(salesType) && salesType.some(({ cwrSaletypeId }) => cwrSaletypeId === saleTypeId));
  // };

  const filterPaymentsBySaleType = (paymentMethods, id) => {
    const saleTypeId = id || selectedSaleTypeData?.cwrSaletype?.cwrSaletypeId;
    if (!saleTypeId) return paymentMethods; // If saleTypeId is null or falsy, return all payment methods
    const tillId = tillData.tillAccess?.cwrTill?.cwrTillID;
    return paymentMethods.filter(
      ({ salesType, cwrTillId }) => (!cwrTillId || cwrTillId === tillId) && Array.isArray(salesType) && salesType.some(({ cwrSaletypeId }) => cwrSaletypeId === saleTypeId)
    );
  };
  const getFilteredPaymentMethods = (id) => {
    if (!Array.isArray(tillDataPaymentMethods)) return [];

    const filteredBySaleType = filterPaymentsBySaleType(tillDataPaymentMethods, id);
    const filteredMethods = _.sortBy(
      filteredBySaleType.filter((pm) => {
        const isLoyaltyDisabled = posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty";
        const isNoLoyaltyLevel = !cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty";
        const isNoCredit = !cart?.customer?.iscredit && pm.name === "Credit";
        const isCafeTips = pm.name.toLowerCase() === "cafe tips";
        const loyaltyFlag = tillData?.tillAccess?.csBunit?.enableLoyalty !== "Y" && pm.name === "Loyalty";
        const isNoWallet = !cart?.customer?.cwrWallet?.wallet_Id && pm.name === "Wallet";

        return !(isLoyaltyDisabled || isNoLoyaltyLevel || isNoCredit || isCafeTips || loyaltyFlag || isNoWallet);
        // return pm;
      }),
      "sequenceNo"
    );
    return filteredMethods;
  };

  const filteredPaymentMethods = getFilteredPaymentMethods();

  const initialShowPayments = filteredPaymentMethods.length > 5 ? filteredPaymentMethods.slice(0, 5) : filteredPaymentMethods;
  localStorage.setItem("initialShowPayments", JSON.stringify(initialShowPayments));
  const [isShowingAll, setIsShowingAll] = useState(false);
  const [showPayments, setShowPayments] = useState(initialShowPayments);
  const [startIndex, setStartIndex] = useState(0);
  const [comboBoxPopup, setComboBoxPopup] = useState(false);

  const addDefinedProduct = async (productObjs, upc, batchno, mBatchId, price, checkWeight, modifiedQty, batchedItem, modifiedPrice, scanFlag, data) => {
    const cartObj = JSON.parse(localStorage.getItem("cartObj"));
    if (productObjs?.productSegment === "AD") {
      const isAlreadyInCart = cartObj?.items?.some((item) => item?.value === productObjs?.value);
      if (isAlreadyInCart) {
        message.warning("This advance item is already present in the cart and cannot be added again.");
        return;
      }
    }

    setFilterDrawer(false);
    setIsProductsVisible(false);
    setQtyNumberFlag(0);
    const productObj = { ...productObjs };
    if (productObj.overRideTax === "Y" && price <= productObj.overRideCondition) {
      // prettier-ignore
      const originalPrice = price - (price - (price * (100 / (100 + productObj.taxRate))));
      const taxedPrice = originalPrice + (originalPrice * productObj.contraRate) / 100;
      price = taxedPrice;
      productObj.cTaxId = productObj.contraTaxId;
      productObj.taxRate = productObj.contraRate;
    }
    // let matchedPriceIndex = [];
    // if (!scanFlag) {
    //   if (productObj?.priceList?.length > 0) {
    //     let cartData = JSON.parse(localStorage.getItem("cartObj"));
    //     matchedPriceIndex = productObj?.priceList?.filter((i) => i.sPricelistId === cartData.customer.sPriceListId);
    //     price = matchedPriceIndex[0]?.pricestd || price;
    //     productObj.originalPrice = productObj.sunitprice;
    //     productObj.sunitprice = matchedPriceIndex[0]?.pricestd || productObj.sunitprice;
    //   }
    // }
    if (!scanFlag && productObj?.priceList?.length > 0) {
      const cartData = JSON.parse(localStorage.getItem("cartObj"));
      const selectedPrice = getApplicablePrice({
        priceList: productObj.priceList,
        selectedUomId: productObj.uomData[0]?.csUomId,
        sPriceListId: cartData?.customer?.sPriceListId,
      });

      if (selectedPrice) {
        productObj.originalPrice = productObj.sunitprice;
        productObj.sunitprice = selectedPrice.pricestd;
        price = selectedPrice.pricestd;
      }
    }

    let productDefined = {
      batchno: batchno || null,
      description: productObj?.description || "",
      discount: 0,
      discountName: "",
      imageurl: productObj?.imageurl || "",
      isDecimal: productObj?.isDecimal || false,
      isManualQty: productObj?.isManualQty || false,
      isPromoApplicable: productObj?.isPromoApplicable || false,
      isReturn: false,
      mBatchId: mBatchId || null,
      mPricingruleId: null,
      name: productObj?.name || "",
      name2: productObj?.name2 || "",
      nettotal: 0,
      primaryOrderLine: null,
      productId: productObj?.mProductId || null,
      realPrice: price,
      listPrice: productObj?.slistprice || 0,
      sunitprice: productObj?.sunitprice || 0,
      returnQty: null,
      salePrice: price,
      stock: productObj?.onhandQty || 0,
      tax: productObj?.cTaxId || null,
      taxCategory: productObj?.taxCategory || "",
      taxName: productObj?.taxName || "",
      taxFlag: productObj?.taxFlag || "N",
      taxAmount: 0,
      taxRate: productObj?.taxRate || 0,
      uom: productObj?.csUomId || null,
      uom_name: productObj?.uomName || "",
      uomData: productObj?.uomData || [],
      addNewLine: productObj?.addNewLine || "N",
      customAttributes: productObj?.customAttributes || [],
      preparationTime: productObj?.preparationTime || "",
      cwrPcatalogueId: productObj?.cwrPcatalogueId || null,
      cwrMenuTimeslot: productObj?.cwrMenuTimeslot || [],
      bunitName: productObj?.bunitName || "",
      imageUrl: productObj?.imageUrl || "",
      showAddons: productObj?.showAddons || false,
      foodType: productObj?.foodType || "",
      itemType: productObj?.itemType || "",
      type: productObj?.type || "",
      newCustomAttributes: [],
      priceList: productObj?.priceList || [],
      originalPrice: productObj?.originalPrice || productObj?.sunitprice,
      productSegment: productObj?.productSegment || "",
      selectedAddons: [],
      isDecimalQty: productObj?.uomData?.[0]?.decimal === "Y" ? true : false,
      isQtyDesimal: productObj?.uomData[0]?.stdprecision ?? 2,
      upc: upc || "",
      value: productObj?.value || "",
      weight: 0,
      order: "N",
      productionCenter: productObj?.productionCenter || "",
      productionCenterId: productObj?.productionCenterId || "",
      shortDescription: productObj?.shortDescription || "",
      hsncode: productObj?.hsncode || null,
      csBunitId: productObj?.csBunitId || null,
      mProductCategoryId: productObj?.mProductCategoryId || null,
      productManufacturerId: productObj?.productManufacturerId || null,
      productBrandId: productObj?.productBrandId || null,
      productBrandName: productObj?.productBrandName || null,
      productCategoryName: productObj?.productCategoryName || "",
      productAddons: productObj?.productAddons || [],
      batchedProduct: productObj?.batchedProduct || false,
      batchedForSale: productObj?.batchedForSale || false,
      batchedForStock: productObj?.batchedForStock || false,
      multiPrice: productObj?.multiPrice || false,
      shelfLife: productObj?.shelfLife || "",
      stdTax: productObj?.sunitprice * (1 + productObj?.taxRate / 100),
      posPriceEdit: productObj?.posPriceEdit || "N",
      upcPricingRule: productObj?.upcPricingRule || null,
    };

    let cartItems = JSON.parse(localStorage.getItem("cartObj"))?.items;
    let filterItem = cartItems?.filter((item) => item.productId === productDefined.productId);
    if (filterItem?.length === 1 && filterItem?.selectedAddons?.length <= 0) {
      productDefined.lineId = filterItem[0].lineId;
    }
    let updatedWeight;
    // setSelectedProductInCart(productDefined);
    if (productDefined.isManualQty && posConfig?.showWeightPopup === "Y" && (modifiedQty === 1 || modifiedQty === 0 || !modifiedQty) && data?.length !== 13) {
      // checkIsManualWeight(productDefined);
      setOptions([]);
      setActiveInput("weightPopup");
      const updateProductWithWeight = new Promise((resolve) => {
        dispatchWeight(productDefined, setInputFocused, selectedProductInCart, setSelectedProductInCart, (updatedProduct) => {
          if (updatedProduct) {
            updatedWeight = updatedProduct.weight;
            modifiedQty = updatedProduct.weight;
            resolve(updatedProduct);
          }
        });
      });

      // Await the Promise resolution
      const updatedProductDefined = await updateProductWithWeight;
      setCurrentWeightSelectedProduct(updatedProductDefined);
    }
    setActiveInput("search");
    if (searchInputRef?.current) {
      searchInputRef.current.focus();
    }
    if (checkWeight === true || updatedWeight) {
      let index = cart.items.findIndex((item) => item.value === productDefined.value);
      if (batchedItem === true && !updatedWeight) {
        modifiedQty = cart.items > 0 ? cart.items[index].weight + 1 : 1;
      }
      const productSearchInput = document.getElementById("sm-product-search");
      if (productSearchInput) {
        productSearchInput.blur();
      }
      await addProduct(productDefined, modifiedQty, false, modifiedPrice, false);
      setProductSearchInput("");
      localStorage.removeItem("productName");
      setOptions([]);
      if (productSearchInputRef?.current) {
        productSearchInputRef?.current?.clearInput();
      }
    } else {
      await addProduct(productDefined, 1, false, 0, false);
      setProductSearchInput("");
      localStorage.removeItem("productName");
      setOptions([]);
      if (productSearchInputRef?.current) {
        productSearchInputRef?.current?.clearInput();
      }
    }
  };

  const selectProductToCart = (data) => {
    data.productAddons = data?.productAddons || [];
    data.customAttributes = data?.customAttributes || [];
    data.selectedAddons = data?.selectedAddons || [];
    addProduct(data, 1, false, 0, false);
    setDisplayBatchSelection(false);
  };
  // BARCODE READER BLOCK END

  // PRODUCT WEIGHT MODAL START
  const [displayManualQtyWeightInput, setDisplayManualQtyWeightInput] = useState(false);
  const [productWeightModalInput, setProductWeightModalInput] = useState("");
  const [currentWeightSelectedProduct, setCurrentWeightSelectedProduct] = useState({});
  const [stockList, setStockList] = useState([]);

  const onProductModalChangeWeight = (event) => {
    setProductWeightModalInput(event.target.value);
  };

  const handleWeightManual = (value) => {
    if (productWeightModalInput === "" && value === "x") {
      setProductWeightModalInput("");
    } else if (value === "x") {
      setProductWeightModalInput(`${productWeightModalInput.toString().substring(0, productWeightModalInput.toString().length - 1)}`);
    } else {
      setProductWeightModalInput(`${productWeightModalInput}${value}`);
    }
  };

  const pickProduct = (obj) => {
    if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y") {
      if (obj.mBatch.length === 1) {
        setFilterDrawer(false);
        addDefinedProduct(obj, obj.mBatch[0].upc, obj.mBatch[0].batchno, obj.mBatch[0].mBatchId, obj.mBatch[0].price);
      } else {
        const productSet = [];
        const localObj = obj;
        for (let i = 0; i < obj.mBatch.length; i += 1) {
          const batchItem = { ...localObj.mBatch[i] };
          const obj = { ...localObj };
          if (obj.overRideTax === "Y" && batchItem.price <= obj.overRideCondition) {
            // prettier-ignore
            const originalPrice = batchItem.price - (batchItem.price - (batchItem.price * (100 / (100 + obj.taxRate))));
            const taxedPrice = originalPrice + (originalPrice * obj.contraRate) / 100;
            batchItem.price = taxedPrice;
            obj.cTaxId = obj.contraTaxId;
            obj.taxRate = obj.contraRate;
          }

          const productDefined = {
            batchno: batchItem.batchno,
            description: obj.description || "",
            discount: 0,
            discountName: "",
            imageurl: obj.imageurl || "",
            isDecimal: obj.isDecimal || false,
            isManualQty: obj.isManualQty || false,
            isPromoApplicable: obj.isPromoApplicable || false,
            isReturn: false,
            mBatchId: batchItem?.mBatchId || null,
            mPricingruleId: null,
            name: obj.name || "",
            name2: obj.name2 || "",
            nettotal: 0,
            primaryOrderLine: null,
            productId: obj.mProductId || "",
            realPrice: batchItem.price || 0,
            listPrice: obj.slistprice || 0,
            sunitprice: obj.sunitprice || 0,
            returnQty: null,
            salePrice: batchItem.price || 0,
            originalPrice: obj.sunitprice || 0,
            productSegment: obj?.productSegment || "",
            mrpPrice: batchItem.listPrice || 0,
            stock: obj.onhandQty || 0,
            tax: obj.cTaxId || null,
            taxCategory: obj.taxCategory || "",
            taxName: obj?.taxName || "N",
            productSegment: obj.productSegment || "",
            taxFlag: obj?.taxFlag || "N",
            customAttributes: obj.customAttributes || [],
            preparationTime: obj?.preparationTime || "",
            productionCenterId: obj?.productionCenterId || "",
            cwrPcatalogueId: obj.cwrPcatalogueId || null,
            cwrMenuTimeslot: obj.cwrMenuTimeslot || [],
            bunitName: obj?.bunitName || "",
            imageUrl: obj?.imageUrl || "",
            showAddons: obj?.showAddons || false,
            foodType: obj?.foodType || "",
            itemType: obj?.itemType || "",
            type: obj.type || "",
            newCustomAttributes: [],
            priceList: obj?.priceList || [],
            selectedAddons: [],
            taxAmount: 0,
            taxRate: obj.taxRate || 0,
            uom: obj.csUomId || null,
            uom_name: obj.uomName || "",
            addNewLine: obj?.addNewLine || "N",
            isDecimalQty: obj.uomData?.[0]?.decimal === "Y" || false,
            isQtyDesimal: obj.uomData?.[0]?.stdprecision ?? 2,
            upc: batchItem.upc || null,
            value: obj.value || null,
            weight: 0,
            order: "N",
            shortDescription: obj.shortDescription || "",
            hsncode: obj.hsncode || null,
            csBunitId: obj.csBunitId || null,
            mProductCategoryId: obj.mProductCategoryId || null,
            productManufacturerId: obj.productManufacturerId || null,
            productBrandId: obj.productBrandId || null,
            productBrandName: obj?.productBrandName || null,
            batchedProduct: obj.batchedProduct || "",
            batchedForSale: obj.batchedForSale || "",
            batchedForStock: obj.batchedForStock || "",
            multiPrice: obj.multiPrice || false,
            shelfLife: obj.shelfLife || "",
            stdTax: obj?.sunitprice * (1 + obj?.taxRate / 100),
            posPriceEdit: obj?.posPriceEdit || "N",
          };

          productSet.push(productDefined);
        }
        setFilterDrawer(false);
        setBatchSetAvailable([...productSet]);
        setDisplayBatchSelection(true);
      }
    } else {
      addDefinedProduct(obj, obj.upc, null, null, obj.sunitprice);
    }
  };

  const checkIsManualWeight = (prod) => {
    if (prod.isManualQty && posConfig?.showWeightPopup === "Y") {
      setDisplayManualQtyWeightInput(true);
      setCurrentWeightSelectedProduct(prod);
    } else {
      addProduct(prod, 1, false, 0, false);
    }
  };

  const addManualWeightToProduct = () => {
    let inputValidator = new RegExp(/^[0-9]*$/);
    if (currentWeightSelectedProduct.isDecimal) inputValidator = new RegExp(/^[0-9]\d*(\.\d+)?$/);
    if (inputValidator.test(productWeightModalInput) && parseFloat(productWeightModalInput) > 0) {
      setDisplayManualQtyWeightInput(false);
      addProduct(currentWeightSelectedProduct, productWeightModalInput, false, 0, false);
      setTimeout(() => {
        setProductWeightModalInput("");
        setCurrentWeightSelectedProduct({});
      }, 500);
    } else {
      console.warn("Invalid weight input: ", productWeightModalInput);
      message.warning(`${messages.warnings.cart.invalid_input_value}`);
    }
  };

  // PRODUCT WEIGHT MODAL END

  // PRODUCT FILTER START
  const [isProductsFilter, setIsProductsFilter] = useState(() => (posConfig?.defaultSearchScreen === "Category Search" ? true : false));
  const [allProductCategories, setAllProductCategories] = useState([]);
  const [selectedProductBrand, setSelectedProductBrand] = useState([]);
  const [selectedProductCategory, setSelectedProductCategory] = useState("allProducts");
  const [selectCategotyList, setSelectCategotyList] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const prevProductsListRef = useRef(null);
  const prevHistoryRef = useRef(orderHistoryDetails);
  const [productsCopy, setProductsCopy] = useState([]);
  const hasShownCustomerModalRef = useRef(false);

  const callGetWeightAPI = async (productDefined) => {
    try {
      const response = await Axios({
        url: `${tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl}getWeight`,
        method: "POST",
      });
      const productToUpdate = productDefined && Object.keys(productDefined)?.length > 0 ? productDefined : selectedProductInCart;
      if (response?.data?.Weight) {
        const weight = parseFloat(response.data.Weight.replace("kg", "").trim());
        if (!isNaN(weight)) {
          productToUpdate.weight = weight;
          setSelectedProductInCart(productToUpdate);
        }
      }
    } catch (error) {
      console.error("Error in callGetWeightAPI:", error);
    }
  };

  useEffect(() => {
    db.AllProductCategories.toArray().then((res) => {
      setAllProductCategories(res);
    });
    if (!localStorage.getItem("cartObj")) {
      localStorage.setItem("cartObj", JSON.stringify(cart));
    }
  }, []);

  useEffect(() => {
    getCategoryProducts(selectedProductCategory);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const selectProductCategory = (category) => {
    if (selectedProductCategory !== category) {
      setSelectedProductCategory(category);
    }
  };

  const filterProducts = (brands, categories) => {
    let filteredItems = productsCopy;

    if (brands?.length > 0 || categories?.length > 0) {
      filteredItems = productsCopy.filter(
        (item) => (brands?.length === 0 || brands?.includes(item.brandId)) && (categories?.length === 0 || categories?.includes(item.mProductCategoryId))
      );
    }

    // Update the productsList with filtered items
  };

  // const restaurantProductCategory = async (categorie) => {
  //   await db.products
  //     .where("mProductCategoryId")
  //     .equals(categorie)
  //     .toArray()
  //     .then(async (response) => {
  //       setProductsData(response);
  //     });
  // };

  // Debounced handler for brand checkbox changes
  const debouncedBrandChange = debounce((brandId) => {
    const isSelected = selectedProductBrand?.includes(brandId);
    let updatedSelectedBrands = [];

    if (isSelected) {
      // Brand is already selected, remove it from the selectedProductBrand array
      updatedSelectedBrands = selectedProductBrand?.filter((id) => id !== brandId);
    } else {
      // Brand is not selected, add it to the selectedProductBrand array
      let tempBrand = selectedProductBrand || [];
      updatedSelectedBrands = [...tempBrand, brandId];
    }

    setSelectedProductBrand(updatedSelectedBrands || []); // Ensure it's always an array

    // Filter products based on selected brands and categories
    filterProducts(updatedSelectedBrands || [], selectCategotyList);
  }, 300);

  const handleBrandCheckboxChange = (brandId) => {
    debouncedBrandChange(brandId);
  };

  // Debounced handler for category checkbox changes
  const debouncedCategoryChange = debounce((checkedValues) => {
    setSelectCategotyList(checkedValues);
    // Filter products based on selected brands and categories
    filterProducts(selectedProductBrand, checkedValues);
  }, 300); // Adjust debounce delay as needed
  const handleCategoryCheckboxChange = (checkedValues) => {
    debouncedCategoryChange(checkedValues);
  };

  const handleSelectProduct = () => {
    prevProductsListRef.current = [];
    const lowerCaseSearchInput = productSearchInput.toLowerCase();
    const filteredProducts = productsCopy.filter(
      (product) =>
        product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
        product?.batchIndex === lowerCaseSearchInput ||
        product?.upcIndex === lowerCaseSearchInput ||
        product?.value === lowerCaseSearchInput ||
        product?.upc === lowerCaseSearchInput
    );
    if (filteredProducts.length === 0) {
      {
        message.info(`${t("product_search_category_error")}`);
      }
    } else {
    }
  };

  useEffect(() => {
    if (selectedProductCategory !== "all") {
      getCategoryProducts();
    }
  }, [selectedProductCategory]);

  const getMoreProducts = () => {
    if (productSearchInput === "") {
      getCategoryProducts(selectedProductCategory);
    }
  };

  const getCategoryProducts = () => {
    // if (selectedProductCategory === "allProducts") {
    //   db.products.toArray().then((productsFetched) => {
    //     const additionalProductsFetched = productsList.concat(productsFetched);
    //     additionalProductsFetched.map((ele) => {
    //       cart.items.map((item) => {
    //         if (ele.mProductId === item.productId) {
    //           ele.selected = "Y";
    //         }
    //       });
    //     });
    //     setProductsList([...additionalProductsFetched.slice(0, 50)]);
    //     setProductsCopy([...additionalProductsFetched]);
    //   });
    // } else {
    //   db.products
    //     .where("mProductCategoryId")
    //     .equalsIgnoreCase(selectedProductCategory)
    //     .offset(productsList.length)
    //     .limit(50)
    //     .toArray()
    //     .then((productsFetched) => {
    //       const additionalProductsFetched = productsList.concat(productsFetched);
    //       setProductsList([...additionalProductsFetched]);
    //     });
    // }
  };
  // PRODUCT FILTER END

  // PRODUCT SEARCH START
  const [isSearchProducts, setIsSearchProducts] = useState(() =>
    posConfig?.defaultSearchScreen === "Product Search" || posConfig?.defaultSearchScreen === "Category Search" || posConfig?.defaultSearchScreen === undefined ? true : false
  );
  const [isProductsVisible, setIsProductsVisible] = useState(false);
  const [productSearchInput, setProductSearchInput] = useState("");
  const [numb, setNumb] = useState(0);
  const [qtyNumberFlag, setQtyNumberFlag] = useState(0);

  const getSearchedProducts = () => {
    db.products
      .filter((product) => product.isactive === true)
      .filter(
        (product) =>
          (typeof product.name === "string" && product.name.toLowerCase().includes(productSearchInput.toLowerCase())) ||
          (typeof product.value === "string" && product.value.toLowerCase() === productSearchInput.toLowerCase())
      )
      .limit(100)
      .toArray()
      .then((productsFetched) => {
        if (productsFetched.length > 1) {
          setProductsData(productsFetched);
          setIsProductsVisible(true);
        } else if (productsFetched.length === 1) {
          const obj = productsFetched[0];

          if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y") {
            if (Array.isArray(obj.mBatch) && obj.mBatch.length > 0) {
              const batchProductIndex = obj.mBatch.findIndex((bp) => bp.batchno.toLowerCase() === productSearchInput.toLowerCase());

              if (batchProductIndex >= 0 && obj.multiPrice === "N") {
                const batchItem = obj.mBatch[batchProductIndex];
                addDefinedProduct(obj, batchItem.upc || "", batchItem.batchno || "", batchItem.mBatchId || "", batchItem.price || 0);
                setNumb(0);
                paymentModalInputRef.current?.focus();
              } else if (obj.mBatch.length === 1) {
                const batchItem = obj.mBatch[0];
                addDefinedProduct(obj, batchItem.upc || "", batchItem.batchno || "", batchItem.mBatchId || "", batchItem.price || 0);
                paymentModalInputRef?.current?.focus();
                setNumb(0);
              } else {
                const productSet = [];
                const localObj = obj;

                for (let i = 0; i < obj.mBatch.length; i += 1) {
                  const batchItem = { ...localObj.mBatch[i] };
                  const newObj = { ...localObj };

                  if (newObj.overRideTax === "Y" && batchItem.price <= newObj.overRideCondition) {
                    const originalPrice = batchItem.price - (batchItem.price - batchItem.price * (100 / (100 + newObj.taxRate)));
                    const taxedPrice = originalPrice + (originalPrice * newObj.contraRate) / 100;
                    batchItem.price = taxedPrice;
                    newObj.cTaxId = newObj.contraTaxId;
                    newObj.taxRate = newObj.contraRate;
                  }

                  const productDefined = {
                    batchno: batchItem.batchno || null,
                    description: newObj.description || "",
                    discount: 0,
                    discountName: "",
                    imageurl: newObj.imageurl || "",
                    isDecimal: newObj.isDecimal || false,
                    isManualQty: newObj.isManualQty || false,
                    isPromoApplicable: newObj.isPromoApplicable || false,
                    isReturn: false,
                    mBatchId: batchItem.mBatchId || null,
                    mPricingruleId: null,
                    name: newObj.name || "",
                    name2: newObj.name2 || "",
                    nettotal: 0,
                    primaryOrderLine: null,
                    productId: newObj.mProductId || null,
                    realPrice: newObj.sunitprice || 0,
                    listPrice: newObj.slistprice || 0,
                    sunitprice: newObj.sunitprice || 0,
                    returnQty: null,
                    salePrice: newObj.sunitprice || 0,
                    originalPrice: newObj.sunitprice || 0,
                    productSegment: newObj?.productSegment || "",
                    mrpPrice: batchItem.listPrice || 0,
                    stock: newObj.onhandQty || 0,
                    taxCategory: newObj.taxCategory || "",
                    taxName: newObj?.taxName || "",
                    taxFlag: newObj?.taxFlag || "N",
                    tax: newObj.cTaxId || null,
                    taxAmount: 0,
                    taxRate: newObj.taxRate || 0,
                    uom: newObj.csUomId || null,
                    customAttributes: newObj.customAttributes || {},
                    preparationTime: newObj?.preparationTime || "",
                    productionCenterId: newObj?.productionCenterId || "",
                    cwrPcatalogueId: newObj.cwrPcatalogueId || null,
                    cwrMenuTimeslot: newObj.cwrMenuTimeslot || {},
                    bunitName: newObj?.bunitName || "",
                    imageUrl: newObj?.imageUrl || "",
                    showAddons: newObj?.showAddons || false,
                    foodType: newObj?.foodType || "",
                    itemType: newObj?.itemType || "",
                    type: newObj.type || "",
                    addNewLine: newObj?.addNewLine || "N",
                    newCustomAttributes: [],
                    priceList: newObj?.priceList || [],
                    selectedAddons: [],
                    uom_name: newObj.uomName || "",
                    isDecimalQty: newObj?.uomData?.[0]?.decimal === "Y" || false,
                    isQtyDesimal: newObj?.uomData?.[0]?.stdprecision ?? 2,
                    upc: batchItem.upc || null,
                    value: newObj.value || null,
                    weight: 0,
                    shortDescription: newObj.shortDescription || "",
                    hsncode: newObj.hsncode || null,
                    csBunitId: newObj.csBunitId || null,
                    mProductCategoryId: newObj.mProductCategoryId || null,
                    productManufacturerId: newObj.productManufacturerId || null,
                    productBrandId: newObj.productBrandId || null,
                    productBrandName: newObj?.productBrandName || null,
                    batchedProduct: newObj.batchedProduct || "N",
                    batchedForSale: newObj.batchedForSale || "N",
                    batchedForStock: newObj.batchedForStock || "N",
                    multiPrice: newObj.multiPrice || "N",
                    shelfLife: newObj.shelfLife || "",
                    stdTax: newObj?.sunitprice * (1 + newObj?.taxRate / 100),
                    posPriceEdit: newObj?.posPriceEdit || "N",
                  };

                  productSet.push(productDefined);
                }

                setBatchSetAvailable([...productSet]);
                setDisplayBatchSelection(true);
              }
            }
          } else {
            addDefinedProduct(obj, obj.upc || "", null, null, obj.sunitprice || 0);
            paymentModalInputRef?.current?.focus();
            setProductSearchInput("");
            localStorage.removeItem("productName");
            setOptions([]);
            if (productSearchInputRef?.current) {
              productSearchInputRef?.current?.clearInput();
            }
            setNumb(0);
          }
        } else {
          message.warning(`${t("product_search_error")}`);
        }
      });
  };

  const kioskFilteredProducts = (filter) => {
    db.products
      .filter((product) => product.isactive === true)
      .limit(100)
      .toArray()
      .then((productsFetched) => {
        if (productsFetched.length > 1) {
          let filteredData = [];
          productsFetched.forEach((item) => {
            const itemName = item.name[0].toUpperCase();

            if (filter.includes("-")) {
              const filters = filter.split("-");
              const start = filters[0];
              const end = filters[filters.length - 1];

              if (itemName >= start && itemName <= end) {
                filteredData.push(item);
              }
            } else if (itemName === filter) {
              filteredData.push(item);
            }
          });

          setIsProductsVisible(true);

          if (filter === "All") {
            // setProductsList([...productsFetched]);
          } else {
            // setProductsList([...filteredData]);
          }
        }
      });
  };

  const getSearchedItem = () => {
    db.products
      .where("name")
      .startsWithIgnoreCase(productSearchInput)
      .or("batchIndex")
      .equalsIgnoreCase(productSearchInput)
      .or("upcIndex")
      .equalsIgnoreCase(productSearchInput)
      .or("value")
      .equalsIgnoreCase(productSearchInput)
      .and((product) => product.isactive === true) // ✅ use AND, not filter
      .limit(100)
      .toArray()
      .then((product) => {
        if (product.length > 0) {
          const obj = product[0] || {};
          const mBatch = obj.mBatch || [];
          const uomData = obj.uomData || [{}];

          const defaultPrice = obj.sunitprice || 0;

          if (obj.batchedProduct === "Y" && obj.batchedForSale === "Y") {
            const batchProductIndex = mBatch.findIndex((bp) => bp.batchno?.toLowerCase() === (productSearchInput || "").toLowerCase());
            if (batchProductIndex >= 0 && obj.multiPrice === "N") {
              addDefinedProduct(
                obj,
                mBatch[batchProductIndex]?.upc || "",
                mBatch[batchProductIndex]?.batchno || "",
                mBatch[batchProductIndex]?.mBatchId || "",
                mBatch[batchProductIndex]?.price || 0
              );
            } else if (mBatch.length === 1) {
              addDefinedProduct(obj, mBatch[0]?.upc || "", mBatch[0]?.batchno || "", mBatch[0]?.mBatchId || "", mBatch[0]?.price || 0);
            } else {
              const productSet = [];
              for (let i = 0; i < mBatch.length; i++) {
                const batchItem = { ...mBatch[i] };
                const productDefined = {
                  batchno: batchItem.batchno || null,
                  description: obj.description || "",
                  discount: 0,
                  discountName: "",
                  imageurl: obj.imageurl || "",
                  isDecimal: obj.isDecimal || false,
                  isManualQty: obj.isManualQty || false,
                  isPromoApplicable: obj.isPromoApplicable || false,
                  isReturn: false,
                  mBatchId: batchItem.mBatchId || null,
                  mPricingruleId: null,
                  name: obj.name || "",
                  name2: obj.name2 || "",
                  nettotal: 0,
                  primaryOrderLine: null,
                  productId: obj.mProductId || null,
                  realPrice: obj.sunitprice || 0,
                  listPrice: obj.slistprice || 0,
                  sunitprice: obj.sunitprice || 0,
                  originalPrice: obj.sunitprice || 0,
                  productSegment: obj?.productSegment || "",
                  returnQty: null,
                  salePrice: obj.sunitprice || 0,
                  mrpPrice: batchItem.listPrice || 0,
                  stock: obj.onhandQty || 0,
                  taxCategory: obj.taxCategory || "",
                  taxName: obj?.taxName || "",
                  taxFlag: obj?.taxFlag || "N",
                  tax: obj.cTaxId || null,
                  taxAmount: 0,
                  taxRate: obj.taxRate || 0,
                  uom: obj.csUomId || null,
                  customAttributes: obj.customAttributes || {},
                  preparationTime: obj?.preparationTime || "",
                  productionCenterId: obj?.productionCenterId || "",
                  cwrPcatalogueId: obj.cwrPcatalogueId || null,
                  cwrMenuTimeslot: obj.cwrMenuTimeslot || {},
                  bunitName: obj?.bunitName || "",
                  imageUrl: obj?.imageUrl || "",
                  showAddons: obj?.showAddons || false,
                  foodType: obj?.foodType || "",
                  itemType: obj?.itemType || "",
                  type: obj.type || "",
                  addNewLine: obj.addNewLine || "N",
                  newCustomAttributes: [],
                  priceList: obj?.priceList || [],
                  selectedAddons: [],
                  uom_name: obj.uomName || "",
                  isDecimalQty: uomData[0]?.decimal === "Y" || false,
                  isQtyDesimal: uomData[0]?.stdprecision ?? 2,
                  upc: batchItem.upc || null,
                  value: obj.value || null,
                  weight: 0,
                  shortDescription: obj.shortDescription || "",
                  hsncode: obj.hsncode || null,
                  csBunitId: obj.csBunitId || null,
                  mProductCategoryId: obj.mProductCategoryId || null,
                  productManufacturerId: obj.productManufacturerId || null,
                  productBrandId: obj.productBrandId || null,
                  productBrandName: obj?.productBrandName || null,
                  batchedProduct: obj.batchedProduct || "",
                  batchedForSale: obj.batchedForSale || "",
                  batchedForStock: obj.batchedForStock || "",
                  multiPrice: obj.multiPrice || "",
                  shelfLife: obj.shelfLife || "",
                  stdTax: obj?.sunitprice * (1 + obj?.taxRate / 100),
                  posPriceEdit: obj?.posPriceEdit || "N",
                };
                productSet.push(productDefined);
              }
              setBatchSetAvailable([...productSet]);
              setDisplayBatchSelection(true);
            }
          } else {
            addDefinedProduct(obj, obj.upc || "", null, null, defaultPrice);
          }
        } else {
          message.warning(`${t("product_search_error")}`);
        }
      });
  };

  const clearProductSearchResults = () => {
    setProductSearchInput("");
    setOptions([]);
    if (keyboard.current) {
      keyboard.current.setInput("");
    }
    localStorage.removeItem("productName");
  };

  const productListCardRef = useRef(null);

  const closeProductPanel = () => {
    const productSearchInput = document.getElementById("sm-product-search");
    productSearchInput.focus();
    setIsSearchProducts(false);
    setIsProductsVisible(false);
    setIsProductsFilter(false);
    setProductSearchInput("");
    clearProductSearchResults();
    setProductsData([]);
    localStorage.removeItem("productName");
  };
  // PRODUCT SEARCH END

  const cartRef = useRef();
  useEffect(() => {
    let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
    cartRef.current = { ...cart };
    if (cart.items.length === 0) {
      cart.couponInput = [];
      cart.discount = 0;
      cart.payments = [];
      cart.paid = 0;
      cart.giftCardRefId = null;
      cart.totalBillDicount = null;
      setOverPayedAmount(0);
      setSelectedProductInCart({});
      // setCustomMixItems([]);
      setGroupQty(1);
      setShowPaymentMethods(false);
      setCart(cart);
    }
    let PaymentMethods = getFilteredPaymentMethods() || [];
    const isPreOrderPage = window.location.pathname.includes("/preorder");
    const advanceItem = cart.items.find((item) => item.type === "S" && item.weight > 0 && item.productSegment === "AD");
    if (
      cart.layAway === "Y" &&
      cart?.docType === "Advance" &&
      !advanceItem &&
      posConfig?.allowLayawaywithoutPayment !== "Y" &&
      cart.items.some((item) => item.type !== "S" && item?.productSegment !== "AD")
    ) {
      PaymentMethods = [
        ...PaymentMethods,
        ...(posConfig?.enablePreOrder !== "Y"
          ? [
              {
                cWRPaymentMethodID: "",
                sequenceNo: 9999,
                finPaymentmethodId: "",
                finFinancialAccountId: "",
                finDayCloseAccountId: null,
                name: "Complete Order",
                integratedPayment: false,
                isloyalty: false,
                paymentProvider: null,
                iscredit: false,
                isGiftCard: false,
                isDefault: "N",
                csCurrencyId: "",
                isoCode: "AED",
                isactive: true,
                salesType: [],
              },
            ]
          : []),
      ];
      let payments =
        PaymentMethods.length > 5
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
            )
          : PaymentMethods;
      setShowPayments(payments);
      setStartIndex(cart.layAway === "Y" && payments.length >= 5 ? 5 : payments.length);
    } else if (isPreOrderPage) {
      const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
      const maxPaymentsToShow = isRefundScenario ? 3 : 4;
      let payments =
        PaymentMethods.length > maxPaymentsToShow
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
                ? maxPaymentsToShow
                : cart.layAway === "Y"
                  ? maxPaymentsToShow
                  : maxPaymentsToShow
            )
          : PaymentMethods;
      setShowPayments(payments);
      setStartIndex(cart.layAway === "Y" && payments.length >= maxPaymentsToShow ? maxPaymentsToShow : payments.length);
    } else {
      let payments =
        PaymentMethods.length > 5
          ? _.sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
            )
          : PaymentMethods;
      setShowPayments(payments);
      setStartIndex(cart.layAway === "Y" && payments.length >= 5 ? 5 : payments.length);
    }

    // adjustDiscount(cartObj);
  }, [cart, selectedSaleType]);

  const adjustDiscount = (cartObj) => {
    if (cartObj.items.length > 0 && cartObj.total > 0) {
      let cartTotal = cartObj.items.reduce((sum, item) => sum + item.nettotal + item.discount, 0);

      let newCartTotal = parseFloat(parseFloat(cartObj.total)?.toFixed(precision)) + parseFloat(parseFloat(cartObj.discount)?.toFixed(precision));

      if (parseFloat(parseFloat(newCartTotal)?.toFixed(precision)) !== parseFloat(parseFloat(cartTotal)?.toFixed(precision))) {
        let adjustAmount = newCartTotal - cartTotal;

        let lastDiscountedItemIndex = [...cartObj.items].reverse().findIndex((item) => item.discount > 0);
        if (lastDiscountedItemIndex !== -1) {
          let indexToUpdate = cartObj.items.length - 1 - lastDiscountedItemIndex;

          let updatedItems = [...cartObj.items];
          updatedItems[indexToUpdate].discount = parseFloat(parseFloat(updatedItems[indexToUpdate].discount - adjustAmount)?.toFixed(precision));
          updatedItems[indexToUpdate].nettotal = parseFloat(parseFloat(updatedItems[indexToUpdate].nettotal + adjustAmount)?.toFixed(precision));

          let updatedCart = {
            ...cartObj,
            items: updatedItems,
            discount: cartObj.discount - adjustAmount,
          };
          setCart(updatedCart);
          localStorage.setItem("cartObj", JSON.stringify(updatedCart));
        }
      }
    }
  };

  // dynamic pop up modal start
  const [dynamicForm, setDynamicForm] = useState(false);
  const [dynamicModalForm] = Form.useForm();

  const submitCustomAttributs = (prod) => {
    const productObj = { ...prod };

    addProductToCart(
      productObj,
      productObj.qty,
      false,
      cart,
      setCart,
      setSelectedProductInCart,
      deleteCart,
      processTotalManualDiscount,
      setLoader,
      salesRepresentDefaultLine,
      tillData,
      cartRef,
      productsCopy,
      salesRepresent,
      orderType,
      processBillDiscounts,
      undefined,
      setSelectedRowKeys,
      setOrderTimeDetails,
      setDisplayAddOnSelection,
      displayAddOnSelection,
      handleAddOnModal,
      manualDiscountTypes,
      CheckoutFlatDiscount,
      CheckoutPercentageDiscount,
      CheckoutTotalManualDiscount,
      setProductStock,
      selectedProductInCart,
      setTableCards,
      dispatchItemSelection,
      searchInputRef,
      false,
      setShowCompleteSaleStock,
      setCompleteSaleStockData,
      TotalBillDiscount,
      tillLayout,
      false
    );
    setSelectedAddons([]);
  };

  const addProduct = async (addToCart, qty, totalQtyFlag, modifiedPrice, deleteProductInCart, quantityChange) => {
    setStockList([]);
    const cart = JSON.parse(localStorage.getItem("cartObj")) || { ...cartRef.current };
    if (cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
      message.info("This order cannot be edited!");
    } else {
      if (cart?.preOrder === "Y") {
        Modal.confirm({
          title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
          content: (
            <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em" }}>
                This is a pre-order with advance payment. Cart items cannot be modified at this stage. Please proceed to complete the transaction.
              </p>
            </div>
          ),
          icon: null,
          icon: <WarningOutlined />,
          okText: "Ok",
          cancelButtonProps: { style: { display: "none" } },
          autoFocusButton: null,
          modalRender: (node) => <div className="custom-confirm-modal-wrapper">{node}</div>,

          onOk() {
            const productSearchInput = document.getElementById("sm-product-search");
            if (productSearchInput) {
              setTimeout(() => {
                productSearchInput.focus();
              }, 300);
            }
          },
        });

        return;
      }

      if (Object.keys(addToCart).length === 0) {
        return;
      }

      if (!("isBlindReceipt" in cart) || (cart.isBlindReceipt && addToCart.isGiftCard)) {
        // Do nothing
      } else {
        setShowPaymentMethods(false);
      }

      setProductSearchInput("");
      localStorage.removeItem("productName");
      let freeFlag = true;
      if (addToCart.isFree) {
        const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(addToCart.mPricingruleId).toArray();
        const matchingProductIndex = matchingPricingRules[0]?.mPricingXProducts.find((op) => op.mProductId === addToCart.productId);
        freeFlag = matchingProductIndex && addToCart.weight + qty <= matchingProductIndex.quantity;
      }

      const findItemIndex = (condition) =>
        cart?.items?.findIndex(
          (p) =>
            p.productId === addToCart.productId &&
            p.upc === addToCart.upc &&
            p.mBatchId === addToCart.mBatchId &&
            p.isReturn === false &&
            p.lineId === addToCart.lineId &&
            condition(p)
        );

      const addonIndex = findItemIndex((p) => p?.selectedAddons?.length > 0);
      const attributeIndex = findItemIndex((p) => p?.newCustomAttributes?.length > 0);

      let addOnFlag = false;

      if (addToCart?.productAddons?.length > 0 && addToCart.weight + qty !== 0 && qty > 0 && addToCart.showAddons === "Y") {
        if (addonIndex !== -1) {
          addOnFlag = true;
        } else {
          setDisplayAddOnSelection(true);
          handleAddOnModal(addToCart, qty);
        }
      }

      if (addToCart?.customAttributes?.length > 0 && addToCart.weight + qty !== 0 && qty > 0) {
        if (attributeIndex !== -1) {
          addOnFlag = true;
        } else {
          setDynamicForm(true);
          addToCart.qty = qty;
          setSelectedProductInCart(addToCart);
        }
      }

      if (
        freeFlag &&
        (addToCart?.productAddons?.length <= 0 || addToCart.weight + qty === 0 || qty < 0 || addOnFlag || addToCart.showAddons !== "Y") &&
        (addToCart?.customAttributes?.length <= 0 || addToCart.weight + qty === 0 || qty < 0 || addOnFlag)
      ) {
        await addProductToCart(
          addToCart,
          qty,
          totalQtyFlag,
          cart,
          setCart,
          setSelectedProductInCart,
          deleteCart,
          processTotalManualDiscount,
          setLoader,
          salesRepresentDefaultLine,
          tillData,
          cartRef,
          productsCopy,
          salesRepresent,
          orderType,
          processBillDiscounts,
          modifiedPrice,
          setSelectedRowKeys,
          setOrderTimeDetails,
          setDisplayAddOnSelection,
          displayAddOnSelection,
          handleAddOnModal,
          manualDiscountTypes,
          CheckoutFlatDiscount,
          CheckoutPercentageDiscount,
          CheckoutTotalManualDiscount,
          setProductStock,
          selectedProductInCart,
          setTableCards,
          dispatchItemSelection,
          searchInputRef,
          deleteProductInCart,
          setShowCompleteSaleStock,
          setCompleteSaleStockData,
          TotalBillDiscount,
          tillLayout,
          quantityChange
        );
      }
    }
  };

  const modifyProductList = async () => {
    const result = await new Promise((resolve) => {
      const itemsToDispatch = selectedProductInCart;
      dispatchItemSelection(itemsToDispatch, cart, setCart, setProductStock, (eventData) => {
        if (eventData?.selectedItems?.length > 0) {
          resolve({
            selectedItems: eventData.selectedItems,
          });
        }
      });
    });
    selectedProductInCart.childItems = result?.selectedItems || [];

    setSelectedProductInCart({
      ...selectedProductInCart,
      childItems: result?.selectedItems,
    });

    const cartObj = JSON.parse(localStorage.getItem("cartObj")) || { items: [] };
    const updatedCartItems = cartObj.items.map((cartItem) => {
      if (cartItem.productId === selectedProductInCart.productId || cartItem.value === selectedProductInCart.value) {
        return {
          ...cartItem,
          childItems: result?.selectedItems,
        };
      }
      return cartItem;
    });

    localStorage.setItem(
      "cartObj",
      JSON.stringify({
        ...cartObj,
        items: updatedCartItems,
      })
    );
    setCart({
      ...cartObj,
      items: updatedCartItems,
    });
  };

  const [documentSequence, setDocumnetSequence] = useState(tillDocumentSequence);
  //   const [orderDelay, setOrderDelay] = useState(moment().format("DD-MM-YYYY HH:mm:ss"));
  const [orderDelay, setOrderDelay] = useState(moment().format("YYYY-MM-DD HH:mm:ss"));
  const [activeOrderProcess, setActiveOrderProcess] = useState(false);
  const orderState = useRef(0);

  const processOrder = async (param) => {
    orderState.current += 1;
    if (orderState.current === 1 && cart.items.length !== 0 && posConfig?.disableOfflineBilling !== "Y") {
      processOrderApproved(param);
    } else if (orderState.current === 1 && cart.items.length !== 0 && posConfig?.disableOfflineBilling === "Y") {
      await syncOrders();
    } else {
      setPaymentModal(false);
    }
  };

  const loyaltyDateValidator = (sDate, eDate, cDate) => {
    const startDate = sDate ? moment(sDate) : moment("2000-01-01");
    const endDate = eDate ? moment(eDate) : moment();
    const currentDate = cDate ? moment(cDate) : moment();

    return currentDate.isSameOrAfter(startDate, "day") && currentDate.isSameOrBefore(endDate, "day");
  };

  const processOrderApproved = async (param, documentNo, isSynced) => {
    setSelectedPaymentMethod({}); // Reset payment method
    if (activeOrderProcess) return; // Early return if already processing

    // Batch initial state updates
    setOverPayedAmount(0);
    setAmount(0);
    setActiveOrderProcess(true);

    // Create a deep copy of cart to avoid modifying state directly
    const cartToDb = JSON.parse(JSON.stringify(cart));
    //const newDocumentSequence = cart?.statusType === "OCU" && posConfig?.enableGuestRegistration === "Y" ? documentSequence : documentSequence + 1;
    const newDocumentSequence =
      cart?.statusType === "OCU" && (posConfig?.enableGuestRegistration === "Y" || posConfig?.enableGuestRegistration === "N") ? documentSequence : documentSequence + 1;
    const tillSession = JSON.parse(localStorage.getItem("tillSession")) || {};
    const tillSessionId = tillSession.tillSessionId || null;

    // Process payment and layaway logic
    if (param !== "layaway") {
      cartToDb.layAway = cart.layAway === "Y" ? "Y" : "N";
      // const change = cartToDb.paid - Math.abs(cartToDb.total);
      const change = cartToDb.change;
      const isPreOrderPage = window.location.pathname.includes("/preorder");

      if (cart.items.some((it) => it.isReturn) && cartToDb.total === 0) {
        cartToDb.change = 0;
        const paymentType =
          selectedPaymentMethod.name?.toLowerCase() === "cash" || selectedPaymentMethod.name?.toLowerCase() === "card" ? selectedPaymentMethod.name.toLowerCase() : "cash";
        const pMindex = tillDataPaymentMethods.findIndex((pi) => pi.name.toLowerCase() === paymentType);
        cartToDb.payments.push({
          ...tillDataPaymentMethods[pMindex],
          amount: Number(cart.total) || 0,
        }); // Minimal copy
      } else if (amount < 0 && cart.layAway === "Y" && cart?.type === "Layaway" && isPreOrderPage) {
        cartToDb.payments.push({ ...selectedPaymentMethod, amount });
      } else {
        cartToDb.change = parseFloat(parseFloat(change)?.toFixed(precision));
      }

      if (cart.isReturn === true || cart.isReturn === "Y") {
        for (let i = 0; i < cartToDb.payments.length; i++) {
          cartToDb.payments[i].amount *= -1; // Update in place
        }
      }
    } else {
      cartToDb.layAway = "Y";
      if (selectedPaymentMethod?.name) {
        const pMindex = cartToDb.payments.findIndex((pi) => pi.name.toLowerCase() === selectedPaymentMethod.name.toLowerCase());
        if (pMindex !== -1) {
          cartToDb.payments[pMindex].amount += amount; // Update in place
        } else {
          cartToDb.payments.push({ ...selectedPaymentMethod, amount }); // Minimal copy
        }
      }
    }

    // Loyalty points calculation
    // if (cartToDb.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
    //   const loyaltyLevelId = cartToDb.customer.loyaltyLevel.cwrLoyaltyLevelId;
    //   const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();
    //   if (loyaltyData) {
    //     const eventCalenders = loyaltyData.loyaltyEventCalenders || [];
    //     const hasValidEventCalenders = eventCalenders.length > 0 ? dateValidator(eventCalenders[0].startDate, eventCalenders[0].endDate) : true;

    //     for (const item of loyaltyData.LoyaltyAccumulation || []) {
    //       const productValidation = item.mProductId ? cart.items.some((pc) => pc.mProductId === item.mProductId) : true;
    //       const categoryValidation = item.mProductCategoryId ? cart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;
    //       const checkEventsCalender =
    //         item.loyaltyEvent === "Y" && eventCalenders.length > 0
    //           ? eventCalenders.some((i) => dateValidator(i.startDate, i.endDate))
    //           : item.loyaltyEvent === "Y" && eventCalenders.length === 0;

    //       if (
    //         (item.loyaltyEvent === "Y" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation && hasValidEventCalenders && checkEventsCalender) ||
    //         (item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation)
    //       ) {
    //         cartToDb.accumulationPoints =
    //           tillData?.tillAccess?.csBunit?.enableLoyalty === "Y"
    //             ? cartToDb?.discount > 0
    //               ? loyaltyData?.noLoyaltyOnDiscount === "Y"
    //                 ? 0
    //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
    //               : cartToDb?.redemptionPoints > 0
    //               ? loyaltyData?.noLoyaltyOnRedemption === "Y"
    //                 ? 0
    //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
    //               : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
    //             : 0;
    //         break;
    //       }
    //     }
    //   }
    // }
    if (cartToDb.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
      const loyaltyLevelId = cartToDb.customer.loyaltyLevel.cwrLoyaltyLevelId;

      const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();

      if (loyaltyData) {
        const eventCalenders = loyaltyData.loyaltyEventCalenders || [];

        // ✅ Check if ANY event calendar is active
        const isEventActive = eventCalenders.length > 0 && eventCalenders.some((ec) => loyaltyDateValidator(ec.startDate, ec.endDate));

        // ✅ Find applicable accumulation rule
        const applicableRule = (loyaltyData.LoyaltyAccumulation || []).find((item) => {
          const productValidation = item.mProductId ? cart.items.some((pc) => pc.mProductId === item.mProductId) : true;

          const categoryValidation = item.mProductCategoryId ? cart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;

          // 🟢 Event active → Promotion only
          if (isEventActive) {
            return item.loyaltyEvent === "Y" && item.name === "Promotion" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation;
          }

          // 🔵 No event → Generic
          return item.loyaltyEvent === "Y" && item.name === "Generic" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation;
        });

        // ✅ Calculate points
        if (applicableRule) {
          const baseAmount = cart.total - cart.tax;

          if (tillData?.tillAccess?.csBunit?.enableLoyalty !== "Y") {
            cartToDb.accumulationPoints = 0;
          } else if (cartToDb.discount > 0 && loyaltyData.noLoyaltyOnDiscount === "Y") {
            cartToDb.accumulationPoints = 0;
          } else if (cartToDb.redemptionPoints > 0 && loyaltyData.noLoyaltyOnRedemption === "Y") {
            cartToDb.accumulationPoints = 0;
          } else {
            cartToDb.accumulationPoints = Number((applicableRule.pointsPerUnit * baseAmount).toFixed(3));
          }
        }
      }
    }

    // Update order details
    const now = moment(new Date());
    const orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
      orderStartTime: "",
      orderEndTime: "",
      paymentStartTime: "",
    };
    orderTimeDetails.orderEndTime = now.format("DD-MM-YYYY HH:mm:ss");
    Object.assign(cartToDb, {
      orderTime: now.format("DD-MM-YYYY HH:mm:ss"),
      createdBy: tillData.tillAccess.csUserId,
      documentno: documentNo
        ? documentNo
        : cart.isRetrived === "Y" || cart.type === "Layaway" || cart.isSplit === "Y" || cart?.statusType === "OCU"
          ? cart.documentno
          : `${tillData.tillAccess.cwrTill.prefix}${newDocumentSequence}`,
      // documentno: cart.documentno,
      orderType: orderType?.cwrSaletype?.cwrSaletypeId,
      orderDate: now.format("DD-MM-YYYY"),
      tillSessionId,
      key: uuidv4().replace(/-/g, "").toUpperCase(),
      isSynced: isSynced ? isSynced : 0,
      syncAttempts: 0,
      giftCardData: [...giftCardData], // Shallow copy to avoid retaining reference
      roundOff: parseFloat(parseFloat(cart.isReturn ? cartToDb.roundOff * -1 : cartToDb.roundOff)?.toFixed(precision)),
      discount: parseFloat(parseFloat(cartToDb.discount)?.toFixed(precision) || 0),
      customerSearchKey: cartToDb.customer?.code,
      orderTimeDetails,
      totalQty: parseFloat(parseFloat(cartToDb.totalQty)?.toFixed(precision) || 0),
      dineIn: localStorage.getItem("dineIn") || "Y",
      typeOrder: localStorage.getItem("homeDelivery") || "N",
      statusType: JSON.parse(localStorage.getItem("cartObj"))?.statusType || "N",
      orderCompleted: cartToDb.statusType === "layAway" ? false : true,
      overPayedAmount: overPayedAmount || 0,
    });

    if (cartToDb.customer) {
      cartToDb.customer.retlLoyaltyBalance = (cartToDb.customer.retlLoyaltyBalance || 0) + (cartToDb.accumulationPoints || 0);
    }

    // Optimize item updates
    for (let i = 0; i < cartToDb.items.length; i++) {
      const item = cartToDb.items[i];
      item.discount = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;
      item.key = i;
      item.nettotal = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));

      if (!item.isGiftCard) {
        let lineTax = item.listPrice * (1 + item.taxRate / 100);
        const stdTax = item.sunitprice * (1 + item.taxRate / 100);
        let unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : lineTax;
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : stdTax;
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + parseFloat(lineTax?.toFixed(precision));

        Object.assign(item, {
          listPrice: taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision)),
          linetax: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(item.taxAmount)?.toFixed(precision)) : 0,
          linenet: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
          linestd: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
          linegross: Math.abs(item.nettotal) > 0 ? item.nettotal : 0,
          netunit: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          listprice: Math.abs(item.nettotal) > 0 ? item.listPrice : 0,
          grossunit: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
          grossstd: Math.abs(item.nettotal) > 0 ? roundTo(grossStd, precision) : 0,
          grosslist: Math.abs(item.nettotal) > 0 ? roundTo(gross_list, precision) : 0,
          grosslist: Math.abs(item.nettotal) > 0 ? gross_list : 0,
          netList: Math.abs(item.nettotal) > 0 ? netList : 0,
          unitPrice: Math.abs(item.nettotal) > 0 ? unitPrice : 0,
          taxAmount: Math.abs(item.nettotal) > 0 ? parseFloat(parseFloat(item.taxAmount)?.toFixed(precision)) : 0,
        });
      }
    }

    // Tax details calculation
    // const taxDetails = [];
    // const taxMap = {};
    // for (const item of cart.items) {
    //   if (!item.isGiftCard) {
    //     const taxRate = item.taxRate;
    //     const taxAmount = parseFloat(item.taxAmount?.toFixed(precision));
    //     const nettotal = parseFloat((item.nettotal - item.taxAmount)?.toFixed(precision));
    //     if (taxMap[taxRate]) {
    //       taxMap[taxRate].taxAmount += taxAmount;
    //       taxMap[taxRate].nettotal += nettotal;
    //     } else {
    //       taxMap[taxRate] = { taxAmount, nettotal, tax: item.tax, taxRate, taxCategory: item.taxCategory, taxName: item.taxName };
    //     }
    //   }
    // }

    const taxDetails = [];
    const taxMap = {};

    for (const item of cart.items) {
      if (!item.isGiftCard) {
        if (item.taxRate >= 0 && item.tax) {
          const taxRate = item.taxRate;
          const taxAmount = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
          const nettotal = parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision));
          if (taxMap[taxRate]) {
            taxMap[taxRate].taxAmount += taxAmount;
            taxMap[taxRate].nettotal += nettotal;
          } else {
            taxMap[taxRate] = {
              taxAmount,
              nettotal,
              tax: item.tax,
              taxRate,
              taxCategory: item.taxCategory,
              taxName: item.taxName,
            };
          }
        }

        // Handle custom mix item (no taxRate on parent)
        if (!item.taxRate && item.children?.length > 0) {
          for (const child of item.children) {
            if (child.taxRate && child.tax) {
              const taxRate = child.taxRate;
              const taxAmount = parseFloat(parseFloat(child.taxAmount)?.toFixed(precision));
              const nettotal = parseFloat(parseFloat(child.nettotal - child.taxAmount)?.toFixed(precision));
              if (taxMap[taxRate]) {
                taxMap[taxRate].taxAmount += taxAmount;
                taxMap[taxRate].nettotal += nettotal;
              } else {
                taxMap[taxRate] = {
                  taxAmount,
                  nettotal,
                  tax: child.tax,
                  taxRate,
                  taxCategory: child.taxCategory,
                  taxName: child.taxName,
                };
              }
            }
          }
        }
      }
    }

    cartToDb.combinedTaxRates = Object.keys(taxMap).map((taxRate) => {
      const entry = taxMap[taxRate];
      taxDetails.push({
        csTaxID: entry.tax,
        taxableAmt: entry.taxAmount,
        taxAmt: entry.nettotal,
        taxRate,
        taxCategory: entry.taxCategory,
        taxName: entry.taxName,
      });
      return { csTaxID: entry.tax, taxableAmt: entry.nettotal, taxAmt: entry.taxAmount };
    });
    cartToDb.taxDetails = taxDetails;

    // Clear temporary references
    localStorage.removeItem("orderTimeDetails");
    setGiftCardData([]);
    setShowPayments(initialShowPayments);
    setSelectedDate(null);

    // Database operations
    await db.orders
      .where("tillSessionId")
      .equals(tillSessionId)
      .toArray(async (orders) => {
        const newOrder = {
          salesTax: [],
          returnTax: [],
          items: [],
          netTotal: 0,
          grossTotal: 0,
          totalTax: 0,
          netReturnTotal: 0,
          grossReturnTotal: 0,
          totaReturnlTax: 0,
          returnsTransactions: 0,
          salesTransactions: 0,
        };
        let orderExists = false;

        if (orders.length > 0) {
          for (let i = 0; i < orders.length; i++) {
            if (orders[i].sOrderID === cartToDb.sOrderID) {
              orders[i] = { ...cartToDb }; // Create a new copy to avoid retaining reference
              orderExists = true;
              break;
            }
          }
          if (!orderExists) orders.push({ ...cartToDb });

          for (const order of orders) {
            await processOrderData(order, newOrder, orders);
          }
        } else {
          await processOrderData({ ...cartToDb }, newOrder, orders);
        }

        await db.ordersData
          .where("tillSessionId")
          .equals(tillSessionId)
          .modify((order) => {
            Object.assign(order, { tillSessionId, tillStatus: "open", ...newOrder });
          });
      });

    async function processOrderData(orderDetails, newOrder, allOrders) {
      const groupedItems = newOrder.items;
      const targetTaxArray = orderDetails.isReturn ? newOrder.returnTax : newOrder.salesTax;

      for (const item of orderDetails.items) {
        const index = groupedItems.findIndex((ele) => ele.value === item.value);
        if (index >= 0) {
          groupedItems[index].taxAmount = +parseFloat(parseFloat(groupedItems[index].taxAmount + item.taxAmount)?.toFixed(precision));
          groupedItems[index].nettotal = +parseFloat(parseFloat(groupedItems[index].nettotal + item.nettotal)?.toFixed(precision));
          groupedItems[index].weight = parseFloat((parseFloat(groupedItems[index].weight) + parseFloat(item.weight))?.toFixed(item?.isQtyDesimal ?? 2));
        } else {
          groupedItems.push({
            taxAmount: +parseFloat(parseFloat(item.taxAmount)?.toFixed(precision)),
            nettotal: +parseFloat(parseFloat(item.nettotal)?.toFixed(precision)),
            weight: parseFloat(parseFloat(item.weight)?.toFixed(item?.isQtyDesimal ?? 2)),
            value: item.value,
            name: item.name,
          });
        }
      }

      for (const newTax of orderDetails.taxDetails || []) {
        const existingTax = targetTaxArray.find((tax) => tax.taxRate === newTax.taxRate);
        if (existingTax) {
          existingTax.taxAmt = +parseFloat(parseFloat(existingTax.taxAmt + newTax.taxAmt)?.toFixed(precision));
          existingTax.taxableAmt = +parseFloat(parseFloat(existingTax.taxableAmt + newTax.taxableAmt)?.toFixed(precision));
        } else {
          targetTaxArray.push({
            csTaxID: newTax.csTaxID,
            taxableAmt: parseFloat(parseFloat(newTax.taxableAmt)?.toFixed(precision)),
            taxAmt: parseFloat(parseFloat(newTax.taxAmt)?.toFixed(precision)),
            taxRate: newTax.taxRate,
            taxCategory: newTax.taxCategory,
            taxName: newTax.taxName,
          });
        }
      }

      const isReturn = orderDetails.isReturn === true || orderDetails.isReturn === "Y";
      const orderIndex = allOrders.findIndex((o) => o.sOrderID === orderDetails.sOrderID);
      if (isReturn) {
        newOrder.returnTax = targetTaxArray;
        newOrder.netReturnTotal = +parseFloat(parseFloat((newOrder.netReturnTotal || 0) + (orderDetails.total - orderDetails.tax))?.toFixed(precision));
        newOrder.grossReturnTotal = +parseFloat(parseFloat((newOrder.grossReturnTotal || 0) + orderDetails.total)?.toFixed(precision));
        newOrder.totaReturnlTax = +parseFloat(parseFloat((newOrder.totaReturnlTax || 0) + orderDetails.tax)?.toFixed(precision));
        newOrder.returnsTransactions += 1;
        upsertPOSLog(orderDetails, "SLR");
      } else {
        newOrder.salesTax = targetTaxArray;
        newOrder.netTotal = +parseFloat(parseFloat((newOrder.netTotal || 0) + (orderDetails.total - orderDetails.tax))?.toFixed(precision));
        newOrder.grossTotal = +parseFloat(parseFloat((newOrder.grossTotal || 0) + orderDetails.total)?.toFixed(precision));
        newOrder.totalTax = +parseFloat(parseFloat((newOrder.totalTax || 0) + orderDetails.tax)?.toFixed(precision));
        newOrder.salesTransactions += 1;
      }

      if (orderIndex !== -1) {
        const advancePayment = parseFloat(orderDetails.advancePayment || 0);
        newOrder.netTotal = +parseFloat(parseFloat(newOrder.netTotal - advancePayment)?.toFixed(precision));
        newOrder.grossTotal = +parseFloat(parseFloat(newOrder.grossTotal - advancePayment)?.toFixed(precision));
      }
    }

    // Payments data update
    await db.paymentsData
      .where("tillSessionId")
      .equals(tillSessionId)
      .modify((event) => {
        const filteredPayments = event.payments.filter((payment) => payment?.cwrTillId === tillId);
        for (const payment of filteredPayments) {
          let currPaymentAmount = 0;
          let currPaymentReturn = 0;
          for (const orderPayment of cart.payments || []) {
            if (payment.name.toLowerCase() === orderPayment.name.toLowerCase()) {
              if (cart.total > 0) {
                currPaymentAmount += parseFloat(orderPayment.amount);
                payment.transactionCount = (payment.transactionCount || 0) + 1;
              } else if (cart.total < 0) {
                currPaymentReturn += parseFloat(Math.abs(orderPayment.amount));
                payment.transactionCount = (payment.transactionCount || 0) + 1;
              }
            }
          }
          payment.expectedAmount = (payment.expectedAmount || 0) + currPaymentAmount;
          payment.amount = (payment.amount || 0) + currPaymentAmount;
          payment.paymentReturn = (payment.paymentReturn || 0) + currPaymentReturn;
          payment.difference = (payment.difference || 0) + payment.expectedAmount;
          payment.change = (payment.change || 0) + cart.change;
        }
        event.payments = filteredPayments;
      });

    setSelectedDocumentType("Invoice");
    setPaymentProcessFlag(false);
    // Final order processing
    try {
      if (cart.type !== "Layaway") {
        await db.orders.add(cartToDb);
      } else {
        await db.orders.put(cartToDb);
      }

      setPaymentModal(false);

      const dineIn = localStorage.getItem("dineIn");
      const isCallCenter = isCallCenterFlow && tillLayout === 2;
      if (dineIn === "Y" && !isCallCenter) {
        let tableData = JSON.parse(localStorage.getItem("tableName")) || {};
        // const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableData.cwrFbTableId).first();
        const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableData?.cwrFbTableId).first();

        if (tableRecord) {
          Object.assign(tableRecord, {
            salesHistory: "Y",
            fbOrderSync: "N",
            tableSync: "N",
            statusType: "OPN",
            fbOrderStatus: "CO",
            color: "#a7c957",
            ordered: "N",
          });

          const fbOrders = await db.fbOrderData.where("cwrFbTableId").equals(tableData.cwrFbTableId).toArray();
          if (!fbOrders || fbOrders.length === 0) {
            const fbOrders = localStorage.getItem("getFBOrderData");
            if (fbOrders) {
              const fbOrdersData = JSON.parse(fbOrders);
              const filteredOrders = Array.isArray(fbOrdersData) ? fbOrdersData.filter((o) => o.fbTableId === tableData.cwrFbTableId) : [];
              if (filteredOrders.length > 0) {
                for (const order of filteredOrders) {
                  const cleanedLines = Array.isArray(order.lines) ? order.lines.map(({ name, value, ...rest }) => rest) : [];
                  const data = {
                    ...order,
                    salesHistory: "Y",
                    fbOrderSync: "N",
                    tableSync: "N",
                    statusType: "OPN",
                    fbOrderStatus: "CO",
                    color: "#a7c957",
                    sOrderID: cart.sOrderID,
                    fbOrderId: order?.fbOrderId,
                    lines: cleanedLines,
                  };
                  await db.fbOrderData.put(data, data.fbOrderId);
                }
              }
            }
          } else {
            for (const fbOrder of fbOrders) {
              if (fbOrder.fbOrderStatus === "IP") {
                Object.assign(fbOrder, {
                  salesHistory: "Y",
                  fbOrderSync: "N",
                  tableSync: "N",
                  statusType: "OPN",
                  fbOrderStatus: "CO",
                  color: "#a7c957",
                  sOrderID: cart.sOrderID,
                });
                await db.fbOrderData.put(fbOrder, fbOrder.fbOrderId);
              }
            }
          }
          await db.tableData.put(tableRecord, tableRecord.cwrFbTableId);
          await SyncData(tableRecord, "upsertTableStatus");
          await SyncData(tableRecord, "upsertFbOrder");
        }
      }

      // Reset state and local storage
      localStorage.setItem("cartObj", "[]");
      if (cart.isRetrived !== "Y" && cart.type !== "Layaway" && splitCarts.length === 0) {
        localStorage.setItem("documentSequence", String(newDocumentSequence));
        setDocumnetSequence(newDocumentSequence);
        deleteCart();
      } else {
        const newCart = {
          items: [],
          couponInput: [],
          advancePayment: 0,
          total: 0,
          tax: 0,
          discount: 0,
          paid: 0,
          change: 0,
          totalQty: 0,
          roundOff: 0,
          payments: [],
          redemptionPoints: 0,
          accumulationPoints: 0,
          creditAmount: 0,
          docType: "Invoice",
          sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
          referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
          giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          customer: selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData.customer : defaultCustomer,
          salesRepId: null,
          cardPaymentData: {},
          documentno: `${tillData.tillAccess.cwrTill.prefix}${documentSequence + 1}`,
          userName: userData.user,
          tillName: tillValue?.name,
          subTotal: 0,
          itemsSummery: {},
          amountInWords: "",
          groupedItemsByTaxRate: {},
          serviceCharge: 0,
          tip: 0,
          deiveryCharge: 0,
          packingCharge: 0,
          others: 0,
        };
        setCart(newCart);
        localStorage.setItem("cartObj", JSON.stringify(newCart));
      }

      setNotesValue("");
      setOrderDelay(now.format("DD-MM-YYYY HH:mm:ss"));
      if (posConfig?.disableOfflineBilling !== "Y") {
        message.success(`Order ${cartToDb.documentno} Created Successfully`);
      }
      hasShownCustomerModalRef.current = false;
      setIsInputFocused(false);
      orderState.current = 0;
      setActiveOrderProcess(false);
      localStorage.removeItem("totalDiscountsCartRef");

      if (cartToDb.giftVoucherType) {
        const { csBunitId, cwrTillId } = tillData.tillAccess;
        const customerId = cartToDb.customer?.cwrCustomerId;
        if (!csBunitId || !cwrTillId || !customerId) {
          console.error("Missing required data for gift voucher generation");
          cartToDb.voucherCode = null;
        } else {
          const query = `
            mutation {
              generateGiftVoucher(
                giftVoucher: {
                  cSBunitID: "${csBunitId}"
                  tillId: "${cwrTillId}"
                  b2cCustomerId: "${customerId}"
                  giftVoucherType: "${cartToDb.giftVoucherType}"
                  voucherAmount: ${cartToDb.giftVoucherAmount || 0}
                }
              ) {
                status
                message
                voucherCode
              }
            }
          `;
          try {
            const response = await generateGiftVoucher(query);
            const gGV = response?.data?.data?.generateGiftVoucher;
            cartToDb.voucherCode = gGV?.status === "200" ? gGV.voucherCode : null;
          } catch (error) {
            console.error("Error in generating gift voucher:", error);
            cartToDb.voucherCode = null;
          }
        }
      }
      if (tillaccess?.layout === "2") cartToDb.orderSelection = orderTypeSelection;
      PrintController(cartToDb, cart);

      const defaultSaleType = await getDefaultSaleType();
      if (defaultSaleType) {
        setSelectedSaleType(defaultSaleType.cwrSaletype.name);
        setSelectedSaleTypeData(defaultSaleType);
        localStorage.setItem("saleTypeData", JSON.stringify(defaultSaleType));

        const cartDetails = JSON.parse(localStorage.getItem("cartObj")) || {};
        cartDetails.customer = defaultSaleType.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer;
        setCart(cartDetails);
        localStorage.setItem("cartObj", JSON.stringify(cartDetails));
      }
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }
      if (tillLayout === 2) {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          history.push("/pos");
        }, 500);
      }
    } catch (error) {
      console.error("Failed to process order:", error);
      setActiveOrderProcess(false); // Ensure flag is reset on error
    }
  };
  //// CART OPERATIONS END ////

  // OFFERS AND DISCOUNTS BLOCK START
  const [offerProductsList, setOfferProductList] = useState();
  const [displayOfferProductSelectiton, setDisplayOfferProductSelection] = useState(false);

  const selectOfferProduct = (product) => {
    const pro = product;
    addProduct(pro, 1, false, 0, false);
    setDisplayOfferProductSelection(false);
    if (tillLayout === 2) {
      setPaymentModal(true);
    }
  };
  // OFFERS AND DISCOUNTS BLOCK START

  //// PAYMENTS BLOCK START ////
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentProcessFlag, setPaymentProcessFlag] = useState(false);
  const [amount, setAmount] = useState("");
  const [overPayedAmount, setOverPayedAmount] = useState(0);
  const [denaminationsKeyboard, setDenaminationsKeyboard] = useState(false);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});

  const [loader, setLoader] = useState(false);

  const onChangeAmount = (event) => {
    let type = "3";
    // let value = event.target.value?.replace(/[^\d.]/g, "");
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, "");
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }
    paymentProcess(type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb);
  };

  const handleAmount = (value) => {
    let type = "1";
    paymentProcess(type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb);
  };

  const showConfirm = () => {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: (
          <>
            <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
          </>
        ),
        icon: null,
        content: (
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "1px solid #fff",
              borderRadius: "7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Bill Amount Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Bill Amount</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Tendered Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Tendered</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(amount).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Received Row */}
            <Row
              style={{
                fontSize: "1em", // Adjust font size for readability
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Received</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Change Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Change Due</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {cart.paid + parseFloat(amount) - Math.abs(cart.total) > 0
                    ? (cart.paid + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                    : cart?.change <= 0
                      ? "0.00"
                      : cart?.change}
                </p>
              </Col>
            </Row>
          </div>
        ),
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        cancelButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the Cancel button
          },
        },
        okButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the OK button
          },
        },
      });
    });
  };

  const handleCashPayment = (value) => {
    let type = "2";
    paymentProcess(type, value, setAmount, amount, cart, tillData, selectedPaymentMethod, setOverPayedAmount, setNumb, numb);
  };

  const [paymentModalByCustomerState, setPaymentModalByCustomerState] = useState(false);

  const openPaymentModal = async () => {
    if (tillLayout === 2) {
      setPaymentModal(true);
    }
    setPaymentProcessFlag(true);
    openPaymentModalByCustomer();
  };

  const openPaymentModalByCustomer = (cartObj) => {
    paymentModalInputRef?.current?.select();
    paymentModalInputRef?.current?.focus();
    const cartData = cartObj ? { ...cartObj } : cart;
    localStorage.setItem("totalDiscountsCartRef", JSON.stringify(cartData));
    setPaymentModalByCustomerState(false);
    if (cartData?.items?.length > 0) {
      db.pricingRules.toArray().then((pr) => {
        const pricingRuleCount = pr.length;
        if (pricingRuleCount > 0) {
          pr.sort((a, b) => {
            if (a.priority === null && b.priority === null) {
              return 0;
            } else if (a.priority === null) {
              return 1;
            } else if (b.priority === null) {
              return -1;
            }
            return parseInt(a.priority, 10) - parseInt(b.priority, 10);
          });
          for (let i = 0; i < pricingRuleCount; i++) {
            const pricingRule = pr[i];
            if (dateValidator(pricingRule.startDate, pricingRule.endDate) && pricingRule.iscoupon === "N" && (pricingRule.type === "TD" || pricingRule.type === "TDF")) {
              if (pricingRule.timeSpecific === "Y") {
                const weekDay = currentDay();
                const pStartTime = pricingRule.starttime.substring(11);
                const pEndTIme = pricingRule.endtime !== null ? pricingRule.endtime.substring(11) : moment(new Date()).format("DD-MM-YYYY HH:mm:ss").substring(11);
                const starttime = timeStamp().substring(0, 10) + " " + pStartTime;
                const endtime = timeStamp().substring(0, 10) + " " + pEndTIme;
                if (timeValidator(starttime, endtime) && pricingRule[weekDay] === "Y") {
                  processBillDiscounts(pricingRule, cartData, false);
                }
              } else {
                processBillDiscounts(pricingRule, cartData, false);
              }
            }
          }
        }
      });
    }
  };

  const processBillDiscounts = (pricingRule, cartObj, iscoupon, couponInput, uniqReferenceId, mPricingCouponId, mPricingRulesId) => {
    if (pricingRule.type === "TD" && (pricingRule.manualDiscount === "N" || pricingRule.manualDiscount === null)) {
      let updatedCart = TotalBillDiscount(pricingRule, setCart, cart, orderType, cartObj, iscoupon, couponInput, uniqReferenceId, mPricingCouponId, mPricingRulesId);
      return updatedCart;
    }

    if (pricingRule.type === "TDF" && (pricingRule.manualDiscount === "N" || pricingRule.manualDiscount === null)) {
      let updatedCart = TotalBillFreeProductDiscount(
        pricingRule,
        setCart,
        cart,
        orderType,
        cartObj,
        addProduct,
        setOfferProductList,
        setDisplayOfferProductSelection,
        iscoupon,
        couponInput,
        uniqReferenceId,
        mPricingCouponId,
        mPricingRulesId
      );
      return updatedCart;
    }
  };

  const closePaymentModal = () => {
    setPaymentModal(false);
    setSelectedPaymentMethod("");
  };

  const [loyaltyPaymentOtp, setLoyaltyPaymentOtp] = useState();
  const [loyaltyInputValue, setLoyaltyInputValue] = useState("");
  const [loyalityOtpModalVisible, setLoyalityOtpModalVisible] = useState(false);
  const [loyalityOtpData, setLoyalityOtpData] = useState();
  const [paymentModalLoyalityMessages, setPaymentModalLoyalityMessages] = useState({ inputMessage: "Enter Amount", buttonText: "Add Payment" });

  const processOtpInput = () => {
    const { otp, paymentMethod, value, redeemPoints } = loyalityOtpData;
    setLoyalityOtpModalVisible(false);
    if (otp === loyaltyPaymentOtp) {
      message.success(`${messages.errors.loyalty.loyalty_points_redeemed}`);
      paymentMethod.redemptionPoints = parseInt(redeemPoints);
      processPayment(paymentMethod, value);
    } else {
      message.warning(`${messages.info.invalid_otp}`);
    }
    setLoyalityOtpData();
    setLoyaltyPaymentOtp();
  };

  const handleLoyalityInput = (value) => {
    if (value === "clear") {
      setLoyaltyInputValue("");
    } else if (value === "x") {
      setLoyaltyInputValue(`${loyaltyInputValue.toString().substring(0, loyaltyInputValue.toString().length - 1)}`);
    } else {
      setLoyaltyInputValue(`${loyaltyInputValue}${value}`);
    }
  };

  const checkLoyality = async () => {
    requestPayment(selectedPaymentMethod, parseFloat(loyaltyInputValue));
    setLoyalityOtpModalVisible(false);
    setLoyaltyInputValue(0);
    // setCart(cartObj);
    // localStorage.setItem("cartObj", JSON.stringify(cartObj));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (selectedPaymentMethod?.name?.toLowerCase() === "cash") {
        setDenaminationsKeyboard(true);
      }
      if (selectedPaymentMethod.isloyalty) {
        setPaymentModalLoyalityMessages({
          inputMessage: "Enter Points to Redeem",
          buttonText: "Redeem",
        });
        try {
          let loyaltyData = await db.loyalityData.toArray();
          const matchedLoyalty = loyaltyData.find((loyalty) => loyalty.name === cart.customer.loyaltyLevel.name);
          let cartObj = cart;
          let value = 0;
          if (posConfig?.enableLoyalty === "Y") {
            loyaltyData?.forEach((loyality) => {
              if (loyality.loyaltylevelId === cartObj?.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
                loyality.loyaltyRedemption.forEach((redeemItem) => {
                  value = parseFloat(parseFloat(cart.total - cart.paid / redeemItem.redemptionValue)?.toFixed(precision));
                });
              }
            });
          } else {
            value = parseFloat(parseFloat(cart.total - cart.paid)?.toFixed(precision));
          }
          if (Math.abs(matchedLoyalty.loyaltyRedemption[0].minPurchase <= cart.total)) {
            setLoyalityOtpModalVisible(true);
            setLoyaltyInputValue(value ? value : 0);
            upsertPOSLog(cart, "LOR");
          } else {
            message.error(`${messages.errors.loyalty.minimum_purchase_not_met}`);
          }
        } catch (error) {
          console.error("Error fetching loyalty data:", error);
        }
      } else if (selectedPaymentMethod.isGiftCard) {
        setGiftCardFlag(true);
        setTimeout(() => {
          if (redeemNumberRef.current) {
            redeemNumberRef.current.focus();
          }
        }, 250);
        setPaymentModalLoyalityMessages({
          inputMessage: "Enter Coupon Code",
          buttonText: "Redeem",
        });
      } else {
        setPaymentModalLoyalityMessages({
          inputMessage: "Enter Amount",
          buttonText: "Add Payment",
        });
      }
    };

    fetchData();
  }, [selectedPaymentMethod]);

  const requestPayment = async (paymentMethod, value, grant, wallet, cardPaymentDetails, updatedCart) => {
    addAmount(
      paymentMethod,
      value,
      grant,
      updatedCart || cart,
      setCart,
      setLoader,
      setPaymentModal,
      setAmount,
      setLoyalityOtpData,
      setLoyalityOtpModalVisible,
      setSelectedPaymentMethod,
      setPaytmQrCodeModalOpens,
      setQrCodeResponse,
      overPayedAmount,
      setShowCardPaymnteModal,
      setCardPaymnetError,
      setCardPaymnetStatus,
      setCardPaymnetStatusPLB,
      setLoading,
      setIsCardPaymentLoading,
      setLayoutType,
      setKioskUI,
      dispatchQRCodeEvent,
      closeQRCodeModal,
      wallet,
      cardPaymentDetails,
      setIntegratedPaymentStatus
    );
  };

  const processPayment = (paymentMethod, value) => {
    completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod);
  };
  //// PAYMENTS BLOCK END ////

  const eBillConfig = useRef({});
  useEffect(() => {
    const fetchPOSConfig = async () => {
      try {
        if (!authHeaders?.access_token || !tillValue?.cwr_till_id) {
          console.error("Missing required parameters: access token or till ID");
          return;
        }
        const response = await posConfigService(tillValue?.cwr_till_id);

        const posConfigData = response?.data?.data?.getPOSConfig;

        if (posConfigData?.length > 0) {
          const ebConfig = JSON.parse(posConfigData[0]?.configJson || "{}");
          eBillConfig.current = ebConfig;
        } else {
          console.warn("No POS configuration found for the provided till ID");
        }
      } catch (error) {
        console.error("Error fetching POS configuration:", error);
      }
    };
    fetchPOSConfig();
  }, []);

  const sendWebHookData = async (pendingOrders) => {
    try {
      // const orders = await db.orders.where("isSynced").equals(0).toArray();
      const orders = [...pendingOrders];
      for (const order of orders) {
        let shortId = "";
        const { eBillWebHookURL } = eBillConfig.current;
        try {
          const { data } = await Axios.get(`${eBillWebHookURL}/ebill/uniqueid`);
          shortId = data;
        } catch (error) {
          console.error(error);
          throw new Error("Failed to Fetch ID");
        }

        const orderItems = [];
        const taxKeyValue = [];
        const taxType = [];

        order.items.forEach((orderItem, i) => {
          let taxRate = orderItem.taxRate;
          if (taxType.indexOf(taxRate) !== -1) {
            let taxVal = orderItem.taxAmount / 2;
            for (let j = 0; j < taxKeyValue.length; j += 1) {
              const keys = Object.keys(taxKeyValue[j]);
              if (keys[0].toString() === taxRate.toString()) {
                taxKeyValue[j][taxRate] = taxKeyValue[j][taxRate] + taxVal;
              }
            }
          } else {
            taxType.push(taxRate);
            let taxVal = orderItem.taxAmount / 2;
            taxKeyValue.push({ [taxRate]: taxVal });
          }

          orderItems.push({
            line_no: i + 1,
            sku: orderItem.value,
            name: orderItem.name,
            description: null,
            hsn_code: null,
            selling_price: orderItem.salePrice,
            quantity: orderItem.weight,
            amount: orderItem.nettotal,
            list_price: orderItem.realPrice,
            uom: orderItem.uom_name,
            attributes: {
              mc: "",
              symc: "",
            },
            taxes: [
              {
                tax_name: "GST",
                percentage: orderItem.taxRate,
                amount: orderItem.taxAmount,
                taxableAmount: orderItem.nettotal,
              },
            ],
            brand: null,
            categoryId: orderItem.mProductCategoryId,
            categoryName: null,
          });
        });

        const payments = [];
        order.payments.forEach((payment, i) => {
          payments.push({
            payment_method: payment.name,
            amount: payment.amount,
          });
        });

        const orderData = {
          clientId: tillData.tillAccess.csClientId,
          storeId: tillData.tillAccess.csBunit.csBunitId,
          eBillCommType: eBillConfig.current.eBillCommType,
          created: order.orderTime,
          updated: order.orderTime,
          short_id: shortId,
          customer: {
            customer_id: order.customer.cwrCustomerId,
            first_name: order.customer.name,
            last_name: "",
            mobile: order.customer.mobileNo,
          },
          order_type: order.orderType,
          order_id: order.sOrderID,
          bill_no: order.documentno,
          bill_status: "PAID",
          order_date: order.orderTime,
          items: orderItems,
          item_count: order.items.length,
          total_qty: order.totalQty,
          net_total: order.total,
          gross_total: order.total,
          payment: payments,
          taxes: [
            {
              tax_name: "GST",
              amount: order.tax,
              taxableAmount: order.total,
            },
          ],
          additonalTaxinfo: taxKeyValue,
          feedback: false,
          feedbackStars: 0,
        };

        try {
          if (orderData.customer.mobile !== "9999999999") {
            await Axios.post(`${eBillWebHookURL}/ebill/webhook`, orderData);
          }
        } catch (error) {
          console.error(error);
          throw new Error("Failed to POST Webhook");
        }
      }
    } catch (e) {
      console.error("Webhook Error", e);
    }
  };

  const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    return saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
  };

  // ORDER SYNC BLOCK START
  const syncOrders = async (syncTrigger) => {
    const nWStatus = navigator.onLine ? "online" : "offline";
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    let saleTypeId = null;
    if (localStorage.getItem("saleTypeData") !== null) {
      const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData"));
      saleTypeId = saleTypeData?.cwrSaletype?.cwrSaletypeId;
    }
    if (nWStatus === "online") {
      db.logInformation.toArray().then(async (fetched) => {
        if (fetched.length > 0) {
          const posLogArray = [];
          const trxId = uuidv4().replace(/-/g, "").toUpperCase();
          let shouldCallAxios = false;

          for (const item of fetched) {
            const value = { ...item };
            await db.logInformation.where("id").equals(value.id).delete();

            posLogArray.push(`{
              type: ${JSON.stringify(value.type)},
              action: "LOG",
              description: ${JSON.stringify(value.description)},
              date: ${JSON.stringify(value.date)},
              time: ${JSON.stringify(value.time)},    
              orderNo: ${JSON.stringify(value.orderNo)},
              remarks: ${JSON.stringify(value.remarks)},
              transactionId: "${trxId}",
              status: "SCS",
              duration: ${value.duration ?? 0}
            }`);

            if (posConfig?.[value.type] === "Y") {
              shouldCallAxios = true;
            }
          }

          if (shouldCallAxios) {
            try {
              if (!tillData?.tillAccess?.cwrTill?.cwrTillID || !tillData?.tillAccess?.csUserId || !tillData?.tillAccess?.csBunit?.csBunitId) {
                console.error("Required till data is missing");
                return;
              }
              const response = await upsertPOSLogService(
                tillData.tillAccess.cwrTill.cwrTillID,
                tillData.tillAccess.csUserId,
                tillData.tillAccess.csBunit.csBunitId,
                posLogArray.join(", ")
              );

              if (response.status === 200) {
                console.log("POS logs successfully upserted:", response.data);
              } else {
                console.error("Error upserting POS logs:", response.status, response.data);
              }
            } catch (error) {
              console.error("Axios request failed:", error);
            }
          }
        }
      });

      const csCurrencyId = tillData?.tillAccess?.csBunit?.currencies[0]?.csCurrencyId || "";
      let orders = [];
      const taxDetails = [];
      const taxMap = {};
      for (const item of cart.items) {
        if (!item.isGiftCard) {
          if (item.taxRate >= 0 && item.tax) {
            const taxRate = item.taxRate;
            const taxAmount = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
            const nettotal = parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision));
            if (taxMap[taxRate]) {
              taxMap[taxRate].taxAmount += taxAmount;
              taxMap[taxRate].nettotal += nettotal;
            } else {
              taxMap[taxRate] = {
                taxAmount,
                nettotal,
                tax: item.tax,
                taxRate,
                taxCategory: item.taxCategory,
                taxName: item.taxName,
              };
            }
          }

          if (!item.taxRate && item.children?.length > 0) {
            for (const child of item.children) {
              if (child.taxRate && child.tax) {
                const taxRate = child.taxRate;
                const taxAmount = parseFloat(parseFloat(child.taxAmount)?.toFixed(precision));
                const nettotal = parseFloat(parseFloat(child.nettotal - child.taxAmount)?.toFixed(precision));
                if (taxMap[taxRate]) {
                  taxMap[taxRate].taxAmount += taxAmount;
                  taxMap[taxRate].nettotal += nettotal;
                } else {
                  taxMap[taxRate] = {
                    taxAmount,
                    nettotal,
                    tax: child.tax,
                    taxRate,
                    taxCategory: child.taxCategory,
                    taxName: child.taxName,
                  };
                }
              }
            }
          }
        }
      }

      const combinedTaxRates = Object.keys(taxMap).map((taxRate) => {
        const entry = taxMap[taxRate];
        taxDetails.push({
          csTaxID: entry.tax,
          taxableAmt: entry.nettotal,
          taxAmt: entry.taxAmount,
          taxRate,
          taxCategory: entry.taxCategory,
          taxName: entry.taxName,
        });
        return { csTaxID: entry.tax, taxableAmt: entry.nettotal, taxAmt: entry.taxAmount };
      });

      if (posConfig?.disableOfflineBilling === "Y") {
        const now = moment(new Date());
        const orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
          orderStartTime: "",
          orderEndTime: "",
          paymentStartTime: "",
        };
        orderTimeDetails.orderEndTime = now.format("DD-MM-YYYY HH:mm:ss");
        const tillSessionId = tillSession.tillSessionId || null;
        orders = [
          {
            ...cart,
            combinedTaxRates,
            taxDetails,
            createdBy: tillData.tillAccess.csUserId,
            customerSearchKey: cart?.customer?.code || "",
            isSynced: 0,
            // key: uuidv4().replace(/-/g, "").toUpperCase(),
            orderCompleted: cart.statusType === "layAway" ? false : true,
            orderDate: now.format("DD-MM-YYYY"),
            orderTime: now.format("DD-MM-YYYY HH:mm:ss"),
            orderTimeDetails,
            orderType: orderType?.cwrSaletype?.cwrSaletypeId,
            overPayedAmount: overPayedAmount || 0,
            syncAttempts: 0,
            tillSessionId,
            typeOrder: localStorage.getItem("homeDelivery") || "N",
          },
        ];
      } else {
        orders = await db.orders.where("isSynced").equals(0).or("isSynced").equals(2).toArray();
      }

      const pendingOrdersCount = orders.length;
      if (pendingOrdersCount > 0) {
        if (eBillConfig.current.eBill === "Y") {
          sendWebHookData(orders);
        }
        for (let i = 0; i < pendingOrdersCount; i += 1) {
          const regularOrders = orders.filter((order) => {
            const layAwayStatus = order?.layAway || "N";
            const paidAmount = order.layAway === "Y" && posConfig?.advanceLayaway === "Y" && order.advancePayment <= 0 ? 0 + order?.paid : order?.paid || 0;
            const advancePayment = order?.advancePayment || 0;
            const totalAmount = order?.total || 0;
            const totalQty = order?.totalQty || 0;
            const isParked = order?.parked === "Y";

            const isRegularOrderWithPaid =
              posConfig?.advanceLayaway === "Y"
                ? layAwayStatus === "Y"
                  ? layAwayStatus === "Y" && paidAmount + advancePayment <= totalAmount && advancePayment <= 0 && order?.docType !== "Advance"
                  : layAwayStatus === "N" && paidAmount !== 0
                : layAwayStatus === "N" && paidAmount !== 0;

            const isRegularOrderWithoutPaid = (layAwayStatus === "N" || layAwayStatus === "Y") && paidAmount === 0;
            const isCancelledOrder = totalAmount === 0 && totalQty === 0;
            const isParkedOrder = isParked && paidAmount === 0;

            return isRegularOrderWithPaid || isRegularOrderWithoutPaid || isCancelledOrder || isParkedOrder;
          });

          if (regularOrders.length > 0) {
            const orderLines = [];
            const childItemMetaMap = new Map();
            for (let j = 0; j < regularOrders[i]?.items.length; j += 1) {
              let unitTax = regularOrders[i].items[j].taxAmount / regularOrders[i].items[j].weight;
              unitTax = unitTax * (regularOrders[i].items[j].isReturn ? -1 : 1);

              let linesMeta = [];
              if (regularOrders[i].items[j].newCustomAttributes?.length > 0) {
                Object.entries(regularOrders[i].items[j].newCustomAttributes[0]).forEach(([key, value]) => {
                  linesMeta.push({
                    key: key,
                    value: value,
                  });
                });
              }

              if (regularOrders[i]?.items[j]?.approval?.length > 0) {
                const approval = regularOrders[i].items[j].approval[0];
                const keysToRemove = ["type", "min", "max", "roleId", "mPricingrulesId", "pin"];

                keysToRemove.forEach((key) => delete approval[key]);

                linesMeta.push({
                  key: "Approval",
                  value: JSON.stringify([approval]),
                });
              }

              const productAddons = [];

              if (regularOrders[i].items[j]?.childItems?.length > 0) {
                regularOrders[i].items[j]?.childItems.forEach((childItem) => {
                  const sp = parseFloat(parseFloat(childItem?.sunitprice || 0)?.toFixed(precision));
                  const quantity = childItem.weight * regularOrders[i].items[j].weight;
                  const grossUnit = sp;
                  const lineGross = parseFloat(parseFloat(sp * quantity)?.toFixed(precision));
                  const tax = taxIncludeFlag === "Y" ? lineGross - lineGross / (1 + childItem.taxRate / 100) : (lineGross * childItem.taxRate) / 100;
                  const unitTax = parseFloat(parseFloat(tax / quantity)?.toFixed(precision));
                  const lineTotal = parseFloat(parseFloat(lineGross + tax)?.toFixed(precision));

                  productAddons.push({
                    name: childItem.name,
                    price: sp,
                    addonProductId: childItem.mProductId,
                    qty: quantity,
                    lineGross: lineGross,
                    lineTax: tax,
                    lineTotal: lineTotal,
                    unitTax: unitTax,
                    grossUnit: grossUnit,
                    value: childItem.value,
                  });
                });
              } else if (regularOrders[i].items[j]?.selectedAddons?.length > 0) {
                regularOrders[i].items[j]?.selectedAddons.forEach((addon) => {
                  // const sp = parseFloat(parseFloat(childItem?.sunitprice || 0)?.toFixed(precision));
                  // const quantity = childItem.weight * regularOrders[i].items[j].weight;
                  // const grossUnit = sp;
                  // const lineGross = parseFloat(parseFloat(sp * quantity)?.toFixed(precision));
                  // const tax = taxIncludeFlag === "Y" ? lineGross - lineGross / (1 + childItem.taxRate / 100) : (lineGross * childItem.taxRate) / 100;
                  // const unitTax = parseFloat(parseFloat(tax / quantity)?.toFixed(precision));
                  // const lineTotal = parseFloat(parseFloat(lineGross + tax)?.toFixed(precision));

                  productAddons.push({
                    name: addon.name,
                    price: addon.price,
                    addonProductId: addon?.mAddonProduct?.mProductId || null,
                    qty: 1,
                    lineGross: 0,
                    lineTax: 0,
                    lineTotal: 0,
                    unitTax: 0,
                    grossUnit: 0,
                  });
                });
              }

              const item = regularOrders[i].items[j];
              if (item?.realWeight)
                linesMeta.push({
                  key: item.name,
                  value: item?.realWeight.toString(),
                });
              if (Array.isArray(item.children) && item.children.length > 0) {
                const childIDs = [];
                for (let k = 0; k < item.children.length; k++) {
                  const currentItem = item.children[k];
                  let unitTax = currentItem.taxAmount / currentItem.weight;
                  const sOrderlineID = uuidv4().replace(/-/g, "").toUpperCase();
                  const parsedDate = moment(
                    regularOrders[i].orderTime,
                    [
                      "YYYY-MM-DD HH:mm:ss", // case 1
                      "DD-MM-YYYY HH:mm:ss", // case 2
                    ],
                    true
                  );
                  orderLines.push({
                    csBunitId: currentItem.csBunitId || null,
                    // sOrderlineID: uuidv4().replace(/-/g, "").toUpperCase(),
                    sOrderlineID: sOrderlineID,
                    childrenId: currentItem.childrenId || null,
                    sOrderlineReturnId: currentItem.sOrderlineReturnId || null,
                    created: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    createdby: regularOrders[i].createdBy,
                    updated: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    updatedby: regularOrders[i].createdBy,
                    deliveryDate: regularOrders[i]?.deliveryDate
                      ? moment(regularOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                      : moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    sOrderId: regularOrders[i].sOrderID,
                    line: (j + 1) * 10 + k,
                    description: currentItem.notes || "",
                    mProductId: currentItem.productId || currentItem.mProductId,
                    csUomId: currentItem.uom || currentItem.uomData?.[0]?.csUomId,
                    csTaxId: currentItem.tax || currentItem.cTaxId,
                    qty: currentItem.weight,
                    unitprice: parseFloat(currentItem.realPrice) * (currentItem.isReturn ? -1 : 1),
                    netlist: parseFloat(currentItem.netList),
                    discount: currentItem.discount,
                    returnline: currentItem.isReturn || false,
                    returnQty: currentItem.isReturn ? Math.abs(currentItem.weight) : 0,
                    mBatchId: currentItem.mBatchId || currentItem.mBatch || null,
                    mPricingruleId: currentItem.mPricingruleId || null,
                    batchedForSale: currentItem.batchedForSale,
                    batchedForStock: currentItem.batchedForStock,
                    batchedProduct: currentItem.batchedProduct,
                    salesRepId: currentItem.salesRepId || regularOrders[i]?.salesRepId || null,
                    multiPrice: currentItem.multiPrice,
                    discountTypeId: null,
                    discountAmount: null,
                    metaData: linesMeta,
                    unittax: unitTax > 0 ? parseFloat(parseFloat(unitTax)?.toFixed(precision)) : 0,
                    linetax: parseFloat(currentItem.linetax || 0),
                    linenet: currentItem.linenet || 0,
                    linegross: currentItem.linegross || 0,
                    linestd: currentItem.linestd || 0,
                    netunit: currentItem.netunit || 0,
                    netstd: Math.abs(currentItem.netStd) ? parseFloat(currentItem.netStd) : 0,
                    listprice: currentItem.listPrice || 0,
                    grossunit: currentItem.grossunit || 0,
                    grossstd: roundTo(currentItem.grossstd, precision) || 0,
                    grosslist: roundTo(currentItem.grosslist, precision) || 0,
                    tax: [
                      {
                        csTaxID: currentItem.tax || currentItem.cTaxId,
                        taxableAmt: parseFloat(parseFloat(currentItem.linenet || 0)?.toFixed(precision)),
                        taxAmt: parseFloat(parseFloat(currentItem.taxAmount || 0)?.toFixed(precision)),
                      },
                    ],
                    addons: productAddons,
                  });
                  childIDs.push({ sOrderlineID });
                }
                childItemMetaMap.set(item.name + "_" + j, {
                  name: item.name,
                  weight: item.weight,
                  discount: item.discount,
                  taxAmount: item.taxAmount,
                  realPrice: item.realPrice,
                  nettotal: item.nettotal,
                  children: childIDs,
                });
              } else {
                orderLines.push({
                  csBunitId: regularOrders[i].items[j].csBunitId || null,
                  sOrderlineID: uuidv4().replace(/-/g, "").toUpperCase(),
                  sOrderlineReturnId: regularOrders[i].items[j].sOrderlineReturnId || null,
                  created: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                  createdby: regularOrders[i].createdBy,
                  updated: moment(regularOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                  updatedby: regularOrders[i].createdBy,
                  deliveryDate: regularOrders[i]?.deliveryDate
                    ? moment(regularOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                    : moment(regularOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                  sOrderId: regularOrders[i].sOrderID,
                  line: (j + 1) * 10,
                  description: regularOrders[i].items[j].notes || "",
                  mProductId: regularOrders[i].items[j].productId || regularOrders[i].items[j].mProductId,
                  csUomId: regularOrders[i].items[j].uom || regularOrders[i].items[j].uomData[0]?.csUomId,
                  csTaxId: regularOrders[i].items[j].tax || regularOrders[i].items[j].cTaxId,
                  qty: regularOrders[i].items[j].weight,
                  unitprice: parseFloat(regularOrders[i].items[j].realPrice) * (regularOrders[i].items[j].isReturn ? -1 : 1),
                  netlist: parseFloat(regularOrders[i].items[j].netList),
                  discount: regularOrders[i].items[j].discount,
                  returnline: regularOrders[i].items[j].isReturn || false,
                  returnQty: regularOrders[i].items[j].isReturn ? Math.abs(regularOrders[i].items[j].weight) : 0,
                  mBatchId: regularOrders[i].items[j].mBatchId || regularOrders[i].items[j].mBatch || null,
                  mPricingruleId: regularOrders[i].items[j].mPricingruleId || null,
                  batchedForSale: regularOrders[i].items[j].batchedForSale,
                  batchedForStock: regularOrders[i].items[j].batchedForStock,
                  batchedProduct: regularOrders[i].items[j].batchedProduct,
                  salesRepId: regularOrders[i].items[j]?.salesRepId || regularOrders[i]?.salesRepId || null,
                  multiPrice: regularOrders[i].items[j].multiPrice,
                  discountTypeId: null,
                  discountAmount: null,
                  metaData: linesMeta,
                  unittax: unitTax > 0 ? parseFloat(parseFloat(unitTax)?.toFixed(precision)) : 0,
                  linetax: parseFloat(regularOrders[i].items[j].linetax || 0),
                  linenet: regularOrders[i].items[j].linenet || 0,
                  linegross: regularOrders[i].items[j].linegross || 0,
                  linestd: regularOrders[i].items[j].linestd || 0,
                  netunit: regularOrders[i].items[j].netunit || 0,
                  netstd: Math.abs(regularOrders[i].items[j].netStd) ? parseFloat(regularOrders[i].items[j].netStd) : 0,
                  listprice: regularOrders[i].items[j].listPrice || 0,
                  grossunit: regularOrders[i].items[j].grossunit || 0,
                  grossstd: roundTo(regularOrders[i].items[j].grossstd, precision) || 0,
                  grosslist: roundTo(regularOrders[i].items[j].grosslist, precision) || 0,
                  tax: [
                    {
                      csTaxID: regularOrders[i].items[j].tax || regularOrders[i].items[j].cTaxId,
                      taxableAmt: parseFloat(parseFloat(regularOrders[i]?.items[j]?.linenet)?.toFixed(precision)),
                      taxAmt: parseFloat(parseFloat(regularOrders[i].items[j].taxAmount)?.toFixed(precision)),
                    },
                  ],
                  addons: productAddons,
                });
              }
            }
            let metaData = [];
            const paymentsList = [];

            const paymentMetaData = [];
            let amtMax = -100000000000000000000;
            let maxFinPaymentMethod;
            for (const payment of regularOrders[i]?.payments?.flat() || []) {
              paymentMetaData.push({
                [payment.name]: parseFloat(parseFloat(payment.amount)?.toFixed(precision)),
              });
              if (amtMax < parseFloat(payment.amount)) {
                amtMax = parseFloat(payment.amount);
                maxFinPaymentMethod = payment.finPaymentmethodId;
              }
              if (payment.name.toLowerCase() === "card") {
                if (payment.integratedPayment === true) {
                  paymentsList.push({
                    finPaymentmethodID: payment.finPaymentmethodId,
                    amount: parseFloat(parseFloat(payment.amount)?.toFixed(precision)),
                    transactionResponse: regularOrders[i].cardPaymentData?.response?.length > 0 ? regularOrders[i].cardPaymentData?.response[0]?.resultMessage : "",
                    transactionId: null,
                    cardType: "",
                    cardNo: "",
                    // transactionTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                    transactionTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                    authorizationCode: null,
                    metaData: [
                      {
                        key: "payload",
                        value: regularOrders[i].cardPaymentData?.payload?.length > 0 ? JSON.stringify(regularOrders[i].cardPaymentData?.payload[0]) : "",
                      },
                      {
                        key: "response",
                        value: regularOrders[i].cardPaymentData?.response?.length > 0 ? JSON.stringify(regularOrders[i].cardPaymentData?.response[0]) : "",
                      },
                    ],
                  });
                } else {
                  paymentsList.push({
                    finPaymentmethodID: payment.finPaymentmethodId,
                    amount: parseFloat(parseFloat(payment.amount)?.toFixed(precision)),
                    transactionResponse: null,
                    transactionId: regularOrders[i]?.cardPaymentData?.manual?.transactionId || null,
                    cardType: regularOrders[i].cardPaymentData?.manual?.cardType || null,
                    cardNo: regularOrders[i].cardPaymentData?.manual?.cardNumber || null,
                    transactionTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                    // transactionTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                    authorizationCode: payment.authorization || null,
                    metaData: [],
                  });
                }
              } else {
                paymentsList.push({
                  finPaymentmethodID: payment.finPaymentmethodId,
                  amount: parseFloat(parseFloat(payment.amount)?.toFixed(precision)),
                });
              }
            }

            if (paymentMetaData.length > 0) {
              const details = [
                ...paymentMetaData,
                { "Bill Amount": regularOrders[i]?.total },
                { change: regularOrders[i]?.change },
                { "Round Off": regularOrders[i]?.roundOff },
                { "Over Payment": regularOrders[i]?.overPayedAmount },
              ];

              if (regularOrders[i]?.tenderedAmount > 0) {
                details.push({ "Cash Received": parseFloat(parseFloat(regularOrders[i]?.tenderedAmount)?.toFixed(precision)) });
              }

              metaData.push({
                key: "Payment Details",
                value: JSON.stringify(details),
              });
            }

            let tableData = JSON.parse(localStorage.getItem("tableName"));
            if (localStorage.getItem("dineIn") === "Y") {
              const keysToCheck = ["guestName", "guestType", "cwrFbTableId", "cwrFbsectionId", "noOfPersons", "referredBy", "orderId"];
              // localStorage.removeItem("tableName");
              for (const key of keysToCheck) {
                if (tableData?.hasOwnProperty(key)) {
                  metaData.push({
                    key: key,
                    // value: tableData[key],
                    value: key === "noOfPersons" ? String(tableData[key]) : tableData[key],
                  });
                }
              }
            }

            if (regularOrders[i]?.orderTimeDetails) {
              Object.keys(regularOrders[i].orderTimeDetails).forEach((obj) => {
                metaData.push({
                  key: obj,
                  value: regularOrders[i].orderTimeDetails[obj],
                });
              });
            }

            let giftCards = [];
            regularOrders[i]?.giftCardData?.map((res) => {
              giftCards.push({
                redeemRefNo: res.redemptionId || null,
                cardNo: res.number || null,
                referenceNo: res.refId || null,
              });
            });

            if (Array.isArray(regularOrders[i]?.items)) {
              if (childItemMetaMap.size > 0) {
                const customMixMeta = [];

                childItemMetaMap.forEach((metaObj) => {
                  customMixMeta.push(metaObj);
                });

                metaData.push({
                  key: "Custom Mix",
                  value: JSON.stringify(customMixMeta),
                });
              }
            }

            const couponData = JSON.parse(localStorage.getItem("couponAdditionalInfo"));

            if (couponData) {
              metaData.push({
                key: "Coupon Data",
                value: JSON.stringify(couponData),
              });
            }

            const discountData = JSON.parse(localStorage.getItem("discountAdditionalInfo"));

            if (discountData) {
              metaData.push({
                key: "Discount Data",
                value: JSON.stringify(discountData),
              });
            }
            const salesReturnData = JSON.parse(localStorage.getItem("salesReturnData"));

            if (salesReturnData) {
              metaData.push({
                key: "Sales Return Data",
                value: JSON.stringify(salesReturnData),
              });
            }

            // Cancel Parked Bill
            const billParkingData = JSON.parse(localStorage.getItem("billParkingData"));

            if (billParkingData?.remarks?.trim()) {
              metaData.push({
                key: "Bill parking",
                value: JSON.stringify({
                  remarks: billParkingData.remarks.trim(),
                }),
              });
            }

            let storeOpsTillID;
            const tillEvent = await db.tillEvents.where("tillSessionId").equals(tillSession.tillSessionId).first();

            if (tillEvent) {
              storeOpsTillID = tillEvent.storeDailyOpsTillid;
            }
            const isLoyaltyEnabled =
              (posConfig?.enableLoyalty || "N") === "N" || ((posConfig?.enableLoyalty || "N") === "Y" && (posConfig?.disablePOSLoyaltyCalculation || "N") === "N");
            if (!regularOrders[i] || !regularOrders[i].items) continue;
            const parsedDate = moment(
              regularOrders[i].orderTime,
              [
                "YYYY-MM-DD HH:mm:ss", // case 1
                "DD-MM-YYYY HH:mm:ss", // case 2
              ],
              true
            );
            if (posConfig) posConfig.disablePOSLoyaltyCalculation = posConfig?.disablePOSLoyaltyCalculation || "N";
            const orderJson = {
              sOrderID: regularOrders[i].sOrderID,
              cSClientID: tillData.tillAccess.csClientId,
              cSBunitID: tillData.tillAccess.csBunit.csBunitId,
              created: moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              createdby: regularOrders[i].createdBy,
              updated: moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              updatedby: regularOrders[i].createdBy,
              csDoctypeId: tillData.tillAccess.csBunit.cwrCsDoctypeId,
              sCustomerId: regularOrders[i]?.customer?.sCustomer?.sCustomerID
                ? regularOrders[i].customer.sCustomer.sCustomerID
                : tillData.tillAccess.csBunit.b2cCustomer.sCustomer.sCustomerID,
              sCustomerBillingId: tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
              sCustomerShippingId: tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
              sPricelistId: tillData.tillAccess.csBunit.cwrSpricelistId,
              documentno: regularOrders[i].documentno,
              dateordered: moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              datepromised: regularOrders[i].deliveryDate
                ? moment(regularOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                : moment(parsedDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
              csPaymenttermID: null,
              finPaymentmethodId: regularOrders[i].layAway === "N" && maxFinPaymentMethod ? maxFinPaymentMethod : null,
              csCurrencyId: csCurrencyId,
              mWarehouseId: tillData.tillAccess.csBunit.mWarehouse.mWarehouseID,
              cwrLongitude: "",
              cwrLatitude: "",
              csUserId: tillData.tillAccess.csUserId,
              cwrB2cCustomerId: regularOrders[i].customer?.cwrCustomerId ? regularOrders[i].customer?.cwrCustomerId : regularOrders[i].customer?.b2cCustomerId,
              orderreference: "",
              cwrPayref: "",
              cwrPayremarks: "",
              description: regularOrders[i].description || "",
              storeDailyOpsTillid: storeOpsTillID,
              cwrTillId: tillData.tillAccess.cwrTill.cwrTillID,
              redemption: isLoyaltyEnabled ? regularOrders[i].redemptionPoints : 0,
              accumulation: isLoyaltyEnabled ? regularOrders[i].accumulationPoints : 0,
              redeemRefId: regularOrders[i].referenceId,
              roundoff: parseFloat(parseFloat(regularOrders[i].roundOff)?.toFixed(precision)) || 0,
              cwrProductQty: regularOrders[i].totalQty,
              cwrProductCount: regularOrders[i].totalQty,
              ofdStatus: "Delivered",
              ofdIspaid: "Y",
              posLoyaltyCalculation: posConfig?.disablePOSLoyaltyCalculation,
              mPricingruleId: regularOrders[i].mPricingruleId ?? null,
              cwrSaletypeId: regularOrders[i]?.saleType?.cwrSaletypeId || saleTypeId,
              salesRepId: regularOrders[i]?.salesRepId || null,
              discAmount: parseFloat(parseFloat(regularOrders[i].discount)?.toFixed(precision)),
              creditReferenceNo: regularOrders[i]?.referenceId ?? null,
              creditAmount: `${regularOrders[i].isReturn && regularOrders[i].customer?.iscredit ? -regularOrders[i].creditAmount : regularOrders[i].creditAmount}`,
              metaData: metaData,
              giftCard: giftCards,
              pricingCoupon: [
                {
                  mPricingCouponId: regularOrders[i]?.couponInput?.[0]?.mPricingCouponId || null,
                  redemptionCount: regularOrders[i].couponRedemptionCount ? parseInt(regularOrders[i].couponRedemptionCount) : null,
                  referenceId: regularOrders[i]?.couponInput?.[0]?.referenceId || null,
                },
              ],
              orderTotal: regularOrders[i].total,
              nettotal: parseFloat(parseFloat(regularOrders[i].total - regularOrders[i].tax)?.toFixed(precision)),
              taxamt: parseFloat(parseFloat(regularOrders[i].tax)?.toFixed(precision)),
              isReturn: regularOrders[i].items.some((f) => f.isReturn) ? "Y" : "N",
              sOrderReturnId: regularOrders[i].items?.[0]?.sOrderReturnId || null,
              layAway: regularOrders[i].layAway || null,
              payments: paymentsList,
              tax: regularOrders[i].combinedTaxRates ? regularOrders[i].combinedTaxRates : [],
              line: orderLines,
            };

            const stringifiedData = JSON.stringify(orderJson);
            const newStringifiedFields = stringifiedData.replace(/\\"/g, '\\"');
            const newStringRequest = JSON.stringify(newStringifiedFields);
            const orderObj = JSON.parse(JSON.parse(newStringRequest));

            const paramsInput = {
              query: `
                    mutation {
                      posOrderProcessor1(
                        tillId: "${tillData.tillAccess.cwrTill.cwrTillID}",
                        orderId: "${regularOrders[i].sOrderID}",
                        documentNo: ${posConfig?.disableOfflineBilling !== "Y" ? `"${regularOrders[i].documentno}"` : null},
                        orderJson: ${newStringRequest}
                      ) {
                        documentno
                        status
                        message
                      }
                    }
                  `,
            };
            if (posConfig?.disableOfflineBilling === "Y") {
              setLoading(true);
            }
            try {
              const response = await posOrderProcessor1(paramsInput);
              const result = response.data.data.posOrderProcessor1;
              const { status, documentno } = result;

              if (status === "200") {
                if (posConfig?.disableOfflineBilling !== "Y") {
                  console.info(`Order ${regularOrders[i].documentno} synced to Server`);
                  db.orders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ isSynced: 1 });
                } else if (posConfig?.disableOfflineBilling === "Y") {
                  console.info(`Order ${documentno} synced to Server`);
                  message.success(`Order ${documentno} Created Successfully`);
                  await processOrderApproved(cart.sOrderID, documentno, 1);
                }
                setCustomMixItems([]);
                localStorage.removeItem("couponAdditionalInfo");
                localStorage.removeItem("discountAppliedData");
                localStorage.removeItem("discountAdditionalInfo");
                localStorage.removeItem("getFBOrderData");
                localStorage.removeItem("salesReturnData");
                localStorage.removeItem("billParkingData");
                setSelectedCoupon(null);
                setCompleteSaleStockData([]);
                let rfidData = [];
                await db.rfidData.toArray((products) => {
                  products.map((ele) => {
                    if (ele.tag_status === "SO") {
                      rfidData.push(` {
                                tagValue: "${ele.tag_value}"
                                taggingDate: null
                                batchNumber: null
                                batchId: null
                                warehouseId: null
                                tagStatus: "SO"
                                lastScannedDate: "${moment(new Date()).format("DD-MM-YYYY HH:mm:ss")}"
                                scannedBy: null
                                expirydate: null
                                customAttribute: null
                                tagType: null
                                productCode: "${ele.product_code}"
                                }`);
                    }
                  });
                });
                await RFIDTag(rfidData);
              } else {
                console.error("Failed Order Sync ====> ", response);
                const syncFailedCount = parseInt(regularOrders[i].syncAttempts) + 1;
                if (parseInt(regularOrders[i].syncAttempts) < 100) {
                  db.regularOrders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ syncAttempts: syncFailedCount });
                } else {
                  db.regularOrders.where("sOrderID").equals(regularOrders[i].sOrderID).modify({ isSynced: 2 });
                }
              }
            } catch (error) {
              console.log(error, "err------------>");
            } finally {
              setLoading(false);
            }
          } else {
            const layAwayOrders = orders.filter((order) => {
              return order.layAway === "Y" && order.paid !== 0;
            });
            if (layAwayOrders.length > 0) {
              const orderLines = [];
              const childItemMetaMap = new Map();
              for (let j = 0; j < layAwayOrders[i].items.length; j += 1) {
                let unitPrice;
                if (layAwayOrders[i].items[j].weight > 0) {
                  unitPrice = layAwayOrders[i].items[j].realPrice;
                  unitPrice = parseFloat(parseFloat(unitPrice)?.toFixed(precision));
                } else {
                  unitPrice = 0;
                }
                let orderLineMeta = [];
                if (layAwayOrders[i]?.items[j]?.approval?.length > 0) {
                  orderLineMeta.push();
                }
                const item = layAwayOrders[i].items[j];

                if (Array.isArray(item.children) && item.children.length > 0) {
                  const childIDs = [];
                  for (let k = 0; k < item.children.length; k++) {
                    let unitPrice;
                    const currentItem = item.children[k];
                    let unitTax = currentItem.taxAmount / currentItem.weight;
                    // const sOrderlineID = uuidv4().replace(/-/g, "").toUpperCase();
                    const sOrderlineID = currentItem.sOrderlineID ? currentItem.sOrderlineID : uuidv4().replace(/-/g, "").toUpperCase();
                    orderLines.push({
                      sOrderlineID: sOrderlineID,
                      sOrderlineReturnId: currentItem.sOrderlineReturnId || null,
                      created: moment(layAwayOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      createdby: layAwayOrders[i].createdBy,
                      updated: moment(layAwayOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      updatedby: layAwayOrders[i].createdBy,
                      // deliveryDate: layAwayOrders[i]?.deliveryDate
                      //   ? moment(layAwayOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                      //   : momentylayAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      deliveryDate: cart?.deliveryDate
                        ? moment(cart.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                        : layAwayOrders[i]?.deliveryDate
                          ? moment(layAwayOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                          : moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                      sOrderId: layAwayOrders[i].sOrderID,
                      line: (j + 1) * 10 + k,
                      description: "",
                      mProductId: currentItem.productId ? currentItem.productId : currentItem.mProductId,
                      csUomId: currentItem.productId ? currentItem.uom : currentItem.uom?.csUomId || null,
                      csTaxId: currentItem.productId ? currentItem.tax : currentItem.tax?.csTaxID || null,
                      qty: currentItem.weight,
                      unitprice: currentItem.weight > 0 ? parseFloat(parseFloat(currentItem.realPrice)?.toFixed(precision)) : 0,
                      netlist: currentItem.weight > 0 ? currentItem.salePrice : 0,
                      discount: currentItem.discount,
                      returnline: currentItem.isReturn ?? currentItem.returnline,
                      returnQty: currentItem.isReturn === true ? Math.abs(currentItem.weight) : 0,
                      mBatchId: currentItem.mBatchId || null,
                      mPricingruleId: currentItem.mPricingruleId ?? null,
                      batchedForSale: currentItem.batchedForSale || null,
                      batchedForStock: currentItem.batchedForStock || null,
                      batchedProduct: currentItem.batchedProduct || null,
                      salesRepId: currentItem.salesRepId || layAwayOrders[i]?.salesRepId || null,
                      multiPrice: currentItem.multiPrice || null,
                      discountTypeId: null,
                      discountAmount: null,
                      unittax: currentItem.weight > 0 && currentItem.taxRate > 0 ? currentItem?.unitTax || currentItem?.unittax || 0 : 0,
                      linetax: parseFloat(currentItem.linetax || 0),
                      metaData: orderLineMeta,
                      linenet: currentItem.linenet || 0,
                      linegross: currentItem.linegross || 0,
                      linestd: currentItem.linestd || 0,
                      netunit: Math.abs(currentItem.netunit),
                      listprice: currentItem.weight > 0 ? currentItem?.listPrice : 0,
                      grossunit: currentItem.grossunit || 0,
                      grossstd: currentItem.weight > 0 ? roundTo(currentItem.grossstd, precision) : 0,
                      grosslist: currentItem.weight > 0 ? roundTo(currentItem.listPrice, precision) : 0,
                      tax: [
                        {
                          csTaxID: layAwayOrders[i].taxDetails[0]?.csTaxID || "",
                          taxableAmt: parseFloat(parseFloat(currentItem?.linenet)?.toFixed(precision) || 0),
                          taxAmt: parseFloat(parseFloat(currentItem.taxAmount)?.toFixed(precision) || 0),
                        },
                      ],
                    });
                    childIDs.push({ sOrderlineID });
                  }
                  childItemMetaMap.set(item.name + "_" + j, {
                    name: item.name,
                    weight: item.weight,
                    discount: item.discount,
                    taxAmount: item.taxAmount,
                    realPrice: item.realPrice,
                    nettotal: item.nettotal,
                    children: childIDs,
                  });
                } else {
                  orderLines.push({
                    sOrderlineID: layAwayOrders[i].items[j].sOrderlineID ? layAwayOrders[i].items[j].sOrderlineID : uuidv4().replace(/-/g, "").toUpperCase(),
                    sOrderlineReturnId: layAwayOrders[i].items[j].sOrderlineReturnId || null,
                    created: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    createdby: layAwayOrders[i].createdBy,
                    updated: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    updatedby: layAwayOrders[i].createdBy,
                    // deliveryDate: layAwayOrders[i]?.deliveryDate
                    //   ? moment(layAwayOrders[i]?.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                    //   : moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    deliveryDate: cart?.deliveryDate
                      ? moment(cart.deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                      : layAwayOrders[i]?.deliveryDate
                        ? moment(layAwayOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                        : moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                    sOrderId: layAwayOrders[i].sOrderID,
                    line: (j + 1) * 10,
                    description: "",
                    mProductId: layAwayOrders[i].items[j].productId ? layAwayOrders[i].items[j].productId : layAwayOrders[i].items[j].product.mProductId,
                    csUomId: layAwayOrders[i].items[j].productId ? layAwayOrders[i].items[j].uom : layAwayOrders[i].items[j].uom?.csUomId || null,
                    csTaxId: layAwayOrders[i].items[j].productId ? layAwayOrders[i].items[j].tax : layAwayOrders[i].items[j].tax?.csTaxID || null,
                    qty: layAwayOrders[i].items[j].weight,
                    unitprice: unitPrice || 0,
                    netlist: layAwayOrders[i].items[j].weight > 0 ? layAwayOrders[i].items[j].salePrice : 0,
                    discount: layAwayOrders[i].items[j].discount,
                    returnline: layAwayOrders[i].items[j].isReturn ?? layAwayOrders[i].items[j].returnline,
                    returnQty: layAwayOrders[i].items[j].isReturn === true ? Math.abs(layAwayOrders[i].items[j].weight) : 0,
                    mBatchId: layAwayOrders[i].items[j].mBatchId || null,
                    mPricingruleId: layAwayOrders[i].items[j].mPricingruleId ?? null,
                    batchedForSale: layAwayOrders[i].items[j].batchedForSale || null,
                    batchedForStock: layAwayOrders[i].items[j].batchedForStock || null,
                    batchedProduct: layAwayOrders[i].items[j].batchedProduct || null,
                    salesRepId: layAwayOrders[i].items[j]?.salesRepId || layAwayOrders[i]?.salesRepId || null,
                    multiPrice: layAwayOrders[i].items[j].multiPrice || null,
                    discountTypeId: null,
                    discountAmount: null,
                    unittax:
                      layAwayOrders[i].items[j].weight > 0 && layAwayOrders[i].items[j].taxRate > 0
                        ? layAwayOrders[i].items[j]?.unitTax || layAwayOrders[i].items[j]?.unittax || 0
                        : 0,
                    linetax: parseFloat(layAwayOrders[i].items[j].linetax || 0),
                    metaData: orderLineMeta,
                    linenet: layAwayOrders[i].items[j].linenet || 0,
                    linegross: layAwayOrders[i].items[j].linegross || 0,
                    linestd: layAwayOrders[i].items[j].linestd || 0,
                    netunit: Math.abs(layAwayOrders[i].items[j].netunit),
                    listprice: layAwayOrders[i].items[j].weight > 0 ? layAwayOrders[i].items[j].listPrice : 0,
                    grossunit: layAwayOrders[i].items[j].grossunit || 0,
                    grossstd: layAwayOrders[i].items[j].weight > 0 ? roundTo(layAwayOrders[i].items[j].grossstd, precision) : 0,
                    grosslist: layAwayOrders[i].items[j].weight > 0 ? roundTo(layAwayOrders[i].items[j].listPrice, precision) : 0,
                    tax: [
                      {
                        csTaxID: layAwayOrders[i].taxDetails[0]?.csTaxID || "",
                        taxableAmt: parseFloat(parseFloat(layAwayOrders[i].items[j].linenet)?.toFixed(precision) || 0),
                        taxAmt: parseFloat(parseFloat(layAwayOrders[i].items[j].taxAmount)?.toFixed(precision) || 0),
                      },
                    ],
                  });
                }
              }
              const paymentsList = [];
              let amtMax = -100000000000000000000;
              let maxFinPaymentMethod = null;
              for (let k = 0; k < layAwayOrders[i].payments.length; k += 1) {
                if (amtMax < parseFloat(layAwayOrders[i].payments[k].amount)) {
                  amtMax = parseFloat(layAwayOrders[i].payments[k].amount);
                  maxFinPaymentMethod = layAwayOrders[i].payments[k].finPaymentmethodId;
                }
                paymentsList.push({
                  finPaymentmethodID: layAwayOrders[i].payments[k].finPaymentmethodId,
                  amount: parseFloat(parseFloat(layAwayOrders[i].payments[k].amount).toFixed(2)),
                });
              }
              let tableData = JSON.parse(localStorage.getItem("tableName"));
              let metaData = [];
              if (localStorage.getItem("dineIn") === "Y") {
                const keysToCheck = ["guestName", "guestType", "cwrFbTableId", "cwrFbsectionId", "noOfPersons", "referredBy", "orderId"];
                // localStorage.removeItem("tableName");
                for (const key of keysToCheck) {
                  if (tableData.hasOwnProperty(key)) {
                    metaData.push({
                      key: key,
                      value: tableData[key],
                    });
                  }
                }
              }

              if (Array.isArray(layAwayOrders[i].items)) {
                if (childItemMetaMap.size > 0) {
                  const customMixMeta = [];

                  childItemMetaMap.forEach((metaObj) => {
                    customMixMeta.push(metaObj);
                  });

                  metaData.push({
                    key: "Custom Mix",
                    value: JSON.stringify(customMixMeta),
                  });
                }
              }
              let accumulationPoints;
              // if (cart.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
              //   const loyaltyLevelId = cart.customer.loyaltyLevel.cwrLoyaltyLevelId;
              //   const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();
              //   if (loyaltyData) {
              //     const eventCalenders = loyaltyData.loyaltyEventCalenders || [];
              //     const hasValidEventCalenders = eventCalenders.length > 0 ? dateValidator(eventCalenders[0].startDate, eventCalenders[0].endDate) : true;

              //     for (const item of loyaltyData.LoyaltyAccumulation || []) {
              //       const productValidation = item.mProductId ? cart.items.some((pc) => pc.mProductId === item.mProductId) : true;
              //       const categoryValidation = item.mProductCategoryId ? cart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;
              //       const checkEventsCalender =
              //         item.loyaltyEvent === "Y" && eventCalenders.length > 0
              //           ? eventCalenders.some((i) => dateValidator(i.startDate, i.endDate))
              //           : item.loyaltyEvent === "Y" && eventCalenders.length === 0;

              //       if (
              //         (item.loyaltyEvent === "Y" &&
              //           item.minPurchase <= Math.abs(cart.total) &&
              //           productValidation &&
              //           categoryValidation &&
              //           hasValidEventCalenders &&
              //           checkEventsCalender) ||
              //         (item.loyaltyEvent === "N" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation)
              //       ) {
              //         accumulationPoints =
              //           tillData?.tillAccess?.csBunit?.enableLoyalty === "Y"
              //             ? cart?.discount > 0
              //               ? loyaltyData?.noLoyaltyOnDiscount === "Y"
              //                 ? 0
              //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
              //               : cart?.redemptionPoints > 0
              //               ? loyaltyData?.noLoyaltyOnRedemption === "Y"
              //                 ? 0
              //                 : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
              //               : parseFloat(parseFloat(item.pointsPerUnit * (cart.total - cart.tax))?.toFixed(3))
              //             : 0;
              //         break;
              //       }
              //     }
              //   }
              // }
              if (cart.customer?.loyaltyLevel?.cwrLoyaltyLevelId) {
                const loyaltyLevelId = cart.customer.loyaltyLevel.cwrLoyaltyLevelId;

                const loyaltyData = await db.loyalityData.where("loyaltylevelId").equals(loyaltyLevelId).first();

                if (loyaltyData) {
                  const eventCalenders = loyaltyData.loyaltyEventCalenders || [];

                  // ✅ Check if any event calendar is active
                  const isEventActive = eventCalenders.length > 0 && eventCalenders.some((ec) => dateValidator(ec.startDate, ec.endDate));

                  // ✅ Select applicable accumulation rule
                  const applicableRule = (loyaltyData.LoyaltyAccumulation || []).find((item) => {
                    const productValidation = item.mProductId ? cart.items.some((pc) => pc.mProductId === item.mProductId) : true;

                    const categoryValidation = item.mProductCategoryId ? cart.items.some((pc) => pc.mProductCategoryId === item.mProductCategoryId) : true;

                    // 🟢 Event active → Promotion
                    if (isEventActive) {
                      return item.loyaltyEvent === "Y" && item.name === "Promotion" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation;
                    }

                    // 🔵 No event → Generic
                    return item.loyaltyEvent === "Y" && item.name === "Generic" && item.minPurchase <= Math.abs(cart.total) && productValidation && categoryValidation;
                  });

                  // ✅ Calculate accumulation points
                  if (applicableRule) {
                    const baseAmount = cart.total - cart.tax;

                    if (tillData?.tillAccess?.csBunit?.enableLoyalty !== "Y") {
                      accumulationPoints = 0;
                    } else if (cart?.discount > 0 && loyaltyData?.noLoyaltyOnDiscount === "Y") {
                      accumulationPoints = 0;
                    } else if (cart?.redemptionPoints > 0 && loyaltyData?.noLoyaltyOnRedemption === "Y") {
                      accumulationPoints = 0;
                    } else {
                      accumulationPoints = Number((applicableRule.pointsPerUnit * baseAmount).toFixed(3));
                    }
                  }
                }
              }
              const orderJson = {
                sOrderID: layAwayOrders[i].sOrderID,
                cSClientID: tillData.tillAccess.csClientId,
                cSBunitID: tillData.tillAccess.csBunit.csBunitId,
                created: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                createdby: layAwayOrders[i].createdBy,
                updated: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                updatedby: layAwayOrders[i].createdBy,
                csDoctypeId: tillData.tillAccess.csBunit.cwrCsDoctypeId,
                sCustomerId: layAwayOrders[i]?.customer?.sCustomer?.sCustomerID
                  ? layAwayOrders[i].customer.sCustomer.sCustomerID
                  : tillData.tillAccess.csBunit.b2cCustomer.sCustomer.sCustomerID,
                sCustomerBillingId: tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
                sCustomerShippingId: tillData.tillAccess.csBunit.customerAddress?.sCustomerAddressID,
                sPricelistId: tillData.tillAccess.csBunit.cwrSpricelistId,
                documentno: layAwayOrders[i].documentno,
                dateordered: moment(layAwayOrders[i]?.orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                datepromised: layAwayOrders[i].deliveryDate
                  ? moment(layAwayOrders[i].deliveryDate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                  : moment(layAwayOrders[i].orderTime, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
                csPaymenttermID: null,
                finPaymentmethodId: maxFinPaymentMethod || null,
                csCurrencyId: csCurrencyId,
                mWarehouseId: tillData.tillAccess.csBunit.mWarehouse.mWarehouseID,
                cwrLongitude: "",
                cwrLatitude: "",
                csUserId: tillData.tillAccess.csUserId,
                cwrB2cCustomerId: layAwayOrders[i].customer.cwrCustomerId,
                orderreference: "",
                cwrPayref: "",
                cwrPayremarks: "",
                description: "",
                isAdvance: layAwayOrders[i].statusType === "layAway" ? "Y" : "N",
                cwrTillId: tillData.tillAccess.cwrTill.cwrTillID,
                redemption: layAwayOrders[i].redemptionPoints || null,
                accumulation: layAwayOrders[i].accumulationPoints || null,
                roundoff: Math.abs(parseFloat(layAwayOrders[i].roundOff)?.toFixed(precision)) || 0,
                cwrProductQty: layAwayOrders[i].totalQty,
                cwrProductCount: layAwayOrders[i].totalQty,
                ofdStatus: "Delivered",
                ofdIspaid: "Y",
                mPricingruleId: layAwayOrders[i].mPricingruleId !== null && layAwayOrders[i].mPricingruleId !== undefined ? layAwayOrders[i].mPricingruleId : null,
                cwrSaletypeId: layAwayOrders[i].saleType.cwrSaletypeId || saleTypeId,
                salesRepId: layAwayOrders[i].salesRepId !== null && layAwayOrders[i].salesRepId !== undefined ? layAwayOrders[i].salesRepId : null,
                discAmount: layAwayOrders[i].discount,
                creditAmount: layAwayOrders[i].creditAmount,
                metaData: metaData,
                pricingCoupon: [
                  {
                    mPricingCouponId: layAwayOrders[i].mPricingCouponId || null,
                    redemptionCount: layAwayOrders[i].couponRedemptionCount ? parseInt(layAwayOrders[i].couponRedemptionCount) : null,
                    referenceId: layAwayOrders[i]?.couponInput?.length > 0 ? layAwayOrders[i].couponInput[0].referenceId : null,
                  },
                ],
                orderTotal: layAwayOrders[i].total,
                isReturn: layAwayOrders[i].items.filter((f) => f.isReturn === true).length > 0 ? "Y" : "N",
                sOrderReturnId: layAwayOrders[i].items?.[0]?.sOrderReturnId || null,
                layAway: layAwayOrders[i].layAway,
                nettotal: parseFloat(parseFloat(layAwayOrders[i].total - layAwayOrders[i].tax)?.toFixed(precision)),
                taxamt: parseFloat(parseFloat(layAwayOrders[i].tax)?.toFixed(precision)),
                payments: paymentsList,
                line: orderLines,
                tax: layAwayOrders[i].combinedTaxRates ? layAwayOrders[i].combinedTaxRates : [],
              };

              const stringifiedData = JSON.stringify(orderJson);
              const newStringifiedFields = stringifiedData.replace(/\\"/g, '\\"');
              const newStringRequest = JSON.stringify(newStringifiedFields);

              const paramsInput = {
                query: `
                      mutation {
                        confirmPOSLayawayOrder1(
                          tillId: "${tillData.tillAccess.cwrTill.cwrTillID}",
                          orderId: "${layAwayOrders[i].sOrderID}",
                          documentNo: "${layAwayOrders[i].documentno}",
                          orderJson: ${newStringRequest}
                        ) {
                          documentno
                          status
                          message
                        }
                      }
                    `,
              };

              try {
                const response = await confirmPOSLayawayOrder1(paramsInput);
                const result = response.data.data.confirmPOSLayawayOrder1;
                const { status, documentno } = result;
                if (result.status === "200") {
                  if (posConfig?.disableOfflineBilling !== "Y") {
                    console.info(`Order ${layAwayOrders[i].documentno} synced to Server`);
                    db.orders.where("sOrderID").equals(layAwayOrders[i].sOrderID).modify({ isSynced: 1 });
                  } else if (posConfig?.disableOfflineBilling === "Y") {
                    // console.info(`Order ${documentno} synced to Server`);
                    message.success(`Order ${documentno} Created Successfully`);
                    await processOrderApproved(cart.sOrderID, null, 1);
                  }

                  let rfidData = [];
                  await db.rfidData.toArray((products) => {
                    products.map((ele) => {
                      if (ele.tag_status === "SO") {
                        rfidData.push(` {
                                    tagValue: "${ele.tag_value}"
                                    taggingDate: null
                                    batchNumber: null
                                    batchId: null
                                    warehouseId: null
                                    tagStatus: "SO"
                                    lastScannedDate: "${moment(new Date()).format("DD-MM-YYYY HH:mm:ss")}"
                                    scannedBy: null
                                    expirydate: null
                                    customAttribute: null
                                    tagType: null
                                    productCode: "${ele.product_code}"
                                    }`);
                      }
                    });
                  });
                  await RFIDTag(rfidData);
                } else {
                  console.error("Failed Order Sync ====> ", response);
                  const syncFailedCount = parseInt(layAwayOrders[i].syncAttempts) + 1;
                  if (parseInt(layAwayOrders[i].syncAttempts) < 100) {
                    db.layAwayOrders.where("sOrderID").equals(layAwayOrders[i].sOrderID).modify({ syncAttempts: syncFailedCount });
                  } else {
                    db.layAwayOrders.where("sOrderID").equals(layAwayOrders[i].sOrderID).modify({ isSynced: 2 });
                  }
                }
              } catch (error) {
                console.log(error);
              }
            }
          }
        }
      }

      setActiveInput("search");
    }
    if (syncTrigger === "orderHistory") {
      showOrderHistory();
    }
  };

  useEffect(() => {
    if (posConfig?.disableOfflineBilling !== "Y") {
      const syncOrdersInterval = setInterval(() => syncOrders(), 10000);
      return () => {
        clearTimeout(syncOrdersInterval);
      };
    }
  }, []);
  // ORDER SYNC BLOCK END

  const handleCloseModal = () => {
    history.push("/dashboard");
  };

  const confirmDiscardCart = () => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        className: "parkedItemsClass",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        onOk() {
          parkBill();
          setTimeout(() => {
            history.push("/dashboard");
          }, 700);
        },
        onCancel: () => {
          handleCloseModal();
        },
      });
    } else {
      history.push("/dashboard");
    }
  };

  const [couponModalVisible, setCouponModalVisible] = useState(false);
  const [couponInput, setCouponInput] = useState("");

  const closeCouponModal = () => {
    setCouponModalVisible(false);
    setSelectedCoupon(null);
    // setSelectedExternalCouponType("")
    // setExternalCouponTypes([])
    // setManualDiscountInput("")
    setCouponInput("");
    setIsInputFocused(false);
    setAdditionalInfo([]);
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
  };

  const handleCouponInput = (value) => {
    if (value === "clear") {
      setCouponInput("");
    } else if (value === "x") {
      setCouponInput(`${couponInput.toString().substring(0, couponInput.toString().length - 1)}`);
    } else {
      setCouponInput(`${couponInput}${value}`);
    }
  };

  const toCamelCase = (str) =>
    str
      .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special chars if needed
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase()))
      .replace(/\s+/g, "");

  const processCouponApplication = async (verifyCoupons, pricingRules, uniqReferenceId) => {
    const couponData = Array.isArray(verifyCoupons) ? verifyCoupons[0] : verifyCoupons;
    pricingRules = Array.isArray(pricingRules) ? pricingRules : [pricingRules];
    let approvalFlag = true;
    let discountAmt = 0;
    cartObj.items.map((item) => {
      let excludingFlag = true;
      const matchingCategory = pricingRules[0]?.mPricingPcategories?.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);
      if (
        (pricingRules[0].excludeProductCategories === "Y" && matchingCategory) ||
        (pricingRules[0].excludeProductCategories !== "Y" && !matchingCategory) ||
        (pricingRules[0].excludeProductCategories === "N" && pricingRules[0].mPricingPcategories.length === 0)
      ) {
        excludingFlag = false;
      }

      const matchingBrand = pricingRules[0]?.mPricingBrands?.find((pc) => pc.mBrandId === item.productBrandId);
      if (
        (pricingRules[0].excludeBrands === "Y" && matchingBrand) ||
        (pricingRules[0].excludeBrands !== "Y" && !matchingBrand) ||
        (pricingRules[0].excludeBrands === "N" && pricingRules[0].mPricingBrands.length === 0)
      ) {
        excludingFlag = false;
      }

      const matchingProductIndex = pricingRules[0]?.mPricingXProducts?.findIndex((op) => op.mProductId === item.productId);
      if (
        (pricingRules[0].excludeProducts === "Y" && matchingProductIndex !== -1) ||
        (pricingRules[0].excludeProducts !== "Y" && matchingProductIndex === -1) ||
        (pricingRules[0].excludeProducts === "N" && pricingRules[0].mPricingXProducts.length === 0)
      ) {
        excludingFlag = false;
      }

      let pricingRuleFlag = true;

      // Apply additional logic for pricingRuleFlag based on your requirements

      if (item.discount <= 0 && item.mPricingRulesId !== null && item.mPricingRulesId !== undefined) {
        pricingRules[0].mPricingXProducts.forEach((res) => {
          if (res.mProductId === item.productId) {
            delete item.priority;
          }
        });
      }
      const saleTypeValidation =
        pricingRules[0]?.cwrSaletypeId === null || orderType === undefined ? true : pricingRules[0]?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;
      let addToCart = cart.items.filter((item) => pricingRules[0]?.mPricingXProducts?.some((pro) => item.productId === pro.mProductId));
      let iscoupon = true;
      if (
        saleTypeValidation &&
        excludingFlag &&
        pricingRuleFlag &&
        (addToCart.productId === item.productId || iscoupon) &&
        (item?.priority ? item?.priority < pricingRules[0].priority : true)
      ) {
        const offerIndex =
          pricingRules[0]?.mPricingXProducts?.length > 0 && pricingRules[0].excludeProducts === "N"
            ? pricingRules[0]?.mPricingXProducts?.findIndex((op) => op.mProductId === item.productId)
            : pricingRules[0]?.mPricingXProducts?.length > 0 && pricingRules[0].excludeProducts === "Y"
              ? pricingRules[0]?.mPricingXProducts?.findIndex((op) => op.mProductId !== item.productId)
              : 0;

        if (offerIndex >= 0 && Math.abs(item.weight) >= pricingRules[0].minimumQty) {
          if (Array.isArray(item.children) && item.children.length > 0) {
            item.children.forEach((child) => {
              const discount = ((pricingRules[0].percentageDiscount / 100) * parseFloat(child.realPrice)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);

              discountAmt += parseFloat((discount * child.weight).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
            });
          } else {
            // If no children, apply discount to parent
            const discount = ((pricingRules[0].percentageDiscount / 100) * parseFloat(item.realPrice)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision);
            discountAmt += parseFloat((discount * item.weight).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          }
        } else {
          item.discount = 0;
          delete item.nextRule;
        }
      }
    });
    if (pricingRules[0].mPricingApprovals) {
      approvalFlag = await new Promise((resolve) => {
        discountApproval(pricingRules[0].mPricingApprovals, pricingRules[0], couponInput, discountAmt, cart?.totalStd, (eventData) => {
          resolve(eventData?.approvalGranted);
        });
      });
    }

    let discardCoupon = false;
    if (pricingRules && approvalFlag) {
      setCouponModalVisible(false);
      setCouponInput("");
      const pricingRule = pricingRules[0];
      let finalObj;
      if (pricingRule.type === "TD" && pricingRule.iscoupon === "Y") {
        if (dateValidator(pricingRule.startDate, pricingRule.endDate)) {
          if (pricingRule.timeSpecific === "Y") {
            const weekDay = currentDay();
            const pStartTime = pricingRule.starttime.substring(11);
            const pEndTIme = pricingRule.endtime !== null ? pricingRule.endtime.substring(11) : moment(new Date()).format("DD-MM-YYYY HH:mm:ss").substring(11);
            const starttime = timeStamp().substring(0, 10) + " " + pStartTime;
            const endtime = timeStamp().substring(0, 10) + " " + pEndTIme;
            if (timeValidator(starttime, endtime) && pricingRule[weekDay] === "Y") {
              finalObj = processBillDiscounts(pricingRule, cart, true, couponInput, uniqReferenceId, couponData?.mPricingCouponId);
            }
          } else {
            finalObj = processBillDiscounts(pricingRule, cart, true, couponInput, uniqReferenceId, couponData?.mPricingCouponId);
          }
        }
        if (finalObj) {
          setCart(finalObj);
        }
        let filteredCoupon = finalObj?.couponInput?.findIndex((item) => item.mPricingCouponId === couponData?.mPricingCouponId);
        if (filteredCoupon >= 0) {
          message.success(`Coupon Applied: ${pricingRule.printedName}`);
          setAdditionalInfo([]);
          setCouponInput("");
        } else {
          discardCoupon = true;
        }
      }

      if (pricingRule.type === "TDF" && pricingRule.iscoupon === "Y") {
        if (dateValidator(pricingRule.startDate, pricingRule.endDate)) {
          if (pricingRule.timeSpecific === "Y") {
            const weekDay = currentDay();
            const pStartTime = pricingRule.starttime.substring(11);
            const pEndTIme = pricingRule.endtime !== null ? pricingRule.endtime.substring(11) : moment(new Date()).format("DD-MM-YYYY HH:mm:ss").substring(11);
            const starttime = timeStamp().substring(0, 10) + " " + pStartTime;
            const endtime = timeStamp().substring(0, 10) + " " + pEndTIme;
            if (timeValidator(starttime, endtime) && pricingRule[weekDay] === "Y") {
              processBillDiscounts(pricingRule, cart, true, couponInput, uniqReferenceId, couponData?.mPricingCouponId, couponData?.mPricingRulesId);
            }
          } else {
            processBillDiscounts(pricingRule, cart, true, couponInput, uniqReferenceId, couponData?.mPricingCouponId, couponData?.mPricingRulesId);
          }
        }
      }

      if (pricingRule.type !== "TDF" && pricingRule.iscoupon === "Y" && pricingRule.type !== "TD") {
        let addToCart = cart.items.filter((item) => pricingRule.mPricingXProducts.some((pro) => item.productId === pro.mProductId));

        // Check if the filtered array is empty
        if (addToCart.length === 0 && cart.items.length > 0) {
          addToCart = cart.items[cart.items.length - 1]; // Add the last item of the cart
        } else {
          addToCart = addToCart[0];
        }

        let cartObj = cart;
        let iscoupon = true;
        let expiryDiscount = localStorage.getItem("expiryDiscount") !== null && localStorage.getItem("expiryDiscount") === "Y" ? true : false;
        let updatedCart = expiryDiscount
          ? cartObj
          : await pricingRuleController(
              addToCart,
              cartObj,
              cart,
              setCart,
              cartRef,
              orderType,
              iscoupon,
              selectedCoupon?.externalCoupon === "Y" ? selectedCoupon.name : couponInput,
              uniqReferenceId,
              verifyCoupons.mPricingCouponId,
              verifyCoupons.mPricingRulesId || verifyCoupons.mPricingrulesId
            );
        let updatedTotalTax = 0;
        let updatedTotalPrice = 0;
        let updatedTotalItemsQty = 0;
        let updatedTotalDiscounts = 0;
        for (let i = 0; i < updatedCart.items.length; i += 1) {
          updatedTotalPrice += updatedCart.items[i].nettotal;
          updatedTotalItemsQty += updatedCart.items[i].weight;
          updatedTotalTax += updatedCart.items[i].taxAmount;
          updatedTotalDiscounts += updatedCart.items[i].discount;
          updatedCart.items[i].key = i;
        }

        const updatedRoundOffValue = Math.round(updatedTotalPrice);
        const updatedTotalRoundOff = updatedTotalPrice - updatedRoundOffValue;
        const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
        const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
        // 🔥 Group items by Tax Rate
        const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

        const groupedItems = allItems.reduce((acc, item) => {
          const key = item.tax?.rate ?? item.taxRate ?? "0";
          acc[key] = acc[key] || [];
          acc[key].push(item);
          return acc;
        }, {});

        const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
          const totalTaxAmount = items.reduce((sum, item) => {
            const taxValue = item.taxAmount || 0;
            return sum + parseFloat(parseFloat(taxValue).toFixed(precision));
          }, 0);

          const totalNetTotal = items.reduce((sum, item) => {
            const netValue = item.nettotal || 0;
            return sum + parseFloat(netValue);
          }, 0);

          const totalSgstAmount = items.reduce((sum, item) => {
            const sgstValue = item.sgst ?? item.tax?.sgst ?? (item.taxAmount ? parseFloat(item.taxAmount) / 2 : 0);

            return sum + parseFloat(parseFloat(sgstValue).toFixed(precision));
          }, 0);

          const totalCgstAmount = items.reduce((sum, item) => {
            const cgstValue = item.cgst ?? item.tax?.cgst ?? (item.taxAmount ? parseFloat(item.taxAmount) / 2 : 0);

            return sum + parseFloat(parseFloat(cgstValue).toFixed(precision));
          }, 0);

          return {
            taxRate,
            totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount).toFixed(precision)),
            totalLinetax: parseFloat(parseFloat(totalTaxAmount).toFixed(precision)),
            totalLinegross: parseFloat(parseFloat(totalNetTotal).toFixed(precision)),
            totalSgst: parseFloat(parseFloat(totalSgstAmount).toFixed(precision)),
            totalCgst: parseFloat(parseFloat(totalCgstAmount).toFixed(precision)),
          };
        });
        const rawCouponInfo = JSON.parse(localStorage.getItem("couponAdditionalInfo"));
        const couponInfo = {};
        // Object.entries(rawCouponInfo).forEach(([key, value]) => {
        if (rawCouponInfo && rawCouponInfo["Discount Reason"]) {
          const camelKey = toCamelCase("Discount Reason");
          couponInfo[camelKey] = rawCouponInfo["Discount Reason"];
        }
        // });

        const updatedCouponInput = updatedCart.couponInput.map((item) => (typeof item === "object" ? { ...item, percentageDiscount: pricingRules[0].percentageDiscount } : item));
        let finalCartObj = {
          ...updatedCart,
          items: [...updatedCart.items],
          couponInput: updatedCouponInput,
          total: parseFloat(parseFloat(updatedTotalPrice)?.toFixed(precision)),
          tax: parseFloat(parseFloat(updatedTotalTax)?.toFixed(precision)),
          discount: parseFloat(parseFloat(updatedTotalDiscounts)?.toFixed(precision)),
          totalQty: updatedTotalItemsQty,
          roundOff: parseFloat(parseFloat(updatedTotalRoundOff)?.toFixed(precision)),
          totalStd: updatedTotalStd,
          discountInfo: couponInfo,
          groupedItemsByTaxRate,
        };
        setCart(finalCartObj);
        localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
        let filteredCoupon = finalCartObj?.couponInput?.length > 0 ? finalCartObj?.couponInput?.findIndex((item) => item.mPricingCouponId === verifyCoupons.mPricingCouponId) : -1;
        if (filteredCoupon >= 0) {
          message.success(`Coupon Applied: ${pricingRule.printedName}`);
        } else {
          discardCoupon = true;
        }
      }

      if (discardCoupon) {
        const serverUrl = process.env.REACT_APP_serverUrl;
        const couponsData = [{ couponCode: couponInput, referenceId: uniqReferenceId }];
        // Function to discard a coupon
        const discardCoupons = async (coupon) => {
          await discardCouponService(coupon.couponCode, coupon.referenceId);
        };
        couponsData.forEach((coupon) => {
          discardCoupons(coupon);
        });
        if (pricingRule.type === "TD" || pricingRule.type === "TDF") {
          if (!finalObj) return;
          finalObj.totalBillDicount = null;
          setCart(finalObj);
        }
      }
      upsertPOSLog(cart, "CUP");
      setAdditionalInfo([]);
      setCouponModalVisible(false);
      if (searchInputRef?.current) {
        searchInputRef?.current?.focus();
      }
    } else {
      message.warning(`${messages.errors.coupons.not_available}`);
    }
  };

  const couponInfo = async (values) => {
    const formatted = {
      ...values,
      DateOfBirth: values.DateOfBirth?.format("DD-MM-YYYY"),
    };
    localStorage.setItem("couponAdditionalInfo", JSON.stringify(formatted));
    await processCouponApplication(couponVerificationData.verifyCoupons, couponVerificationData.pricingRules, couponVerificationData.uniqReferenceId);
    additionalInfoForm.resetFields();
    setShowAdditionalInfo(false);
    setShowCouponApproval(true);
  };

  const checkExternalCoupon = async (coupon) => {
    const providerConfig = coupon?.couponProvider?.[0]?.apiConfig;
    if (!providerConfig) {
      console.error("Missing coupon provider configuration");
      return;
    }
    const parsedConfig = JSON.parse(providerConfig);

    const url = parsedConfig.api_url;
    const token = parsedConfig.api_key;

    const currPrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;
    let discountAmount = 0;
    if (selectedExternalCouponType?.type === "TD") {
      discountAmount = totalBillDiscountData?.discountedAmount?.toFixed(currPrecision) || 0;
    } else {
      const discountAmt = selectedCoupon?.discountType === "V" ? (selectedCoupon?.amountDiscount ?? "") : (selectedCoupon?.percentageDiscount ?? "");
      if (cart.items.length > 0) {
        discountAmount =
          selectedExternalCouponType?.discountType === "P"
            ? (cart.items.reduce((total, item) => total + item.realPrice * item.weight, 0) * (discountAmt / 100)).toFixed(
                tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2
              )
            : discountAmt;
      }
    }

    const userId = couponInput?.includes("HTR?") ? couponInput.split("HTR?")[1] : couponInput;
    const body = {
      perk: 9,
      billAmount: cart.total,
      savings: discountAmount,
      userId: userId,
      type: "perk",
    };

    const result = await externalCoupon(url, token, body);
    if (result && result.error === false) {
      let uniqReferenceId = uuidv4().replace(/-/g, "").toUpperCase();
      processCouponApplication(selectedCoupon, selectedCoupon, uniqReferenceId);
    } else if (result.error === true) {
      message.warning(result?.data?.message);
      setCouponInput("");
      couponInputRef.current?.focus();
    }
  };

  const checkCoupon = async () => {
    if (navigator.onLine) {
      let setAuthTokens;
      if (authHeaders && authHeaders.access_token) {
        setAuthTokens = authHeaders.access_token;
      }
      let uniqReferenceId = uuidv4().replace(/-/g, "").toUpperCase();
      let couponFlag = true;
      cart?.couponInput?.forEach((coupon) => {
        if (coupon.couponCode === couponInput) {
          couponFlag = false;
        }
        // discardCoupon(coupon);
      });
      const currPrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;
      let discountAmount = 0;
      if (selectedExternalCouponType?.type === "TD") {
        discountAmount = totalBillDiscountData?.discountedAmount?.toFixed(currPrecision) || 0;
      } else {
        const discountAmt = selectedCoupon?.discountType === "V" ? (selectedCoupon?.amountDiscount ?? "") : (selectedCoupon?.percentageDiscount ?? "");
        if (cart.items.length > 0) {
          discountAmount =
            selectedExternalCouponType?.discountType === "P"
              ? (cart.items.reduce((total, item) => total + item.realPrice * item.weight, 0) * (discountAmt / 100)).toFixed(
                  tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2
                )
              : discountAmt;
        }
      }
      const finalCouponInput = selectedCoupon?.couponProvider?.[0]?.providerCode === "HUNTR" ? couponInput?.replace(/^HTR\?/, "") : couponInput;
      const mobileNo = cart?.customer?.mobileNo ? cart.customer.mobileNo : null;
      if (couponFlag) {
        try {
          const data = {
            query: `query{
              verifyCoupons(couponcode:"${finalCouponInput}",referenceId: "${uniqReferenceId}",bunitId: "${tillData.tillAccess.csBunit.csBunitId}", contactNo: ${mobileNo ? `"${mobileNo}"` : null}, pricingRuleId: ${selectedCoupon?.mPricingrulesId ? `"${selectedCoupon?.mPricingrulesId}"` : null}, billAmount: ${cart.total ? `"${cart.total}"` : null}, savings: ${discountAmount ? `"${discountAmount}"` : null}){
              mPricingCouponId
              csClientId
              csBunitId
              created
              createdBy
              updated
              updatedBy
              line
              mPricingRulesId
              couponcode
              status
              redemptionCount
              usedDate
              upc
              otp
              message
              additionalInfo {
                fieldName
                fieldType
                mandatory
                sequence
                displayLabel
                validationRule
                }
          }
      }
        `,
          };

          const verifyCouponResponse = await verifyCouponsService(data);

          const verifyCoupons = verifyCouponResponse?.data?.data?.verifyCoupons || [];
          if (verifyCoupons?.length > 0) {
            if (verifyCoupons[0].status === "A") {
              const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(verifyCoupons[0].mPricingRulesId).toArray();
              setCouponVerificationData({
                verifyCoupons: verifyCoupons[0],
                pricingRules: matchingPricingRules[0],
                uniqReferenceId,
              });

              if (verifyCoupons[0]?.additionalInfo?.length > 0) {
                // setShowAdditionalInfo(true);
                setAdditionalInfo(verifyCoupons[0]?.additionalInfo);
                return;
              }
              await processCouponApplication(verifyCoupons[0], matchingPricingRules, uniqReferenceId);
            } else if (verifyCoupons[0].status === "201") {
              message.warning(verifyCoupons[0].message);
            } else {
              message.warning(`${messages.errors.coupons.coupon_expired}`);
            }
          } else {
            Sentry.captureException(new Error("Coupon code failed"), {
              extra: {
                couponcode: couponInput,
                referenceId: uniqReferenceId,
              },
            });
            message.warning(`${t("coupon_error")}`);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        message.warning(`${messages.errors.coupons.multiple_entries}`);
      }
      setIsInputFocused(false);
    } else {
      errorMessage("Sync Failed", "Please check your network connection and try again");
    }
  };
  const removeCoupon = async (coupon) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const discardCoupon = async () => {
      try {
        const response = await discardCouponService(coupon.couponCode, coupon.referenceId);
      } catch (error) {
        console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
      }
    };
    discardCoupon();
    let latestData = removeAllDiscounts();

    let cartObj = {
      ...latestData,
      customer: selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : defaultCustomer,
    };
    cartObj.couponInput = cartObj.couponInput.filter((couponCode) => couponCode.mPricingCouponId !== coupon.mPricingCouponId);
    let updatedCart = cartObj;
    let cart = cartObj;

    if (cartObj.items.length > 0) {
      await Promise.all(
        cartObj.items.map(async (ele) => {
          let addToCart = ele;
          addToCart.nettotal = parseFloat(parseFloat(addToCart.nettotal)?.toFixed(precision));
          updatedCart = await pricingRuleController(addToCart, cartObj, cartObj, setCart, cartObj, orderType);
          return updatedCart;
        })
      );
    }
    if (cartObj.totalDiscountFlag) {
      await openPaymentModalByCustomer(updatedCart);
    }

    if (updatedCart?.couponInput?.length > 0) {
      let addToCart = cartObj.items[0];
      await Promise.all(
        updatedCart.couponInput.map(async (coupon) => {
          const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(coupon.mPricingruleId).toArray();
          if (matchingPricingRules[0].type !== "TD" && matchingPricingRules[0].type !== "TDF") {
            updatedCart = await pricingRuleController(
              addToCart,
              updatedCart,
              cart,
              setCart,
              cartRef,
              orderType,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          } else {
            updatedCart = await processBillDiscounts(
              matchingPricingRules[0],
              updatedCart,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          }
        })
      );
    }

    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    updatedCart.items = updatedCart.items.map((item, i) => {
      const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;

      // Update aggregated totals
      updatedTotalPrice += nettotalFixed;
      updatedTotalItemsQty += item.weight;
      updatedTotalTax += taxAmountFixed;
      updatedTotalDiscounts += discountFixed;

      // Update individual item properties
      item.discount = discountFixed;
      item.key = i;
      item.nettotal = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));

      if (!item.isGiftCard) {
        let lineTax = item.listPrice * (1 + item.taxRate / 100);
        let unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;
        if (!isFinite(unitPrice)) unitPrice = 0;

        let unitTax = item.taxAmount / item.weight;
        const stdTax = item.sunitprice * (1 + item.taxRate / 100);
        item.sunitprice = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(item.sunitprice + unitTax)?.toFixed(precision));
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : item.listPrice * (1 + item.taxRate / 100);
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

        item.listPrice = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
        item.linetax = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
        item.linenet = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0;
        item.linegross = Math.abs(nettotalFixed) > 0 ? nettotalFixed : 0;
        item.linestd = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0;
        item.netunit = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0;
        item.listprice = Math.abs(nettotalFixed) > 0 ? item.listPrice : 0;
        item.grossunit = Math.abs(nettotalFixed) > 0 ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0;
        item.grossstd = Math.abs(nettotalFixed) > 0 ? roundTo(grossStd, precision) : 0;
        item.grosslist = Math.abs(nettotalFixed) > 0 ? roundTo(gross_list, precision) : 0;
        item.netList = Math.abs(nettotalFixed) > 0 ? netList : 0;
        item.unitPrice = Math.abs(nettotalFixed) > 0 ? unitPrice : 0;
        item.taxAmount = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
      }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);

    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      discountInfo: [],
    };
    localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
    setCart({ ...finalCartObj });
    localStorage.removeItem("couponAdditionalInfo");
    setSelectedCoupon(null);
  };

  // Side Menu Drawer Starts //

  const [sideMenuDrawervisible, setSideMenuDrawervisible] = useState(false);
  const openSideMenu = () => {
    setSideMenuDrawervisible(true);
  };
  const onClose = () => {
    setSideMenuDrawervisible(false);
  };

  const [displayReturnOrderSearch, setDisplayReturnOrderSearch] = useState(false);

  const handleSalesReturnFromSideMenu = () => {
    setSideMenuDrawervisible(false);
    setDisplayReturnOrderSearch(true);
  };

  // Side Menu Drawer Ends //

  // OMS Orders Modal Starts //

  const omsOrderDetailsList = JSON.parse(localStorage.getItem("omsOrderDetails"));
  const initialOmsOrderList = omsOrderDetailsList ? omsOrderDetailsList : [];
  const [omsOrdersList, setOmsOrderList] = useState(initialOmsOrderList);

  const omsOrderStatus = [
    {
      title: "New",
      imgSrc: NewWhite,
      selectedImgSrc: New,
      statusValue: "NE",
    },
    {
      title: "Preparing",
      imgSrc: PreparingWhite,
      selectedImgSrc: Preparing,
      statusValue: "UP",
    },
    {
      title: "Ready",
      imgSrc: ReadyWhite,
      selectedImgSrc: Ready,
      statusValue: "PK",
    },
    {
      title: "Today's Orders",
      imgSrc: CompletedWhite,
      selectedImgSrc: Completed,
      statusValue: "DE",
    },
  ];

  const [displayOMSOrderItemsModal, setDisplayOMSOrderItemsModal] = useState(false);
  const [selectedOMSOrderStatus, setSelectedOMSOrderStatus] = useState(omsOrderStatus[0]);

  const [order, setOrder] = useState("");
  const [searchOrders, setSearchOrders] = useState(omsOrdersList);

  const [selectedOrder, setSelectedOrder] = useState({});

  const handleOmsOrders = async () => {
    setSideMenuDrawervisible(false);
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    db.orders
      .orderBy("orderTime")
      .limit(20)
      .reverse()
      .toArray()
      .then((data) => {
        if (data?.length > 0) {
          data?.map((item) => {
            let time = new Date(item.orderTime);
            let newTime = time.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            });
            let newLineItems = item?.items?.map((itemLine) => ({
              ...itemLine,
              price: itemLine?.salePrice || 0,
              quantity: itemLine?.weight || 0,
            }));
            let orderObj = {
              cWCOrderId: item.sOrderID || "",
              customerId: item?.customer?.cwrCustomerId || "",
              customerName: item?.customer?.name || "",
              lineItems: [...newLineItems],
              mobileNo: item?.customer?.mobileNo,
              noOfItems: item?.items?.length,
              orderNo: item.documentno,
              posOrders: "Y",
              status: "NE",
              total: item?.total || 0,
              totalQty: item?.totalQty || 0,
              dateCreated: newTime,
            };
            let findIndexOrder = _.findIndex(omsOrdersList, ["cWCOrderId", orderObj.cWCOrderId]);
            if (findIndexOrder === -1) {
              omsOrdersList.push(orderObj);
            } else {
              omsOrdersList[findIndexOrder] = orderObj;
            }
            return null;
          });
        }
      });
    const paramsInput = {
      query: `query{
          getNewOmsOrders(bunitId:"${tillData.tillAccess.csBunit.csBunitId}"){
          cWCOrderId
          orderNo
          dateCreated
          customerId
          customerName
          mobileNo
          total
          noOfItems
          totalQty
          lineItems{
              productId
              name
              productCode
              quantity
              price
              subTotal
              addOnProducts{
                  id
                  name
                  price
              }
          }
      }
      }`,
    };
    try {
      const response = await getNewOmsOrder(paramsInput);

      const { getNewOmsOrders } = response?.data?.data || {};
      if (getNewOmsOrders) {
        const updatedOmsOrders = [...omsOrdersList];

        for (const item of getNewOmsOrders) {
          const obj = {
            ...item,
            status: "NE",
            noOfItems: item.lineItems.length,
            posOrders: "N",
            dateCreated: new Date(item.dateCreated).toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            }),
          };

          const findIndex = _.findIndex(updatedOmsOrders, ["cWCOrderId", item.cWCOrderId]);
          if (findIndex === -1) {
            updatedOmsOrders.push(obj);
          } else {
            updatedOmsOrders[findIndex] = obj;

            const prodCodes = _.map(updatedOmsOrders[findIndex]?.lineItems || [], "productCode");
            const productsFetched = await db.products
              .where("value")
              .startsWithAnyOfIgnoreCase(prodCodes)
              .and((product) => product.isactive === true)
              .toArray();

            if (productsFetched?.length > 0) {
              const newLineItems = updatedOmsOrders[findIndex].lineItems.map((lineItem) => {
                const product = productsFetched.find((product) => product.value === lineItem.productCode);
                return product ? { ...lineItem, img: product.imageurl } : { ...lineItem };
              });
              updatedOmsOrders[findIndex].lineItems = newLineItems;
            }
          }
        }

        // Update localStorage and state with the updated orders
        localStorage.setItem("omsOrderDetails", JSON.stringify(updatedOmsOrders));
        setOmsOrderList(updatedOmsOrders);
      }
    } catch (error) {
      console.error("Error processing OMS orders:", error);
    }

    setDisplayOMSOrderItemsModal(true);
  };

  const handleOMSOrderStatusSelection = (record) => {
    setSelectedOMSOrderStatus(record);
  };

  const setOMSStatus = (status) => {
    let newOMSStatus = "";
    switch (status) {
      case "NE":
        newOMSStatus = "UP";
        break;
      case "UP":
        newOMSStatus = "PK";
        break;
      case "PK":
        newOMSStatus = "DE";
        break;
      default:
        newOMSStatus = "NE";
    }
    return newOMSStatus;
  };

  const nextOMSOrderStatus = () => {
    let newOMSOrderStatus = [...omsOrderStatus];
    let statusIndex = _.findIndex(newOMSOrderStatus, (item) => item.title === selectedOMSOrderStatus.title);
    if (statusIndex <= newOMSOrderStatus.length - 1) setSelectedOMSOrderStatus(newOMSOrderStatus[statusIndex + 1]);
  };

  const handleOMSStatusButton = async (record) => {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    const paramsInput = {
      query: `mutation{
          updateOMSOrderStatus(order:{
              cWCOrderId: "${record.cWCOrderId}"
              status: "${setOMSStatus(record.status)}"
          })
          {
              status
              message
          }
      }`,
    };
    try {
      const response = await updateOmsOrder(paramsInput);

      if (response?.data?.data?.updateOMSOrderStatus?.status === "200") {
        const newOMSOrderDetails = omsOrdersList.map((order) => (order.cWCOrderId === record.cWCOrderId ? { ...order, status: setOMSStatus(record.status) } : order));

        localStorage.setItem("omsOrderDetails", JSON.stringify(newOMSOrderDetails));
        setOmsOrderList(newOMSOrderDetails);
        nextOMSOrderStatus();
      } else {
        console.error("Failed to update OMS order status:", response?.data?.data);
      }
    } catch (error) {
      console.error("Error in updating OMS order status:", error);
    }
  };

  const handleOrderCard = (record) => {
    setSelectedOrder(record);
    handleOMSOrderStatusSelection(_.filter(omsOrderStatus, (statusItem) => statusItem.statusValue === record.status)?.[0]);
  };

  const handleOrderSearchInput = (value) => {
    if (value !== "") {
      const results = omsOrdersList.filter((orderDetails) => {
        return orderDetails.orderNo.startsWith(value);
      });
      setSearchOrders(results);
    } else {
      setSearchOrders(omsOrdersList);
    }
    setOrder(value);
  };

  const omsOrderTotalPrice = _.sumBy(selectedOrder.lineItems, "price");

  // OMS Orders Modal Ends //

  // Sales Representative Modal Starts //
  const [openSalesRep, setOpenSalesRep] = useState({ flag: false, level: "" });
  const [salesRepModalOpen, setSalesRepModalOpen] = useState({
    status: false,
    title: "",
  });
  const [salesRepresent, setSalesRepresent] = useState({});
  const [salesRepresentDefaultLine, setSalesRepresentDefaultLine] = useState({ salesRepresentId: null, name: null });

  const handleSalesRepresentive = (record) => {
    if (salesRepModalOpen.title === "orderSalesRep") {
      setSalesRepresentDefaultLine({ ...record });
      setCart({
        ...cart,
        salesRepId: record.salesRepresentId,
      });
      localStorage.setItem(
        "cartObj",
        JSON.stringify({
          ...cart,
          salesRepId: record.salesRepresentId,
        })
      );
      setSalesRepresent(record);
    } else if (salesRepModalOpen.title === "itemSalesRep" && !_.isEmpty(selectedProductInCart)) {
      setSalesRepresentDefaultLine({ ...record });
      let lineItemsData = [...cart.items];
      const lineItemsIndex = _.findIndex(lineItemsData, (item) => item.productId === selectedProductInCart.productId);
      lineItemsData[lineItemsIndex]["salesRepId"] = record.salesRepresentId;
      lineItemsData[lineItemsIndex]["salesRepName"] = record.name;

      setCart({
        ...cart,
        items: lineItemsData,
      });
      localStorage.setItem(
        "cartObj",
        JSON.stringify({
          ...cart,
          items: lineItemsData,
        })
      );
    }
    setSalesRepModalOpen({ status: false, title: "" });
  };

  const [salesRepresentSearchInput, setSalesRepresentSearchInput] = useState("");
  const salesReprestiveList = tillData.tillAccess.csBunit.salesRep;
  const [filteredSalesRepresentList, setFilteredSalesRepresentList] = useState(salesReprestiveList);

  const handleSalesRepresentSearchInput = (value) => {
    if (value !== "") {
      const results = salesReprestiveList.filter((list) => {
        return list.name.toLowerCase().startsWith(value.toLowerCase());
      });
      setFilteredSalesRepresentList(results);
    } else {
      setFilteredSalesRepresentList(salesReprestiveList);
    }
    setSalesRepresentSearchInput(value);
  };

  const handleKey = (e) => {
    const { altKey, keyCode } = e;
    if (altKey) {
      if (keyCode === 83) {
        if (posConfig?.showLineSalesRep === "Y") {
          setSalesRepModalOpen({ status: true, title: "itemSalesRep" });
          setSalesRepresentSearchInput("");
          setFilteredSalesRepresentList(salesReprestiveList);
        }
      }
      if (keyCode === 67) {
        setSelectedRowKeys((v) => {
          if (v.length > 0) {
            return [];
          } else {
            return [0];
          }
        });
      }
      if (keyCode === 80) {
        openPaymentModal();
      }

      if (keyCode === 79) {
        setDisplayOrderHistory(true);
      }

      if (keyCode === 66) {
        setDisplayParkedBillModal(true);
      }

      if (keyCode === 73) {
        if (selectedRowKeysRef.current.length > 0) {
          setIsQtyUpdate(selectedProductInCartRef.current);
        }
      }

      if (keyCode === 76) {
        parkBill("parkKey");
      }

      if (keyCode === 72) {
        confirmDiscardCart();
      }
    }

    if (keyCode === 115) {
      setTimeout(() => {
        // productSearchInputRef.current.focus();
      }, 100);
    }
    if (keyCode === 27) {
      if ((e.target.id === "productSearchInputId" || e.target.id.search("productCardItem")) >= 0) {
        closeProductPanel();
      }
      setDisplayBatchSelection((b) => {
        if (b) {
          return !b;
        } else {
          return b;
        }
      });
      setSalesRepModalOpen({ status: false, title: "" });
      setSalesRepresentSearchInput("");
      closeCustomerSearch();

      if (paymentModalStateRef.current) {
        closePaymentModal();
      }
    }
    if (keyCode === 38) {
      setSelectedRowKeys((v) => {
        if (v.length > 0 && v[0] > 0) {
          return [v[0] - 1];
        } else {
          return [v[0]];
        }
      });
    }
    if (keyCode === 40) {
      setSelectedRowKeys((v) => {
        if (v.length > 0 && v[0] < cartItemsLengthRef.current - 1) {
          return [v[0] + 1];
        } else {
          return [v[0]];
        }
      });
    }

    if (keyCode === 187 || keyCode === 107) {
      if (selectedRowKeysRef.current.length > 0 && !selectedItemsModalOpen && cart.saleType.value !== "DI") {
        increaseProductQty(selectedProductInCartRef.current);
      }
    }
    if (keyCode === 109 || keyCode === 189) {
      if (selectedRowKeysRef.current.length > 0 && !selectedItemsModalOpen && cart.saleType.value !== "DI") {
        if (parseFloat(selectedProductInCartRef.current.weight) > 1) {
          decreaseProductQty(selectedProductInCartRef.current);
        }
      }
    }
    if (keyCode === 46) {
      if (selectedRowKeysRef.current.length > 0) {
        deleteProduct(selectedProductInCartRef.current);
      }
    }
  };

  const cartItemsLengthRef = useRef(0);
  const [cartObj, setOrderObj] = useState(null);

  // useEffect(() => {
  //   cartItemsLengthRef.current = cart.items.length;
  //   // setAmount((Math.abs(cart.total) - cart.paid)?.toFixed(precision));
  //   setAmount(parseFloat(parseFloat(Math.abs(cart.total) - (cart.paid ?? 0))?.toFixed(precision)));
  //   let flag = tillLayout !== 1 ? true : false;
  //   if (Math.abs(cart.total) <= cart.paid && cart.payments.length > 0 && flag && cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
  //     orderState.current = 0;
  //     setPaymentProcessFlag(false);
  //     processOrder(cart.sOrderID);
  //   } else if (Math.abs(cart.total) <= cart.paid && cart.payments.length > 0 && flag && (cart.layAway !== "Y" || cart.preOrder === "Y")) {
  //     orderState.current = 0;
  //     setPaymentProcessFlag(false);
  //     processOrder(cart.sOrderID);
  //   }
  //   try {
  //     const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
  //     if (cartDetails !== null) {
  //       setOrderObj(cartDetails);
  //     }
  //   } catch (error) {
  //     console.error("Error parsing cart details:", error);
  //   }
  //   if (cart.discount) {
  //     upsertPOSLog(cart, "DAP");
  //   }
  // }, [cart]);

  useEffect(() => {
    cartItemsLengthRef.current = cart.items.length;
    // setAmount((Math.abs(cart.total) - cart.paid)?.toFixed(precision));
    // setAmount(parseFloat(parseFloat(Math.abs(cart.total) - (cart.paid ?? 0) + cart?.deiveryCharge + cart?.tip + cart?.serviceCharge + cart?.packingCharge)?.toFixed(precision)));
    setAmount(
      parseFloat(
        (Math.abs(cart.total) - (cart.paid ?? 0) + (cart?.deiveryCharge ?? 0) + (cart?.tip ?? 0) + (cart?.serviceCharge ?? 0) + (cart?.packingCharge ?? 0)).toFixed(precision)
      )
    );
    let flag = tillLayout !== 1 ? true : false;
    if (Math.abs(cart.total) <= cart.paid && cart.payments.length > 0 && flag && cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
      orderState.current = 0;
      setPaymentProcessFlag(false);
      processOrder(cart.sOrderID);
    } else if (Math.abs(cart.total) <= cart.paid && cart.payments.length > 0 && flag && (cart.layAway !== "Y" || cart.preOrder === "Y")) {
      orderState.current = 0;
      setPaymentProcessFlag(false);
      processOrder(cart.sOrderID);
    }
    try {
      const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
      if (cartDetails !== null) {
        setOrderObj(cartDetails);
      }
    } catch (error) {
      console.error("Error parsing cart details:", error);
    }
    if (cart.discount) {
      upsertPOSLog(cart, "DAP");
    }
  }, [cart]);

  const selectedProductInCartRef = useRef({});
  useEffect(() => {
    selectedProductInCartRef.current = selectedProductInCart;
  }, [selectedProductInCart]);

  const selectedRowKeysRef = useRef([0]);
  useEffect(() => {
    selectedRowKeysRef.current = selectedRowKeys;
    if (selectedRowKeys.length > 0) {
      const cartIndex = cart.items.findIndex((ci) => ci.key === selectedRowKeys[0]);
      // setSelectedProductInCart({ ...cart.items[cartIndex] });
    }
  }, [selectedRowKeys]);

  const paymentModalStateRef = useRef(false);
  useEffect(() => {
    paymentModalStateRef.current = paymentModal;
    if (paymentModal) {
      setSelectedPaymentMethod(tillDataPaymentMethods.filter((item, index) => item.isDefault === "Y")?.[0] || {});
    }
  }, [paymentModal]);

  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  });

  // Sales Representative Modal Ends //

  const [manualDiscountModalVisible, setManualDiscountModalVisible] = useState(false);
  const [manualDiscountInput, setManualDiscountInput] = useState("");
  const [manualDiscountTypes, setManualDiscountTypes] = useState([]);
  const [selectedManualDiscountType, setSelectedManualDiscountTypeValue] = useState("");
  const [enableManualDiscountInput, setEnableManualDiscountInput] = useState(false);

  const [selectedExternalCouponType, setSelectedExternalCouponTypeValue] = useState("");
  const [externalCouponTypes, setExternalCouponTypes] = useState([]);

  useEffect(() => {
    db.pricingRules.toArray().then((pr) => {
      const bunitId = tillData.tillAccess.csBunit.csBunitId;
      const manualPricingRules = pr.filter((rule) => {
        if (rule.manualDiscount === "Y") {
          if (rule.excludeBusinessUnits === "Y") {
            if (rule.mPricingBUnits.length === 0) return rule;
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId !== bunitId);
            if (index !== -1) {
              return rule;
            }
          } else {
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId === bunitId);
            if (index >= 0) {
              return rule;
            }
          }
        }
      });
      setManualDiscountTypes([...manualPricingRules]);
    });
  }, []);

  useEffect(() => {
    db.pricingRules.toArray().then((pr) => {
      const bunitId = tillData.tillAccess.csBunit.csBunitId;
      const manualPricingRules = pr.filter((rule) => {
        if (rule.iscoupon === "Y") {
          if (rule.excludeBusinessUnits === "Y") {
            if (rule.mPricingBUnits.length === 0) return rule;
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId !== bunitId);
            if (index !== -1) {
              return rule;
            }
          } else {
            const index = rule.mPricingBUnits.findIndex((Bunit) => Bunit.mBunitPricingId === bunitId);
            if (index >= 0) {
              return rule;
            }
          }
        }
      });
      setExternalCouponTypes([...manualPricingRules]);
    });
  }, []);

  useEffect(() => {
    manualDiscountForm.setFieldsValue({
      discountValue: manualDiscountInput,
    });
  }, [manualDiscountInput]);

  const setSelectedExternalCouponType = (value) => {
    if (value !== "") {
      const mdi = externalCouponTypes.findIndex((md) => md.mPricingrulesId === value);
      setSelectedExternalCouponTypeValue(externalCouponTypes[mdi]);
      const discountValue = externalCouponTypes[mdi]?.discountType === "V" ? (externalCouponTypes[mdi].amountDiscount ?? "") : (externalCouponTypes[mdi]?.percentageDiscount ?? "");
      if (discountValue) {
        setManualDiscountInput(discountValue);
        setEnableManualDiscountInput(true);
      } else {
        setManualDiscountInput("");
        setEnableManualDiscountInput(false);
      }
    }
  };

  const setSelectedManualDiscountType = (value) => {
    if (value !== "") {
      const mdi = manualDiscountTypes.findIndex((md) => md.mPricingrulesId === value);
      setSelectedManualDiscountTypeValue(manualDiscountTypes[mdi]);
      const discountValue = manualDiscountTypes[mdi]?.discountType === "V" ? (manualDiscountTypes[mdi].amountDiscount ?? "") : (manualDiscountTypes[mdi]?.percentageDiscount ?? "");
      if (discountValue) {
        setManualDiscountInput(discountValue);
        setEnableManualDiscountInput(true);
      } else {
        setManualDiscountInput("");
        setEnableManualDiscountInput(false);
      }
    }
  };

  const [manualDiscountForm] = Form.useForm();

  const handleManualDiscountKeyPress = (value) => {
    if (!enableManualDiscountInput) {
      if (manualDiscountInput === "" && value === "x") {
        manualDiscountForm.setFieldsValue({ discountValue: "" });
        setManualDiscountInput("");
      } else if (value === "x") {
        const updatedValue = manualDiscountInput.toString().slice(0, -1);
        manualDiscountForm.setFieldsValue({ discountValue: updatedValue });
        setManualDiscountInput(updatedValue);
      } else if (value === "clear") {
        manualDiscountForm.setFieldsValue({ discountValue: "" });
        setManualDiscountInput("");
      } else {
        const newInput = `${manualDiscountInput}${value}`;
        manualDiscountForm.setFieldsValue({ discountValue: newInput });
        setManualDiscountInput(newInput);
      }
    }
  };

  const validateUserPin = async (user, pin) => {
    return pin === "1234";
  };

  const discountInforApplication = async (values) => {
    const formatted = {
      ...values,
      DateOfBirth: values.DateOfBirth?.format("DD-MM-YYYY"),
    };
    localStorage.setItem("discountAdditionalInfo", JSON.stringify(formatted));
    let approvalFlag = true;
    const minValue = discountVerificationData.pricingRule?.mPricingApprovals?.reduce((min, item) => Math.min(min, item.min), Infinity);
    const maxValue = discountVerificationData.pricingRule?.mPricingApprovals?.reduce((max, item) => Math.max(max, item.max), -Infinity);
    if (!discountVerificationData.matchingApproval && discountVerificationData.values.discountValue > minValue) {
      message.warning(`${messages.errors.discounts.approval_required}`);
      return;
    } else if (discountVerificationData.values.discountValue >= minValue && discountVerificationData.values.discountValue <= maxValue) {
      const discountAppliedValues = JSON.parse(localStorage.getItem("discountAppliedData"));
      const discountedAmount = totalBillDiscountData?.discountedAmount > 0 ? totalBillDiscountData.discountedAmount : discountAppliedValues?.discountedAmount;
      const totalBillPrice = totalBillDiscountData?.totalBillPrice > 0 ? totalBillDiscountData.totalBillPrice : discountAppliedValues?.totalBillPrice;
      approvalFlag = await new Promise((resolve) => {
        discountApproval([discountVerificationData.matchingApproval], discountVerificationData.pricingRule, null, discountedAmount, totalBillPrice, (eventData) => {
          resolve(eventData?.approvalGranted);
        });
      });
    } else if (discountVerificationData.values.discountValue > maxValue) {
      return;
    }
    if (!approvalFlag) return;
    await processManualDiscount(discountVerificationData.pricingRule, discountVerificationData.matchingApproval, discountVerificationData.values);
    discountAdditionalInfoForm.resetFields();
    // setManualDiscountModalVisible(false);
  };

  const processManualDiscount = async (pricingRule, matchingApproval, values) => {
    setManualDiscountModalVisible(false);
    let updatedCart = cart;
    if (pricingRule.type === "FD" && Object.keys(selectedProductInCart).length > 0) {
      try {
        const newCart = await CheckoutFlatDiscount(selectedProductInCart, pricingRule, setCart, updatedCart, orderType, updatedCart, values.discountValue, matchingApproval);
        updatedCart = newCart;
      } catch (err) {
        console.error("Error applying flat discount:", err);
      }
    } else if (pricingRule.type === "PD" && Object.keys(selectedProductInCart).length > 0) {
      try {
        const newCart = await CheckoutPercentageDiscount(selectedProductInCart, pricingRule, setCart, updatedCart, orderType, updatedCart, values.discountValue, matchingApproval);
        updatedCart = newCart;
      } catch (err) {
        console.error("Error applying percentage discount:", err);
      }
    } else if (pricingRule.type === "TD") {
      try {
        const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, values.discountValue, matchingApproval);
        updatedCart = newCart;
      } catch (err) {
        console.error("Error applying total manual discount:", err);
      }
    }

    const itemsSummery = {
      decimalItems: { totalQty: 0, totalAmount: 0 },
      nonDecimalItems: { totalQty: 0, totalAmount: 0 },
      itemsQty: 0,
      items: 0,
    };

    // Group items by tax rate
    const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

    const groupedItems = allItems.reduce((acc, item) => {
      const key = item.tax?.rate ?? item.taxRate ?? "0";
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    // Calculate tax totals with SGST and CGST
    const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
      const totalTaxAmount = items.reduce((sum, item) => {
        const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
        return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
      }, 0);

      const totalNetTotal = items.reduce((sum, item) => {
        const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
        return sum + parseFloat(netValue);
      }, 0);

      // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
      const totalSgstAmount = items.reduce((sum, item) => {
        const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
      }, 0);

      const totalCgstAmount = items.reduce((sum, item) => {
        const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
      }, 0);

      return {
        taxRate,
        totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
        totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
        totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
        totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
        totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
      };
    });

    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    updatedCart.items = updatedCart.items.map((item, i) => {
      const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
      const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? item.discount : 0;

      // Update totals
      updatedTotalPrice += nettotalFixed;
      updatedTotalItemsQty += item.weight;
      updatedTotalTax += taxAmountFixed;
      updatedTotalDiscounts += discountFixed;

      item.discount = discountFixed;
      item.key = i;

      if (!item.isGiftCard) {
        const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;

        const lineTax = item.listPrice * (1 + item.taxRate / 100);
        const stdTax = item.sunitprice * (1 + item.taxRate / 100);
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

        Object.assign(item, {
          linetax: nettotalFixed ? taxAmountFixed : 0,
          linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
          linegross: nettotalFixed || 0,
          linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
          netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          listprice: nettotalFixed ? item.listPrice : 0,
          grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
          grossstd: nettotalFixed ? grossStd : 0,
          grosslist: nettotalFixed ? roundTo(gross_list, precision) : 0,
          netList: nettotalFixed ? netList : 0,
          unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          taxAmount: nettotalFixed ? taxAmountFixed : 0,
        });
      }

      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children = item.children.map((child, i) => {
          const childNettotalFixed = parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
          const childTaxAmountFixed = parseFloat(parseFloat(child.taxAmount)?.toFixed(precision));
          const childDiscountFixed = child.discount ? child.discount : 0;
          child.discount = childDiscountFixed;
          child.key = i;
          if (!child.isGiftCard) {
            const unitPrice = isFinite(child.nettotal / child.weight) ? (taxIncludeFlag === "Y" ? child.nettotal / child.weight / (1 + child.taxRate / 100) : child.salePrice) : 0;

            const lineTax = child.listPrice * (1 + child.taxRate / 100);
            const stdTax = child.sunitprice * (1 + child.taxRate / 100);
            const grossUnit = Math.abs(child.sunitprice) - Math.abs(child.discount) / Math.abs(child.weight);
            const netList =
              taxIncludeFlag === "Y"
                ? child.listPrice - parseFloat(parseFloat(child.listPrice - child.listPrice / (1 + child.taxRate / 100))?.toFixed(precision))
                : child.listPrice;
            const gross_list = taxIncludeFlag === "Y" ? child.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
            const grossStd = taxIncludeFlag === "Y" ? child.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));

            Object.assign(child, {
              linetax: childNettotalFixed ? childTaxAmountFixed : 0,
              linenet: childNettotalFixed ? parseFloat(parseFloat(child.nettotal - child.taxAmount)?.toFixed(precision)) : 0,
              linegross: childNettotalFixed || 0,
              linestd: childNettotalFixed ? parseFloat(parseFloat(grossStd * child.weight)?.toFixed(precision)) : 0,
              netunit: childNettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
              listprice: childNettotalFixed ? child.listPrice : 0,
              grossunit: childNettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (child.isReturn ? -1 : 1) : 0,
              grossstd: childNettotalFixed ? grossStd : 0,
              grosslist: childNettotalFixed ? gross_list : 0,
              netList: childNettotalFixed ? netList : 0,
              unitPrice: childNettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
              taxAmount: childNettotalFixed ? childTaxAmountFixed : 0,
            });
          }
          return child;
        });
        item.children.forEach((child) => {
          const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemsSummery.itemsQty += child.weight;
          itemsSummery.items += 1;
          itemsSummery[summaryKey].totalQty += child.weight;
          itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
        });
      } else {
        const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemsSummery.itemsQty += item.weight;
        itemsSummery.items += 1;
        itemsSummery[summaryKey].totalQty += item.weight;
        itemsSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      }

      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines?.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
    const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart?.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      subTotal: parseFloat(parseFloat(updatedTotalPrice - updatedTotalTax)?.toFixed(precision)),
      itemsSummery,
      groupedItemsByTaxRate,
      totalStd: updatedTotalStd,
    };
    localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
    setCart({ ...finalCartObj });
    upsertPOSLog("DAP");
    setDiscountAdditionalInfo([]);
    localStorage.removeItem("discountAppliedData");
    if (pricingRule.type === "TD") {
      verifyStock();
    }
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
  };

  const applyManualDiscount = async (values) => {
    setManualDiscountInput("");
    setSelectedManualDiscountTypeValue(null);
    if (selectedManualDiscountType && values.discountName && values.discountValue && cart.items.length > 0) {
      manualDiscountForm.resetFields();
      // setManualDiscountModalVisible(false);
      const pr = await db.pricingRules.toArray();
      const pricingRule = pr[pr.findIndex((md) => md.mPricingrulesId === values.discountName && md.manualDiscount === "Y")];
      if (pricingRule.discountType === "P" && values.discountValue > 100 && pricingRule.type === "TD") {
        message.error(`${messages.errors.discounts.percentage_exceeds_limit}`);
        return;
      } else if (pricingRule.discountType === "V" && values.discountValue > cart.total) {
        message.error(`${messages.errors.discounts.amount_exceeds_total}`);
        return;
      }

      if (values.discountValue > 100 && pricingRule.type === "PD") {
        message.error(`${messages.errors.discounts.percentage_exceeds_limit}`);
        return;
      } else if (values.discountValue > selectedProductInCart.nettotal && pricingRule.type === "FD") {
        message.error(`${messages.errors.discounts.amount_exceeds_total}`);
        return;
      }
      let approvalFlag = true;
      let discountValue = values.discountValue;
      let matchingApproval;
      const minValue = pricingRule?.mPricingApprovals?.reduce((min, item) => Math.min(min, item.min), Infinity);
      const maxValue = pricingRule?.mPricingApprovals?.reduce((max, item) => Math.max(max, item.max), -Infinity);
      if (pricingRule?.mPricingApprovals?.length > 0 && pricingRule?.enableApproval === "Y") {
        matchingApproval = pricingRule.mPricingApprovals.find((approval) => {
          if (approval.type === "P") {
            if (pricingRule.discountType === "V") {
              if (pricingRule.type === "TD") {
                discountValue = (values.discountValue / cart.total) * 100;
              } else {
                discountValue = (values.discountValue / selectedProductInCart.nettotal) * 100;
              }
              return discountValue >= approval.min && (approval?.max ? discountValue <= approval.max : true);
            } else {
              return values.discountValue >= approval.min && (approval?.max ? values.discountValue <= approval.max : true);
            }
          } else if (approval.type === "V") {
            if (pricingRule.discountType === "P") {
              if (pricingRule.type === "TD") {
                discountValue = (values.discountValue / 100) * cart.total;
              } else {
                discountValue = (values.discountValue / 100) * selectedProductInCart.nettotal;
              }
              return discountValue >= approval.min && (approval?.max ? discountValue <= approval.max : true);
            } else {
              return values.discountValue >= approval.min && (approval?.max ? values.discountValue <= approval.max : true);
            }
          }
        });

        localStorage.setItem("discountAppliedData", JSON.stringify(totalBillDiscountData));

        if (pricingRule?.additionalInfo?.length > 0) {
          setDiscountVerifictionData({
            pricingRule: pricingRule,
            matchingApproval: matchingApproval,
            values: values,
          });
          setDiscountAdditionalInfo(pricingRule.additionalInfo);
          return;
        }
        if (!matchingApproval && discountValue > minValue) {
          message.warning(`${messages.errors.discounts.approval_required}`);
          return;
        } else if (discountValue >= minValue && discountValue <= maxValue) {
          approvalFlag = await new Promise((resolve) => {
            discountApproval([matchingApproval], pricingRule, null, totalBillDiscountData?.discountedAmount, totalBillDiscountData?.totalBillPrice, (eventData) => {
              resolve(eventData?.approvalGranted);
            });
          });
        } else if (discountValue > maxValue) {
          return;
        }
      }

      if (!approvalFlag) return;
      processManualDiscount(pricingRule, matchingApproval, values);
    } else {
      message.warning(`${messages.info.valid_input}`);
    }
  };

  const processLineManualDiscount = () => {
    const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === selectedManualDiscountType)];
    if (pricingRule.type === "V") {
      CheckoutFlatDiscount(cart, setCart, selectedRowKeys, pricingRule, manualDiscountInput, tillaccess);
    }

    if (pricingRule.type === "P") {
      CheckoutPercentageDiscount(cart, setCart, selectedRowKeys, pricingRule, manualDiscountInput, tillaccess);
    }
    setSelectedRowKeys([]);
  };

  const processTotalManualDiscount = (discountParam) => {
    CheckoutTotalManualDiscount(discountParam, setCart, cart, manualDiscountTypes, selectedManualDiscountType, manualDiscountInput, tillaccess);
  };

  const removeAllDiscounts = (discountFlag = false, type = false) => {
    setManualDiscountModalVisible(false);
    setManualDiscountInput(null);
    setSelectedManualDiscountTypeValue(null);
    const cartItems = cart.items;
    let updatedCart = cart;
    function calculateCartItem(addedToCart) {
      if (addedToCart.children && addedToCart.children.length > 0) {
        addedToCart.children = addedToCart.children.map((child) => calculateCartItem(child));
        addedToCart.children.forEach((child, index) => {
          const taxInclude = (child.realPrice * child.taxRate) / 100;
          const sp = ((taxIncludeFlag === "Y" ? child.realPrice : child.realPrice + taxInclude) * child.weight || child.nettotal) - child.discount;
          const tax = sp - sp / (1 + child.taxRate / 100);
          child.nettotal = sp;
          child.taxAmount = tax;
        });
        const childrenNetTotal = addedToCart.children.reduce((sum, child) => sum + (child.nettotal || 0), 0);
        const childrenTaxAmount = addedToCart.children.reduce((sum, child) => sum + (child.taxAmount || 0), 0);

        addedToCart.salePrice = addedToCart.realPrice;
        addedToCart.taxAmount = parseFloat(parseFloat(childrenTaxAmount)?.toFixed(precision));
        addedToCart.nettotal = parseFloat(parseFloat(childrenNetTotal)?.toFixed(precision));
        addedToCart.discount = 0;
        addedToCart.discountName = "";
        addedToCart.nextRule = "N";
        addedToCart.mPricingruleId = "";
        delete addedToCart.priority;
      } else {
        const sp = parseFloat(addedToCart.realPrice);
        const mrp = parseFloat(parseFloat(parseFloat(sp) * addedToCart.weight)?.toFixed(precision));
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart.taxRate / 100) : mrp * (addedToCart.taxRate / 100);
        addedToCart.salePrice = sp;
        addedToCart.taxAmount = parseFloat(parseFloat(tax)?.toFixed(precision));
        addedToCart.mPricingruleId = "";
        addedToCart.nettotal = taxIncludeFlag === "Y" ? mrp : parseFloat(parseFloat(parseFloat(mrp) + tax)?.toFixed(precision));
        addedToCart.discount = 0;
        addedToCart.discountName = "";
        addedToCart.nextRule = "N";
        delete addedToCart.priority;
      }
      return addedToCart;
    }

    const pricingRuleIndex = manualDiscountTypes.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId);

    cartItems.forEach((addedToCart, i) => {
      if ((pricingRuleIndex === undefined || !manualDiscountTypes[pricingRuleIndex]) && !type) {
        updatedCart.manualDiscountData = {
          totalLevelDiscount: [],
          lineLevelDiscount: updatedCart?.manualDiscountData?.lineLevelDiscount || [],
        };
        addedToCart.allDiscounts = [];
        addedToCart.approval = [];
        cartItems[i] = calculateCartItem(addedToCart);
        return;
      }
      if (discountFlag && manualDiscountTypes[pricingRuleIndex].type !== "TD" && selectedProductInCart.lineId === addedToCart.lineId) {
        updatedCart.manualDiscountData.lineLevelDiscount = updatedCart.manualDiscountData?.lineLevelDiscount?.filter((item) => item.lineId !== addedToCart.lineId);
        addedToCart.allDiscounts = (addedToCart.allDiscounts || [])?.filter((item) => item.mPricingruleId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
        addedToCart.approval = (addedToCart?.approval || [])?.filter((item) => item.mPricingrulesId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
      } else if (
        discountFlag &&
        manualDiscountTypes[pricingRuleIndex].type === "TD" &&
        selectedProductInCart.mPricingruleId === manualDiscountTypes[pricingRuleIndex].mPricingrulesId
      ) {
        updatedCart.manualDiscountData.totalLevelDiscount = updatedCart.manualDiscountData?.totalLevelDiscount?.filter(
          (item) => item.pricingRule !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId
        );
        addedToCart.allDiscounts = (addedToCart.allDiscounts || [])?.filter((item) => item.mPricingruleId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
        addedToCart.approval = (addedToCart?.approval || [])?.filter((item) => item.mPricingrulesId !== manualDiscountTypes[pricingRuleIndex].mPricingrulesId);
      } else if (!discountFlag && Object.keys(selectedProductInCart).length === 0 && !type) {
        updatedCart.manualDiscountData = {};
      }
      cartItems[i] = calculateCartItem(addedToCart);
    });

    let totalTax = 0;
    let totalPrice = 0;
    let totalItemsQty = 0;
    let totalDiscounts = 0;

    for (let i = 0; i < cartItems.length; i += 1) {
      totalPrice += cartItems[i].nettotal;
      totalItemsQty += cartItems[i].weight;
      totalTax += cartItems[i].taxAmount;
      totalDiscounts += cartItems[i].discount;
      cartItems[i].key = i;
    }

    const roundOffValue = Math.round(totalPrice);
    const totalRoundOff = totalPrice - roundOffValue;
    totalPrice = roundOffValue;

    delete cart["manualDiscountApplied"];

    const tableName = localStorage.getItem("tableName");
    if (tillaccess?.layout === "2" && localStorage.getItem("dineIn") === "Y" && tableName) {
      let obj;
      const fbOrderData = JSON.parse(localStorage.getItem("tableName"));
      db.fbOrderData
        .where("cwrFbTableId")
        .equals(fbOrderData?.cwrFbTableId)
        .toArray()
        .then((ordersFetched) => {
          if (ordersFetched.length > 0) {
            ordersFetched.map(async (fbOrder) => {
              if (fbOrder.fbOrderStatus === "IP") {
                let orderLines = [];
                fbOrder.cart = {
                  ...cart,
                  items: [...cartItems],
                  total: parseFloat(totalPrice.toFixed(precision)),
                  tax: totalTax,
                  discount: totalDiscounts,
                  totalQty: totalItemsQty,
                  roundOff: totalRoundOff,
                };
                fbOrder.fbOrderSync = "N";
                fbOrder.lines = orderLines;
                cartItems.map((obj) => {
                  orderLines.push(`{
                    fbOrderId: "${fbOrder.fbOrderId}"
                    fbOrderLineId: "${obj.fbOrderLineId}"
                    mPoductId: "${obj.productId}"
                    mBatchId: null
                    description: "good"
                    csUomId: "${obj.uom}"
                    csTaxId: "${obj.tax}"
                    discount:${obj.discount}
                    line: 1
                    qty: ${obj.weight}
                    unitPrice: ${obj.realPrice}
                    listPrice: 30
                    lineNet: 2.6
                    lineTax: ${obj.taxRate}
                    lineGross: 30
                    sOrderLineId: null
                    isOrdered: "Y"
                    meta:[]
                    }`);
                });
                await db.fbOrderData.put(fbOrder, fbOrder.fbOrderId);
                obj = {
                  fbOrder: {
                    fbOrderId: fbOrder.fbOrderId,
                    order: fbOrder,
                  },
                };
                // sendOrder(obj);
              }
            });
          }
        });
      SyncData(fbOrderData, "upsertFbOrder");
    }
    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    if (updatedCart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.lineLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        let productSelected = updatedCart.items.filter((cartItem) => cartItem.productId === item.productId);
        if (pricingRule?.type === "FD") {
          try {
            const newCart = await CheckoutFlatDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying flat discount:", err);
          }
        } else if (pricingRule?.type === "PD") {
          try {
            const newCart = await CheckoutPercentageDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying percentage discount:", err);
          }
        }
      });
    }

    if (updatedCart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.totalLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        if (pricingRule?.type === "TD") {
          try {
            const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying Total discount:", err);
          }
        }
      });
    }

    const itemSummery = {
      decimalItems: { totalQty: 0, totalAmount: 0 },
      nonDecimalItems: { totalQty: 0, totalAmount: 0 },
      itemsQty: 0,
      items: 0,
    };

    // Group items by tax rate
    const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const groupedItems = allItems.reduce((acc, item) => {
      const key = item.tax?.rate ?? item.taxRate ?? "0";
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    // Calculate tax totals with SGST and CGST
    const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
      const totalTaxAmount = items.reduce((sum, item) => {
        const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
        return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
      }, 0);

      const totalNetTotal = items.reduce((sum, item) => {
        const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
        return sum + parseFloat(netValue);
      }, 0);

      // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
      const totalSgstAmount = items.reduce((sum, item) => {
        const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
      }, 0);

      const totalCgstAmount = items.reduce((sum, item) => {
        const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
      }, 0);

      return {
        taxRate,
        totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
        totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
        totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
        totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
        totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
      };
    });

    updatedCart.items = updatedCart.items.map((item, i) => {
      const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;

      // Update aggregated totals
      updatedTotalPrice = parseFloat(parseFloat(updatedTotalPrice + nettotalFixed)?.toFixed(precision));
      updatedTotalItemsQty = parseFloat(parseFloat(updatedTotalItemsQty + item.weight)?.toFixed(precision));
      updatedTotalTax = parseFloat(parseFloat(updatedTotalTax + taxAmountFixed)?.toFixed(precision));
      updatedTotalDiscounts = parseFloat(parseFloat(updatedTotalDiscounts + discountFixed)?.toFixed(precision));

      // Update individual item properties
      item.discount = discountFixed;
      item.key = i;
      item.nettotal = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));

      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => {
          const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemSummery.itemsQty += child.weight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += child.weight;
          itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
        });
      } else {
        const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemSummery.itemsQty += item.weight;
        itemSummery.items += 1;
        itemSummery[summaryKey].totalQty += item.weight;
        itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      }

      // if (!item.isGiftCard) {
      //   let lineTax = item.listPrice * (1 + item.taxRate / 100);
      //   let unitPrice = item.nettotal / item.weight - (item.nettotal / item.weight / 100) * item.taxRate;
      //   if (!isFinite(unitPrice)) unitPrice = 0;

      //   let unitTax = item.taxAmount / item.weight;
      //   item.sunitprice = item.realPrice;
      //   const gross_list = taxIncludeFlag === "Y" ? item.listPrice : item.listPrice * (1 + item.taxRate / 100);
      //   const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
      //   const netList = taxIncludeFlag === "Y" ? (item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision) : item.listPrice;
      //   item.listPrice = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(lineTax?.toFixed(precision));
      //   item.linetax = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
      //   item.linenet = Math.abs(nettotalFixed) > 0 ? parseFloat((item.nettotal - item.taxAmount)?.toFixed(precision)) : 0;
      //   item.linegross = Math.abs(nettotalFixed) > 0 ? nettotalFixed : 0;
      //   item.netunit = Math.abs(nettotalFixed) > 0 ? unitPrice?.toFixed(precision) : 0;
      //   item.listprice = Math.abs(nettotalFixed) > 0 ? item.listPrice : 0;
      //   item.grossunit = Math.abs(nettotalFixed) > 0 ? parseFloat(grossUnit?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0;
      //   item.grossstd = Math.abs(nettotalFixed) > 0 ? item.sunitprice : 0;
      //   item.grosslist = Math.abs(nettotalFixed) > 0 ? gross_list : 0;
      //   item.netList = Math.abs(nettotalFixed) > 0 ? netList : 0;
      //   item.unitPrice = Math.abs(nettotalFixed) > 0 ? unitPrice : 0;
      //   item.taxAmount = Math.abs(nettotalFixed) > 0 ? taxAmountFixed : 0;
      // }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
    const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      total: parseFloat(updatedTotalPrice.toFixed(precision)),
      tax: updatedTotalTax,
      subTotal: parseFloat(parseFloat(updatedTotalPrice - updatedTotalTax)?.toFixed(precision)),
      totalDiscountFlag: !discountFlag || Object.keys(selectedProductInCart).length === 0 ? false : true,
      // itemSummery,
      groupedItemsByTaxRate,
      totalStd: updatedTotalStd,
    };
    if (discountFlag) {
      setCart(finalCartObj);
      localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
    }
    if (searchInputRef?.current) {
      searchInputRef?.current?.focus();
    }
    return finalCartObj;
  };

  const clearSelectedProductInCart = () => {
    setSelectedProductInCart({});
    // setTimeout(()=>{
    setSelectedRowKeys([]);
    // },100)
  };

  function parseDateTime(dateTimeString) {
    return new Date(dateTimeString.replace(" ", "T") + "Z");
  }

  function calculateDuration(startTime, endTime) {
    const durationMilliseconds = endTime - startTime;
    const totalSeconds = Math.floor(durationMilliseconds / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { hours, minutes, seconds };
  }

  function formatDuration(duration) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(duration.hours).padStart(2, "0");
    const minutes = String(duration.minutes).padStart(2, "0");
    const seconds = String(duration.seconds).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const posLogActivity = (record, activity) => {
    const timeMark = timeStamp();
    const currentDate = new Date().toLocaleDateString("zh-Hans-CN");
    let products = "";
    let formattedDuration = "";

    // Calculate duration if orderTimeDetails are present
    if (record.orderTimeDetails) {
      const { orderStartTime, orderEndTime } = record.orderTimeDetails;
      const startTime = parseDateTime(orderStartTime);
      const endTime = parseDateTime(orderEndTime);
      const duration = calculateDuration(startTime, endTime);
      formattedDuration = formatDuration(duration);
    }
    const trxId = uuidv4().replace(/-/g, "").toUpperCase();

    if (_.isArray(record)) {
      record.forEach((item) => {
        products += `SKU: ${item.value}, Qty: ${item.weight}, Unit Price: ${item.salePrice}, `;
      });
    } else {
      products = `SKU: ${record.value}, Qty: ${record.weight}, Unit Price: ${record.salePrice}, `;
    }

    db.logInformation.add({
      type: activity,
      action: "LOG",
      description: activity === "DLN" || activity === "DOR" || activity === "RQT" || activity === "SLR" ? products : activity === "SRD" || activity === "ACT" ? record : "",
      date: currentDate,
      time: timeMark,
      orderNo: `${cart.documentno}`,
      remarks: "",
      transactionId: `${trxId}`,
      status: "SCS",
      duration: formattedDuration ? `"${formattedDuration}"` : null,
    });
  };

  // Paytm QR Code Starts //

  const [paytmQrCodeModalOpens, setPaytmQrCodeModalOpens] = useState(false);
  const [qrCodeResponse, setQrCodeResponse] = useState({});

  const handleVerifyPayment = () => {
    let hostUrl = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
    let verifyPaytmUrl = `${hostUrl}paytm/verifyPayment`;
    const getPaymentSuccessValues = {
      midId: "Excelo34085435005810",
      orderId: `${cart.sOrderID}`,
      merchantKey: "qQUxrwRx@qE6zTxt",
      payUrlForVerify: "https://securegw-stage.paytm.in/v3/order/status",
      clientId: "C11",
      version: "v1",
    };
    Axios({
      url: verifyPaytmUrl,
      method: "POST",
      data: getPaymentSuccessValues,
      headers: {
        "Content-Type": "application/json",
        Authorization: `${authHeaders.access_token}`,
      },
    }).then((response) => {
      if (response.data.body.resultInfo.resultStatus === "TXN_SUCCESS") {
        setPaytmQrCodeModalOpens(false);
        processPayment(selectedPaymentMethod, amount);
      }
    });
  };

  // Paytm QR Code Ends //
  const [customerFlag, setCustomerFlag] = useState(true);

  const removeCutomer = async () => {
    if (cart.payments.length > 0) {
      message.warning(`${messages.errors.cart.delete_payment_first_customer}`);
      return;
    }
    setCustomerFlag(true);
    let latestData = removeAllDiscounts(false, true);
    let cartObj = {
      ...latestData,
      customer: defaultCustomer,
    };
    let updatedCart = cartObj;
    updatedCart = await handleDeleteLoyaltyPayment(updatedCart, latestData.customer);
    if (cartObj.items.length > 0) {
      await Promise.all(
        cartObj.items.map(async (ele) => {
          let addToCart = ele;
          let matchedPriceIndex = [];
          if (defaultCustomer?.cwrCustomerId !== updatedCart?.customer?.cwrCustomerId && addToCart?.priceList?.length > 0) {
            const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
            let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
            // matchedPriceIndex = addToCart?.priceList.filter((i) => i.sPricelistId === updatedCart.customer.sPriceListId);
            // if (matchedPriceIndex.length > 0) {
            //   addToCart.price = matchedPriceIndex[0].pricestd;
            //   addToCart.salePrice = matchedPriceIndex[0].pricestd;
            //   addToCart.realPrice = matchedPriceIndex[0].pricestd;
            //   addToCart.sunitprice = matchedPriceIndex[0].pricestd;
            // } else if (!updatedCart.customer.sPriceListId) {
            //   addToCart.price = ele?.originalPrice || ele?.sunitprice;
            //   addToCart.salePrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
            //   addToCart.realPrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
            //   addToCart.sunitprice = ele?.originalPrice || ele?.sunitprice;
            // }
            const selectedPrice = getApplicablePrice({
              priceList: addToCart.priceList,
              selectedUomId: addToCart.uomData[0]?.csUomId,
              sPriceListId: updatedCart.customer.sPriceListId,
            });

            if (selectedPrice) {
              addToCart.price = selectedPrice.pricestd;
              addToCart.salePrice = selectedPrice.pricestd;
              addToCart.realPrice = selectedPrice.pricestd;
              addToCart.sunitprice = selectedPrice.pricestd;
            } else if (!updatedCart.customer.sPriceListId) {
              addToCart.price = ele?.originalPrice || ele?.sunitprice;
              addToCart.salePrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
              addToCart.realPrice = ele?.children?.length > 0 ? ele.realPrice : ele?.originalPrice || ele?.sunitprice;
              addToCart.sunitprice = ele?.originalPrice || ele?.sunitprice;
            }
            const addOnsPriceSum = _.sumBy(addToCart?.selectedAddons, "price");
            const mrp = (parseFloat(addToCart.salePrice) + addOnsPriceSum * addToCart.weight) * parseFloat(addToCart.weight);
            // const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + (addToCart.taxRate) / 100) : mrp * ((addToCart.taxRate ) / 100);
            let tax;
            if (Array.isArray(ele.children) && ele.children.length > 0) {
              tax = _.sumBy(ele.children, (child) => child.taxAmount);
            } else {
              tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addToCart.taxRate / 100) : mrp * (addToCart.taxRate / 100);
            }
            addToCart.taxAmount = tax;
            addToCart.nettotal =
              taxIncludeFlag === "Y"
                ? parseFloat(parseFloat(mrp - parseFloat(addToCart.discount ? addToCart.discount : 0))?.toFixed(precision))
                : parseFloat(parseFloat(mrp - parseFloat(addToCart.discount ? addToCart.discount : 0))?.toFixed(precision)) + tax;
          }
          addToCart.nettotal = parseFloat(addToCart.nettotal.toFixed(precision));
          updatedCart = await pricingRuleController(addToCart, cartObj, cartObj, setCart, cartObj, orderType);
          return updatedCart;
        })
      );
    } else {
      let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
        ? JSON.parse(localStorage.getItem("orderTimeDetails"))
        : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
      orderTimeDetails = {
        ...orderTimeDetails,
        orderStartTime: "", // Update orderStartTime to current time
      };
      localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
    }

    if (cartObj.totalDiscountFlag) {
      await openPaymentModalByCustomer(updatedCart);
    }

    if (updatedCart?.couponInput?.length > 0) {
      let addToCart = cartObj.items[0];
      await Promise.all(
        updatedCart.couponInput.map(async (coupon) => {
          const matchingPricingRules = await db.pricingRules.where("mPricingrulesId").equalsIgnoreCase(coupon.mPricingruleId).toArray();
          if (matchingPricingRules[0].type !== "TD" && matchingPricingRules[0].type !== "TDF") {
            updatedCart = await pricingRuleController(
              addToCart,
              updatedCart,
              cart,
              setCart,
              cartRef,
              orderType,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          } else {
            updatedCart = await processBillDiscounts(
              matchingPricingRules[0],
              updatedCart,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          }
        })
      );
    }

    if (updatedCart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.lineLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        let productSelected = updatedCart.items.filter((cartItem) => cartItem.productId === item.productId);
        if (pricingRule?.type === "FD") {
          try {
            const newCart = await CheckoutFlatDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying flat discount:", err);
          }
        } else if (pricingRule?.type === "PD") {
          try {
            const newCart = await CheckoutPercentageDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying percentage discount:", err);
          }
        }
      });
    }

    if (updatedCart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
      updatedCart.manualDiscountData.totalLevelDiscount.map(async (item) => {
        const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
        if (pricingRule?.type === "TD") {
          try {
            const newCart = await CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
            updatedCart = newCart;
          } catch (err) {
            console.error("Error applying Total discount:", err);
          }
        }
      });
    }

    const itemSummery = {
      decimalItems: { totalQty: 0, totalAmount: 0 },
      nonDecimalItems: { totalQty: 0, totalAmount: 0 },
      itemsQty: 0,
      items: 0,
    };

    // Group items by tax rate
    const allItems = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));

    const groupedItems = allItems.reduce((acc, item) => {
      const key = item.tax?.rate ?? item.taxRate ?? "0";
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    // Calculate tax totals with SGST and CGST
    const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
      const totalTaxAmount = items.reduce((sum, item) => {
        const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
        return sum + parseFloat(parseFloat(taxValue)?.toFixed(precision));
      }, 0);

      const totalNetTotal = items.reduce((sum, item) => {
        const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
        return sum + parseFloat(netValue);
      }, 0);

      // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
      const totalSgstAmount = items.reduce((sum, item) => {
        const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(sgstValue)?.toFixed(precision));
      }, 0);

      const totalCgstAmount = items.reduce((sum, item) => {
        const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || item.taxAmount || 0) / 2;
        return sum + parseFloat(parseFloat(cgstValue)?.toFixed(precision));
      }, 0);

      return {
        taxRate,
        totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount)?.toFixed(precision)),
        totalLinetax: parseFloat(parseFloat(totalTaxAmount)?.toFixed(precision)),
        totalLinegross: parseFloat(parseFloat(totalNetTotal)?.toFixed(precision)),
        totalSgst: parseFloat(parseFloat(totalSgstAmount)?.toFixed(precision)),
        totalCgst: parseFloat(parseFloat(totalCgstAmount)?.toFixed(precision)),
      };
    });

    let updatedTotalTax = 0;
    let updatedTotalPrice = 0;
    let updatedTotalItemsQty = 0;
    let updatedTotalDiscounts = 0;

    updatedCart.items = updatedCart.items.map((item, i) => {
      const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
      const nettotalFixed = parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      const taxAmountFixed = parseFloat(parseFloat(item.taxAmount)?.toFixed(precision));
      const discountFixed = item.discount ? parseFloat(parseFloat(item.discount)?.toFixed(precision)) : 0;

      // Update totals
      updatedTotalPrice += nettotalFixed;
      updatedTotalItemsQty += item.weight;
      updatedTotalTax += taxAmountFixed;
      updatedTotalDiscounts += discountFixed;

      item.discount = discountFixed;
      item.key = i;

      if (!item.isGiftCard) {
        const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;

        const lineTax = item.listPrice * (1 + item.taxRate / 100);
        const stdTax = item.sunitprice * (1 + item.taxRate / 100);
        const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
        const netList =
          taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100))?.toFixed(precision)) : item.listPrice;
        const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax)?.toFixed(precision));
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax)?.toFixed(precision));
        // const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : item.sunitprice + taxAmountFixed;

        Object.assign(item, {
          linetax: nettotalFixed ? taxAmountFixed : 0,
          linenet: nettotalFixed ? parseFloat(parseFloat(item.nettotal - item.taxAmount)?.toFixed(precision)) : 0,
          linegross: nettotalFixed || 0,
          linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight)?.toFixed(precision)) : 0,
          netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          listprice: nettotalFixed ? item.listPrice : 0,
          grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
          grossstd: nettotalFixed ? grossStd : 0,
          grosslist: nettotalFixed ? gross_list : 0,
          netList: nettotalFixed ? netList : 0,
          unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice)?.toFixed(precision)) : 0,
          taxAmount: nettotalFixed ? taxAmountFixed : 0,
        });
      }

      // Update summary
      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => {
          const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

          itemSummery.itemsQty += child.weight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += child.weight;
          itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal)?.toFixed(precision));
        });
      } else {
        const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
        const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

        itemSummery.itemsQty += item.weight;
        itemSummery.items += 1;
        itemSummery[summaryKey].totalQty += item.weight;
        itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal)?.toFixed(precision));
      }
      return item;
    });

    const sumLineTotals = (lines) => {
      let totalLineGross = 0;
      let totalLineTax = 0;

      lines.forEach((line) => {
        totalLineGross += line.nettotal;
        totalLineTax += line.taxAmount;
      });

      return { totalLineGross, totalLineTax };
    };
    // Compare and Adjust Order Totals
    const adjustOrderTotals = (order, lines) => {
      const { totalLineGross, totalLineTax } = sumLineTotals(lines);
      let adjustedOrderGross = order.total;
      let adjustedOrderTax = order.tax;

      const grossDifference = totalLineGross - adjustedOrderGross;
      const taxDifference = totalLineTax - adjustedOrderTax;

      if (Math.abs(grossDifference) > 0.01) {
        adjustedOrderGross += grossDifference;
      }

      if (Math.abs(taxDifference) > 0.01) {
        adjustedOrderTax += taxDifference;
      }

      return {
        ...order,
        total: adjustedOrderGross,
        tax: adjustedOrderTax,
      };
    };
    updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
    const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
    const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
    let finalCartObj = {
      ...updatedCart,
      items: [...updatedCart.items],
      discount: updatedTotalDiscounts,
      totalQty: updatedTotalItemsQty,
      total: parseFloat(updatedTotalPrice.toFixed(precision)),
      tax: updatedTotalTax,
      totalStd: updatedTotalStd,
    };
    delete finalCartObj.isRetrived;
    delete finalCartObj.parked;
    localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
    setCart({ ...finalCartObj });
    setShowPaymentMethods(false);
    upsertPOSLog(cart, "RCT");
  };

  const handleLoyaltyPayment = async (payment, cartData) => {
    let setAuthTokens;
    const authHeaders = await getOAuthHeaders();
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const serverUrl = process.env.REACT_APP_serverUrl;
    const tillData = JSON.parse(localStorage.getItem("tillData"));
    let value = parseFloat(parseFloat(payment.amount / cart.customer.redeemptionValue)?.toFixed(precision));
    if (cartData.customer.loyaltyLevel.cwrLoyaltyLevelId) {
      await upsertLoyaltyTransaction(tillData, value * -1, cartData.customer.cwrCustomerId, cartData.referenceId);

      cartData.customer.retlLoyaltyBalance = (cartData?.customer?.retlLoyaltyBalance || 0) + parseFloat(value);
    }
  };

  const handleDeleteLoyaltyPayment = async (updatedCart, customer) => {
    let newCart = JSON.parse(JSON.stringify(updatedCart));
    newCart.customer = customer;
    const matchedPayment = updatedCart.payments.find((pay) => pay.name.toLowerCase() === "loyalty");
    if (!matchedPayment) return updatedCart;
    updatedCart.payments = updatedCart.payments.filter((pay) => pay.name.toLowerCase() !== "loyalty");
    updatedCart.paid = updatedCart.payments.reduce((sum, pay) => sum + parseFloat(pay.amount), 0);
    await handleLoyaltyPayment(matchedPayment, newCart);
    updatedCart.balance = parseFloat(parseFloat(updatedCart.total - updatedCart.paid)?.toFixed(precision));
    return updatedCart;
  };

  // Bill Management //

  const handleManagement = () => {
    // history.push("/bill-management");
    setManagementScreenShow(true);
  };

  const [managementScreenShow, setManagementScreenShow] = useState(false);
  const [orderTypeSelection, setOrderTypeSelection] = useState("Dine In");

  const changeCustomerId = (obj) => {
    let cartDetails = JSON.parse(localStorage.getItem("cartObj"));
    cartDetails.customer.cwrCustomerId = obj.customer.b2cCustomerId;
    localStorage.setItem("cartObj", JSON.stringify(cartDetails));
  };

  const componentProps = {
    isParkedBill,
    setIsparkedBill,
    integratedPaymentStatus,
    setIntegratedPaymentStatus,
    couponInputRef,
    totalBillCouponData,
    setTotalBillCouponData,
    checkExternalCoupon,
    selectedExternalCouponType,
    setSelectedExternalCouponType,
    selectedCoupon,
    setSelectedCoupon,
    processCouponApplication,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
    showCardPaymnteModal,
    setShowCardPaymnteModal,
    setCustomerLoading,
    customerLoading,
    selectedItemsModalOpen,
    setSelectedItemsModalOpen,
    syncLoad,
    setSyncLoad,
    processTotalManualDiscount,
    cashIn,
    setCashIn,
    cashOut,
    setCashOut,
    pettyCashIn,
    setPettyCashIn,
    pettyCashOut,
    setPettyCashOut,
    clearReturnCartData,
    setCashOut,
    showConfirm,
    showCompleteSaleStock,
    setShowCompleteSaleStock,
    completeSaleStockData,
    setCompleteSaleStockData,
    setTempCart,
    tempCart,
    metaDataRef,
    discountInforApplication,
    discountAdditionalInfoForm,
    discountAdditionalInfo,
    setDiscountAdditionalInfo,
    totalBillDiscountData,
    setTotalBillDiscountData,
    deleteReceipt,
    qtyInputRef,
    searchInputRef,
    activeInput,
    setActiveInput,
    options,
    setOptions,
    couponApprovals,
    setCouponApprovals,
    showCouponApproval,
    setShowCouponApproval,
    couponInfo,
    additionalInfoForm,
    selectedUser,
    setSelectedUser,
    showAdditionalInfo,
    setShowAdditionalInfo,
    additionalInfo,
    setAdditionalInfo,
    showCustomMix,
    setShowCustomMix,
    hasShownCustomerModalRef,
    orderType,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    currenciesData,
    setCurrenciesData,
    groupQty,
    setGroupQty,
    selectedCustomMix,
    setSelectedCustomMix,
    existingGroupItems,
    setExistingGroupItems,
    customMixItems,
    setCustomMixItems,
    firstInputValue,
    setFirstInputValue,
    realPrice,
    setRealPrice,
    splitCarts,
    setSplitCarts,
    tableCards,
    setTableCards,
    keyValue,
    setKeyValue,
    changeCustomerId,
    showProducts,
    setShowProducts,
    handleSelectedSaleTypeForProducts,
    checkIsManualWeight,
    parkBill,
    openPaymentModal,
    addProduct,
    cart,
    setCart,
    cartObj,
    setOrderObj,
    clearProductSearchResults,
    closeProductPanel,
    confirmDiscardCart,
    decreaseProductQty,
    deleteCart,
    deleteProduct,
    displayClock,
    getMoreProducts,
    getSearchedProducts,
    setIsProductsVisible,
    isProductsVisible,
    getSearchedItem,
    increaseProductQty,
    isProductsFilter,
    isQtyUpdate,
    isSearchProducts,
    loader,
    loading,
    setLoading,
    onBarcodeInput,
    openDisplayParkedBillModal,
    orderType,
    parkedList,
    setAllProductCategories,
    allProductCategories,
    handleBrandCheckboxChange,
    selectCategotyList,
    setSelectCategotyList,
    handleCategoryCheckboxChange,
    setSelectedProductBrand,
    selectedProductBrand,
    productSearchInput,
    filtersFlag,
    setFiltersFlag,
    // productSearchInputRef,
    productsCopy,
    selectProductCategory,
    selectProductInCart,
    selectedProductQty,
    selectProduct,
    selectSalseProduct,
    selectedProductInCart,
    selectedRowKeys,
    setSelectedRowKeys,
    selectedKeys,
    searchHistoryInput,
    setSearchhistoryInput,
    setDisplayCustomerSearch,
    displayUAECustomerSearch,
    setDisplayUAECustomerSearch,
    displayUAECustomer,
    setDisplayUAECustomer,
    setDisplayOrderType,
    setIsProductsFilter,
    setIsQtyUpdate,
    setIsSearchProducts,
    setProductSearchInput,
    setParkedBillSearchInput,
    showOrderHistory,
    tillData,
    displayCustomerSearch,
    closeCustomerSearch,
    setCustomerSearchType,
    customerSearchType,
    handleCustomerSearch,
    customerSearchInput,
    setCustomerSearchResults,
    setCloseCustomerFlag,
    setCustomerSearchInput,
    customerSearchResults,
    selectCustomer,
    showEditOldCustomerFields,
    showAddNewCustomerFields,
    showAddNewUAECustomerFields,
    setDisplayAddNewCustomer,
    displayAddNewCustomer,
    form,
    UAECustomerForm,
    addNewCustomer,
    setDisplayEditOldCustomer,
    displayEditOldCustomer,
    editFlag,
    setEditFlag,
    editOldCustomer,
    displayOrderHistory,
    setDisplayOrderHistory,
    changeOrderHistorySearchType,
    searchOrderHistory,
    setOrderHistoryInput,
    orderHistoryDetails,
    showOrderHistoryLine,
    selectedOrderHistoryLine,
    isPrintModeXML,
    syncOrders,
    displayParkedBillModal,
    closeParkedBillModal,
    handleParkedBillSearchInput,
    searchParkedBill,
    parkedBillSearchInput,
    salesHistoryCustomerSearchInput,
    salesHistoryDocumentNoSearchInput,
    setSalesHistoryCustomerSearchInput,
    setSalesHistoryDocumentNoSearchInput,
    filterdParkedList,
    parkedList,
    setFilterdParkedList,
    discardParkedBill,
    selectParkedBill,
    selectLayAwayOrder,
    paymentModal,
    tillDataPaymentMethods,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    requestPayment,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    setCouponModalVisible,
    closePaymentModal,
    paymentModalLoyalityMessages,
    amount,
    onChangeAmount,
    processOrder,
    handleAmount,
    handleCashPayment,
    overPayedAmount,
    setOverPayedAmount,
    handleTotalQty,
    handleRealPrice,
    enterTotalQty,
    enterRealPrice,
    showPaymentMethods,
    setShowPaymentMethods,
    onChangeTotalQuantity,
    displaySetOrderType,
    posSaleTypes,
    changeOrderType,
    displayOfferProductSelectiton,
    offerProductsList,
    selectOfferProduct,
    displayBatchSelection,
    setDisplayBatchSelection,
    batchSetAvailable,
    selectProductToCart,
    displayManualQtyWeightInput,
    setDisplayManualQtyWeightInput,
    setDefaultImage,
    currentWeightSelectedProduct,
    productWeightModalInput,
    onProductModalChangeWeight,
    addManualWeightToProduct,
    couponModalVisible,
    closeCouponModal,
    checkCoupon,
    couponInput,
    setCouponInput,
    handleCouponInput,
    loyalityOtpModalVisible,
    setLoyalityOtpModalVisible,
    processOtpInput,
    loyaltyInputValue,
    setLoyaltyInputValue,
    handleLoyalityInput,
    checkLoyality,
    loyaltyPaymentOtp,
    setLoyaltyPaymentOtp,
    currencyType,
    setCurrencyType,
    setDisplayClock,
    pickProduct,
    addDefinedProduct,
    handleWeightManual,
    selectedProductCategory,
    filterDrawer,
    setFilterDrawer,
    // OMS Order MOdal and Side menu drawer//,
    openSideMenu,
    onClose,
    displayOMSOrderItemsModal,
    omsOrderStatus,
    selectedOMSOrderStatus,
    setSelectedOrder,
    handleOMSOrderStatusSelection,
    order,
    handleOrderSearchInput,
    searchOrders,
    selectedOrder,
    handleOrderCard,
    handleOmsOrders,
    setDisplayOMSOrderItemsModal,
    handleOMSStatusButton,
    omsOrderTotalPrice,
    sideMenuDrawervisible,
    setDisplayOfferProductSelection,
    // Sales Representative Modal //
    salesRepModalOpen,
    setSalesRepModalOpen,
    handleSalesRepresentive,
    salesRepresent,
    setSalesRepresent,
    salesRepresentSearchInput,
    setSalesRepresentSearchInput,
    handleSalesRepresentSearchInput,
    salesReprestiveList,
    filteredSalesRepresentList,
    setFilteredSalesRepresentList,
    prevProductsListRef,
    prevHistoryRef,
    manualDiscountModalVisible,
    setManualDiscountModalVisible,
    manualDiscountInput,
    setManualDiscountInput,
    manualDiscountTypes,
    setManualDiscountTypes,
    handleManualDiscountKeyPress,
    applyManualDiscount,
    manualDiscountForm,
    selectedManualDiscountType,
    setSelectedManualDiscountType,
    enableManualDiscountInput,
    setEnableManualDiscountInput,
    removeAllDiscounts,
    clearSelectedProductInCart,
    setProductWeightModalInput,
    productListCardRef,
    paymentModalByCustomerState,
    posLogActivity,
    upsertPOSLog,
    // Paytm QR Code //
    paytmQrCodeModalOpens,
    setPaytmQrCodeModalOpens,
    qrCodeResponse,
    setQrCodeResponse,
    handleVerifyPayment,
    removeCutomer,
    handleDeleteLoyaltyPayment,
    handleLoyaltyPayment,
    posConfig,
    displayReturnOrderSearch,
    setDisplayReturnOrderSearch,
    handleSalesReturnFromSideMenu,
    // Bill Management //
    handleManagement,
    managementScreenShow,
    setManagementScreenShow,
    orderTypeSelection,
    setOrderTypeSelection,
    // Cash Management
    setAddCashFlag,
    addCashFlag,
    paymentModal,
    tillDataPaymentMethods,
    setSelectedPaymentMethod,
    setCouponModalVisible,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    setSelectedKeys,

    // payment
    setQtyNumberFlag,
    setAmount,
    setNumb,
    amount,
    onChangeAmount,
    processOrder,
    paymentModalLoyalityMessages,
    paymentModalInputRef,
    quantityInputRef,
    // Cash Management
    setCashAddInFlag,
    cashAddInFlag,
    handleCahInOut,
    cashManagementForm,
    cashIn,
    onChangeCheckbox,
    setSelectedProductInCart,
    // kiosk Screen
    kioskUI,
    setKioskUI,
    kioskLogin,
    layoutType,
    setLayoutType,
    kioskFilteredProducts,
    // gift card
    giftCardFlag,
    setGiftCardFlag,
    isGiftCardFlag,
    setIsGiftCardFlag,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    giftCardItems,
    CardPaymentForm,
    setGiftCardItems,
    setAddToBagProducts,
    setAddToBagFlag,
    addToBagFlag,
    addToBagProducts,
    giftCardType,
    setGiftCardType,
    selectGiftCardItem,
    setSelectGiftCardItem,
    validateGiftCard,
    setValidateGiftCard,
    validateGiftCardForm,
    giftCardBalance,
    setGiftCardBalance,
    handleGiftCardDetails,
    redeemGiftCard,
    giftCardData,
    setGiftCardData,
    handleGiftCard,
    giftCardForm,
    // keybord
    setKeyboardType,
    keyboardType,
    layout,
    setLayout,
    inputName,
    setInputName,
    keyboardInputFields,
    setKeyboardInputFields,
    keyboardParkbill,
    keyboardRef,
    keyboardProduct,
    handleKeyboardInput,
    handleKeyPress,
    orderHistorySearchInputRef,
    orderHistoryInput,
    setLoader,
    openPaymentModalByCustomer,
    paymentProcessFlag,
    setPaymentProcessFlag,
    selectedEditOldCustomer,
    setIsInputFocused,
    isInputFocused,
    inputFocused,
    setInputFocused,
    handleSelectProduct,
    getCategoryProducts,
    setSalesHistoryType,
    salesHistoryType,
    setStartRowData,
    setFilterdDate,
    startRowData,
    setOrderHistoryDetails,
    setOrdersCopy,
    ordersCopy,
    documentSequence,
    setDocumnetSequence,
    customerFlag,
    setCustomerFlag,
    notesValue,
    setNotesValue,
    selectedProductForNotes,
    setSelectedProductForNotes,
    productsData,
    orderDelay,
    setOrderDelay,
    setProductsData,
    stockList,
    setStockList,
    // restaurantProductCategory,
    removeCoupon,
    // product add on
    setDisplayAddOnSelection,
    displayAddOnSelection,
    handleAddOnValue,
    handleQty,
    handleAdd,
    addOnsList,
    handleAddOnModalClose,
    selectedAddons,
    selectedProduct,
    setSelectedProduct,
    isUpdatingAddon,
    setIsUpdatingAddon,
    addDefinedProductWithAddons,
    handleAddOnModal,
    dynamicForm,
    setDynamicForm,
    dynamicModalForm,
    submitCustomAttributs,
    isSubmitting,
    setIsSubmitting,
    showSaleType,
    setShowSaleType,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    selectedSaleType,
    setSelectedSaleType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    openSalesRep,
    setOpenSalesRep,
    verifyStock,
    isStockModal,
    setIsStockModal,
    showPayments,
    setShowPayments,
    setStartIndex,
    startIndex,
    getFilteredPaymentMethods,
    handleCartTotalClick,
    isShowingAll,
    setIsShowingAll,
    filteredPaymentMethods,
    initialShowPayments,
    tempCart,
    setTempCart,
    callGetWeightAPI,
    open,
    setOpen,
    productSearchInputRef,
    layoutName,
    setLayoutName,
    giftCardRef,
    searchTerm,
    setSearchTerm,
    salesRepRef,
    salesRepValue,
    setSalesRepValue,
    customerSearchInputRef,
    processBillDiscounts,
    currentInput,
    setCurrentInput,
    inputValues,
    setInputValues,
    refs,
    currenciesData,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    documentTypes,
    keyboard,
    getSalesHistoryData,
    setSelectedManualDiscountTypeValue,
    saleTypeProducts,
    setSaleTypeProducts,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    cardPaymnetError,
    setCardPaymnetError,
    isCardPaymentLoading,
    setIsCardPaymentLoading,
    modifyProductList,
    calendarVisible,
    setCalendarVisible,
    selectedDate,
    setSelectedDate,
    setProductStock,
    saleType,
    setSaleType,
    showCustomerWallet,
    setShowCustomerWallet,
    customersData,
    setCustomersData,
    selectedCustomer,
    setSelectedCustomer,
    handleDeletePayment,
    fetchWalletData,
    setTillLink,
    tillLink,
    isWalletFlag,
    setIswalletFlag,
    walletFunc,
    getFilteredPaymentMethods,
    notesValue,
    setNotesValue,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    setPopoverVisible,
    isPopoverVisible,
    dateRef,
    mapParkedList,
    callCenterVisible,
    setCallCenterVisible,
    isCallCenterFlow,
    setIsCallCenterFlow,
    history,
    showCallCenterPage,
    setShowCallCenterPage,
    holdQueue,
    setHoldQueue,
    redeemNumberRef,
    loyaltyInputRef,
    isOnline,
    setIsOnline,
    setSelectedAddons,
  };

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };

  return (
    <div>
      <RenderComponent {...componentProps} />
      <CoreModals {...componentProps} />
      <ReturnBill {...componentProps} />
      <PointOfSuperMarketModals {...componentProps} />

      <Modal
        visible={productStock}
        footer={null}
        closable={false}
        centered
        zIndex={2000}
        style={{
          textAlign: "center",
          width: "150px",
          height: "70vh",
        }}
        bodyStyle={{
          padding: 0,
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 0,
            fontSize: "1vw",
          }}
        >
          <img src={NotFoundImg} alt="Stock Unavailable" style={{ width: "120px", height: "100px", marginBottom: "5px", marginTop: "10px" }} />
          <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Stock is not available</p>
          <hr style={{ width: "70%", color: "rgba(146,144,152,0.5)" }} />
          <p
            style={{
              color: "#0F0718",
              fontWeight: 400,
              fontSize: "1.25em",
              padding: "15px 15px 0 15px",
            }}
          >
            The item is not available in stock.
          </p>
        </div>
      </Modal>

      <Drawer
        visible={showCompleteSaleStock}
        onClose={() => {
          (setShowCompleteSaleStock(false), setCompleteSaleStockData([]));
        }}
        placement="bottom"
        closable={false}
        height="80vh"
        mask={true}
        maskStyle={{ background: "#000000a6" }}
        maskClosable="false"
        style={{
          textAlign: "center",
        }}
        bodyStyle={{
          padding: "5px 30px", // Increased padding on left and right
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 0,
            fontSize: "1vw",
          }}
        >
          <img src={NotFoundImg} alt="Stock Unavailable" style={{ width: "60px", height: "50px", marginTop: "5px" }} />
          <p style={{ margin: "2px 0", fontSize: "1.8em", fontWeight: "600", color: "#0F0718" }}>Stock is not available</p>
          <p
            style={{
              color: "#6c757d",
              fontWeight: 400,
              fontSize: "1.1em",
            }}
          >
            {`The following ${
              completeSaleStockData?.filter((item) => item.availabilityStatus !== "Yes" && item.availableQty < item.orderQty).length
            } items are not available in sufficient stock`}
          </p>
        </div>
        <Table
          className="sm-stock-check-table"
          pagination={false}
          style={{ height: "50vh" }} // Increased table height to utilize more space
          scroll={{ y: "43vh" }} // Adjusted scroll height to match increased table size
          columns={[
            {
              title: "Item Name",
              dataIndex: "name",
              key: "name",
              width: "30%",
              render: (text, record) => (
                <div>
                  <div style={{ fontWeight: 500 }}>{text}</div>
                  <div style={{ fontSize: "12px", color: "#888" }}>{record.productId}</div>
                </div>
              ),
            },
            { title: "Required", dataIndex: "orderQty", key: "orderQty", width: "25%" },
            { title: "Available", dataIndex: "availableQty", key: "availableQty", width: "25%" },
            {
              title: "Shortfall",
              key: "shortfall",
              width: "25%",
              render: (_, record) => {
                const diff = record.orderQty - record.availableQty;
                return (-Math.abs(diff)).toFixed(precision);
              },
            },
          ]}
          dataSource={completeSaleStockData.filter((item) => item.availabilityStatus !== "Yes" && item.availableQty < item.orderQty)}
          rowKey="productId"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "2vh",
            paddingRight: "1px",
          }}
        >
          <button
            style={{
              width: "25%",
              padding: "6px 12px",
              backgroundColor: "#2F3856",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              (setShowCompleteSaleStock(false), setCompleteSaleStockData([]));
            }}
          >
            OK
          </button>
        </div>
      </Drawer>
    </div>
  );
};
// PointOfSale Component End

export default PointOfsaleCore;
